/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `Byte` scalar type represents byte value as a Buffer */
  Byte: any;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  /** GraphQL Scalar representing the Prisma.Decimal type, based on Decimal.js library. */
  Decimal: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};

export type Achievement = {
  __typename?: 'Achievement';
  achievedText?: Maybe<Scalars['String']>;
  achievementState: Achievement_State;
  achievementType: Achievement_Type_Enum;
  actionName?: Maybe<Scalars['String']>;
  actionRedirectLink?: Maybe<Scalars['String']>;
  actionType?: Maybe<Achievement_Action_Type_Enum>;
  alternativeText: Scalars['String'];
  currentStep: Scalars['Int'];
  description: Scalars['String'];
  footer?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  image: Scalars['String'];
  isNewAchievement?: Maybe<Scalars['Boolean']>;
  maxSteps: Scalars['Int'];
  name: Scalars['String'];
  progressDescription?: Maybe<Scalars['String']>;
  steps?: Maybe<Array<Step>>;
  streakProgress?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  tagline?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type AchievementTemplateCreateInput = {
  achievedDescription?: InputMaybe<Scalars['String']>;
  achievedFooter?: InputMaybe<Scalars['String']>;
  achievedImage?: InputMaybe<Scalars['String']>;
  actionName?: InputMaybe<Scalars['String']>;
  actionRedirectLink?: InputMaybe<Scalars['String']>;
  actionType?: InputMaybe<Scalars['String']>;
  condition: Scalars['String'];
  conditionDataAggregations: Scalars['String'];
  description: Scalars['String'];
  footer?: InputMaybe<Scalars['String']>;
  group: Scalars['String'];
  groupOrder: Scalars['Float'];
  image: Scalars['String'];
  sequentialStepName?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  tagline?: InputMaybe<Scalars['String']>;
  templateFor: Scalars['String'];
  title: Scalars['String'];
  type: Scalars['String'];
};

export type AchievementTemplateUpdateInput = {
  achievedDescription?: InputMaybe<Scalars['String']>;
  achievedFooter?: InputMaybe<Scalars['String']>;
  achievedImage?: InputMaybe<Scalars['String']>;
  actionName?: InputMaybe<Scalars['String']>;
  actionRedirectLink?: InputMaybe<Scalars['String']>;
  actionType?: InputMaybe<Scalars['String']>;
  condition?: InputMaybe<Scalars['String']>;
  conditionDataAggregations?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  footer?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['String']>;
  groupOrder?: InputMaybe<Scalars['Float']>;
  image?: InputMaybe<Scalars['String']>;
  sequentialStepName?: InputMaybe<Scalars['String']>;
  subtitle?: InputMaybe<Scalars['String']>;
  tagline?: InputMaybe<Scalars['String']>;
  templateFor?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type Achievement_Template = {
  __typename?: 'Achievement_template';
  _count?: Maybe<Achievement_TemplateCount>;
  achievedDescription?: Maybe<Scalars['String']>;
  achievedFooter?: Maybe<Scalars['String']>;
  achievedImage?: Maybe<Scalars['String']>;
  actionName?: Maybe<Scalars['String']>;
  actionRedirectLink?: Maybe<Scalars['String']>;
  actionType?: Maybe<Achievement_Action_Type_Enum>;
  condition: Scalars['String'];
  conditionDataAggregations: Scalars['JSON'];
  description: Scalars['String'];
  footer?: Maybe<Scalars['String']>;
  group: Scalars['String'];
  groupOrder: Scalars['Int'];
  id: Scalars['Int'];
  image: Scalars['String'];
  isActive: Scalars['Boolean'];
  sequentialStepName?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  tagline?: Maybe<Scalars['String']>;
  templateFor: Achievement_Template_For_Enum;
  title: Scalars['String'];
  type: Achievement_Type_Enum;
};

export type Achievement_TemplateCount = {
  __typename?: 'Achievement_templateCount';
  user_achievement: Scalars['Int'];
};


export type Achievement_TemplateCountUser_AchievementArgs = {
  where?: InputMaybe<User_AchievementWhereInput>;
};

export type Achievement_TemplateRelationFilter = {
  is?: InputMaybe<Achievement_TemplateWhereInput>;
  isNot?: InputMaybe<Achievement_TemplateWhereInput>;
};

export type Achievement_TemplateWhereInput = {
  AND?: InputMaybe<Array<Achievement_TemplateWhereInput>>;
  NOT?: InputMaybe<Array<Achievement_TemplateWhereInput>>;
  OR?: InputMaybe<Array<Achievement_TemplateWhereInput>>;
  achievedDescription?: InputMaybe<StringNullableFilter>;
  achievedFooter?: InputMaybe<StringNullableFilter>;
  achievedImage?: InputMaybe<StringNullableFilter>;
  actionName?: InputMaybe<StringNullableFilter>;
  actionRedirectLink?: InputMaybe<StringNullableFilter>;
  actionType?: InputMaybe<Enumachievement_Action_Type_EnumNullableFilter>;
  condition?: InputMaybe<StringFilter>;
  conditionDataAggregations?: InputMaybe<JsonFilter>;
  description?: InputMaybe<StringFilter>;
  footer?: InputMaybe<StringNullableFilter>;
  group?: InputMaybe<StringFilter>;
  groupOrder?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  image?: InputMaybe<StringFilter>;
  isActive?: InputMaybe<BoolFilter>;
  sequentialStepName?: InputMaybe<StringNullableFilter>;
  subtitle?: InputMaybe<StringNullableFilter>;
  tagline?: InputMaybe<StringNullableFilter>;
  templateFor?: InputMaybe<Enumachievement_Template_For_EnumFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<Enumachievement_Type_EnumFilter>;
  user_achievement?: InputMaybe<User_AchievementListRelationFilter>;
};

export type AdHocMeeting = {
  __typename?: 'AdHocMeeting';
  appointmentType: Scalars['String'];
  id: Scalars['Float'];
  zoomUrl?: Maybe<Scalars['String']>;
};

export type AffectedRowsOutput = {
  __typename?: 'AffectedRowsOutput';
  count: Scalars['Int'];
};

export type AggregateImportant_Information = {
  __typename?: 'AggregateImportant_information';
  _avg?: Maybe<Important_InformationAvgAggregate>;
  _count?: Maybe<Important_InformationCountAggregate>;
  _max?: Maybe<Important_InformationMaxAggregate>;
  _min?: Maybe<Important_InformationMinAggregate>;
  _sum?: Maybe<Important_InformationSumAggregate>;
};

export type AppFeedback = {
  allowContact: Scalars['Boolean'];
  attachment?: InputMaybe<AppFeedbackAttachment>;
  notes: Scalars['String'];
};

export type AppFeedbackAttachment = {
  Base64Content: Scalars['String'];
  ContentType: Scalars['String'];
  Filename: Scalars['String'];
};

export type AppointmentCreateGroupInput = {
  appointmentType: Lecture_Appointmenttype_Enum;
  description?: InputMaybe<Scalars['String']>;
  duration: Scalars['Float'];
  meetingLink?: InputMaybe<Scalars['String']>;
  start: Scalars['DateTime'];
  subcourseId: Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
};

export type AppointmentCreateMatchInput = {
  appointmentType: Lecture_Appointmenttype_Enum;
  description?: InputMaybe<Scalars['String']>;
  duration: Scalars['Float'];
  matchId: Scalars['Int'];
  meetingLink?: InputMaybe<Scalars['String']>;
  start: Scalars['DateTime'];
  title?: InputMaybe<Scalars['String']>;
};

export type AppointmentParticipant = {
  __typename?: 'AppointmentParticipant';
  firstname?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  isPupil?: Maybe<Scalars['Boolean']>;
  isScreener?: Maybe<Scalars['Boolean']>;
  isStudent?: Maybe<Scalars['Boolean']>;
  lastname?: Maybe<Scalars['String']>;
  user: UserType;
  userID?: Maybe<Scalars['String']>;
};

export type AppointmentUpdateInput = {
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  id: Scalars['Int'];
  start?: InputMaybe<Scalars['DateTime']>;
  title?: InputMaybe<Scalars['String']>;
};

export type BecomeInstructorInput = {
  message?: InputMaybe<Scalars['String']>;
};

export type BecomeStatePupilInput = {
  gradeAsInt?: InputMaybe<Scalars['Int']>;
  teacherEmail: Scalars['String'];
};

export type BecomeTuteeInput = {
  gradeAsInt: Scalars['Int'];
  languages: Array<Language>;
  learningGermanSince?: InputMaybe<LearningGermanySince>;
  subjects: Array<SubjectInput>;
};

export type BecomeTutorInput = {
  languages?: InputMaybe<Array<Language>>;
  subjects?: InputMaybe<Array<SubjectInput>>;
  supportsInDaZ?: InputMaybe<Scalars['Boolean']>;
};

export type BoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type Bucket = {
  __typename?: 'Bucket';
  from: Scalars['Float'];
  label: Scalars['String'];
  to: Scalars['Float'];
  value: Scalars['Float'];
};

export type BulkRun = {
  __typename?: 'BulkRun';
  apply: Scalars['Boolean'];
  count: Scalars['Float'];
  currentUser?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  finishedAt?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notificationCount: Array<BulkRunNotificationCount>;
  progress: Scalars['Float'];
  startedAt: Scalars['String'];
};

export type BulkRunNotificationCount = {
  __typename?: 'BulkRunNotificationCount';
  count: Scalars['Float'];
  notificationID: Scalars['Float'];
};

export type ByMonth = {
  __typename?: 'ByMonth';
  group?: Maybe<Scalars['String']>;
  month?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

export type BytesNullableFilter = {
  equals?: InputMaybe<Scalars['Byte']>;
  in?: InputMaybe<Array<Scalars['Byte']>>;
  not?: InputMaybe<NestedBytesNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Byte']>>;
};

export type Campaign = {
  __typename?: 'Campaign';
  archived: Scalars['Int'];
  canceled: Scalars['Int'];
  context: Scalars['JSON'];
  contextID: Scalars['String'];
  drafted: Scalars['Int'];
  error: Scalars['Int'];
  notificationID: Scalars['Int'];
  scheduled: Scalars['Int'];
  sent: Scalars['Int'];
};

export type CertificateCreationInput = {
  activities: Scalars['String'];
  endDate: Scalars['DateTime'];
  hoursPerWeek: Scalars['Float'];
  hoursTotal: Scalars['Float'];
  medium: Scalars['String'];
  ongoingLessons: Scalars['Boolean'];
  startDate?: InputMaybe<Scalars['DateTime']>;
  state: Scalars['String'];
  subjects: Scalars['String'];
};

export type CertificateUpdateInput = {
  activities?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  hoursPerWeek?: InputMaybe<Scalars['Float']>;
  hoursTotal?: InputMaybe<Scalars['Float']>;
  medium?: InputMaybe<Scalars['String']>;
  ongoingLessons?: InputMaybe<Scalars['Boolean']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  subjects?: InputMaybe<Scalars['String']>;
};

export type Certificate_Of_Conduct = {
  __typename?: 'Certificate_of_conduct';
  createdAt: Scalars['DateTime'];
  criminalRecords: Scalars['Boolean'];
  dateOfInspection: Scalars['DateTime'];
  dateOfIssue: Scalars['DateTime'];
  id: Scalars['Int'];
  student: Array<Student>;
  studentId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type Certificate_Of_ConductOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  criminalRecords?: InputMaybe<SortOrder>;
  dateOfInspection?: InputMaybe<SortOrder>;
  dateOfIssue?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  student?: InputMaybe<StudentOrderByWithRelationInput>;
  studentId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type Certificate_Of_ConductRelationFilter = {
  is?: InputMaybe<Certificate_Of_ConductWhereInput>;
  isNot?: InputMaybe<Certificate_Of_ConductWhereInput>;
};

export type Certificate_Of_ConductWhereInput = {
  AND?: InputMaybe<Array<Certificate_Of_ConductWhereInput>>;
  NOT?: InputMaybe<Array<Certificate_Of_ConductWhereInput>>;
  OR?: InputMaybe<Array<Certificate_Of_ConductWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  criminalRecords?: InputMaybe<BoolFilter>;
  dateOfInspection?: InputMaybe<DateTimeFilter>;
  dateOfIssue?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  student?: InputMaybe<StudentRelationFilter>;
  studentId?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ChannelInput = {
  email: Scalars['Boolean'];
  push?: InputMaybe<Scalars['Boolean']>;
};

export type Chat = {
  __typename?: 'Chat';
  conversationId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  customData?: Maybe<Scalars['JSON']>;
  isReadonly: Scalars['Boolean'];
  shouldMarkAsReadonly: Scalars['Boolean'];
  subject: Scalars['String'];
};

export type Concrete_Notification = {
  __typename?: 'Concrete_notification';
  attachmentGroupId?: Maybe<Scalars['String']>;
  context: Scalars['JSON'];
  contextID?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  message?: Maybe<NotificationMessage>;
  notification: Notification;
  notificationID: Scalars['Int'];
  sentAt: Scalars['DateTime'];
  state: Scalars['Int'];
  userId: Scalars['String'];
};


export type Concrete_NotificationMessageArgs = {
  language?: InputMaybe<Scalars['String']>;
};

export type Concrete_NotificationCreateManyNotificationInput = {
  attachmentGroupId?: InputMaybe<Scalars['String']>;
  context: Scalars['JSON'];
  contextID?: InputMaybe<Scalars['String']>;
  error?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  sentAt: Scalars['DateTime'];
  state: Scalars['Int'];
  userId: Scalars['String'];
};

export type Concrete_NotificationCreateManyNotificationInputEnvelope = {
  data: Array<Concrete_NotificationCreateManyNotificationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type Concrete_NotificationCreateNestedManyWithoutNotificationInput = {
  connect?: InputMaybe<Array<Concrete_NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Concrete_NotificationCreateOrConnectWithoutNotificationInput>>;
  create?: InputMaybe<Array<Concrete_NotificationCreateWithoutNotificationInput>>;
  createMany?: InputMaybe<Concrete_NotificationCreateManyNotificationInputEnvelope>;
};

export type Concrete_NotificationCreateOrConnectWithoutNotificationInput = {
  create: Concrete_NotificationCreateWithoutNotificationInput;
  where: Concrete_NotificationWhereUniqueInput;
};

export type Concrete_NotificationCreateWithoutNotificationInput = {
  attachmentGroupId?: InputMaybe<Scalars['String']>;
  context: Scalars['JSON'];
  contextID?: InputMaybe<Scalars['String']>;
  error?: InputMaybe<Scalars['String']>;
  sentAt: Scalars['DateTime'];
  state: Scalars['Int'];
  userId: Scalars['String'];
};

export type Concrete_NotificationListRelationFilter = {
  every?: InputMaybe<Concrete_NotificationWhereInput>;
  none?: InputMaybe<Concrete_NotificationWhereInput>;
  some?: InputMaybe<Concrete_NotificationWhereInput>;
};

export type Concrete_NotificationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type Concrete_NotificationOrderByWithRelationInput = {
  attachmentGroupId?: InputMaybe<SortOrderInput>;
  context?: InputMaybe<SortOrder>;
  contextID?: InputMaybe<SortOrderInput>;
  error?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  notification?: InputMaybe<NotificationOrderByWithRelationInput>;
  notificationID?: InputMaybe<SortOrder>;
  sentAt?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export enum Concrete_NotificationScalarFieldEnum {
  AttachmentGroupId = 'attachmentGroupId',
  Context = 'context',
  ContextId = 'contextID',
  Error = 'error',
  Id = 'id',
  NotificationId = 'notificationID',
  SentAt = 'sentAt',
  State = 'state',
  UserId = 'userId'
}

export type Concrete_NotificationScalarWhereInput = {
  AND?: InputMaybe<Array<Concrete_NotificationScalarWhereInput>>;
  NOT?: InputMaybe<Array<Concrete_NotificationScalarWhereInput>>;
  OR?: InputMaybe<Array<Concrete_NotificationScalarWhereInput>>;
  attachmentGroupId?: InputMaybe<StringNullableFilter>;
  context?: InputMaybe<JsonFilter>;
  contextID?: InputMaybe<StringNullableFilter>;
  error?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  notificationID?: InputMaybe<IntFilter>;
  sentAt?: InputMaybe<DateTimeFilter>;
  state?: InputMaybe<IntFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type Concrete_NotificationUpdateManyMutationInput = {
  attachmentGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  context?: InputMaybe<Scalars['JSON']>;
  contextID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  error?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sentAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  state?: InputMaybe<IntFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Concrete_NotificationUpdateManyWithWhereWithoutNotificationInput = {
  data: Concrete_NotificationUpdateManyMutationInput;
  where: Concrete_NotificationScalarWhereInput;
};

export type Concrete_NotificationUpdateManyWithoutNotificationNestedInput = {
  connect?: InputMaybe<Array<Concrete_NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Concrete_NotificationCreateOrConnectWithoutNotificationInput>>;
  create?: InputMaybe<Array<Concrete_NotificationCreateWithoutNotificationInput>>;
  createMany?: InputMaybe<Concrete_NotificationCreateManyNotificationInputEnvelope>;
  delete?: InputMaybe<Array<Concrete_NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Concrete_NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Concrete_NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<Concrete_NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<Concrete_NotificationUpdateWithWhereUniqueWithoutNotificationInput>>;
  updateMany?: InputMaybe<Array<Concrete_NotificationUpdateManyWithWhereWithoutNotificationInput>>;
  upsert?: InputMaybe<Array<Concrete_NotificationUpsertWithWhereUniqueWithoutNotificationInput>>;
};

export type Concrete_NotificationUpdateWithWhereUniqueWithoutNotificationInput = {
  data: Concrete_NotificationUpdateWithoutNotificationInput;
  where: Concrete_NotificationWhereUniqueInput;
};

export type Concrete_NotificationUpdateWithoutNotificationInput = {
  attachmentGroupId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  context?: InputMaybe<Scalars['JSON']>;
  contextID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  error?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sentAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  state?: InputMaybe<IntFieldUpdateOperationsInput>;
  userId?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Concrete_NotificationUpsertWithWhereUniqueWithoutNotificationInput = {
  create: Concrete_NotificationCreateWithoutNotificationInput;
  update: Concrete_NotificationUpdateWithoutNotificationInput;
  where: Concrete_NotificationWhereUniqueInput;
};

export type Concrete_NotificationWhereInput = {
  AND?: InputMaybe<Array<Concrete_NotificationWhereInput>>;
  NOT?: InputMaybe<Array<Concrete_NotificationWhereInput>>;
  OR?: InputMaybe<Array<Concrete_NotificationWhereInput>>;
  attachmentGroupId?: InputMaybe<StringNullableFilter>;
  context?: InputMaybe<JsonFilter>;
  contextID?: InputMaybe<StringNullableFilter>;
  error?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  notification?: InputMaybe<NotificationRelationFilter>;
  notificationID?: InputMaybe<IntFilter>;
  sentAt?: InputMaybe<DateTimeFilter>;
  state?: InputMaybe<IntFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type Concrete_NotificationWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type Contact = {
  __typename?: 'Contact';
  chatId?: Maybe<Scalars['String']>;
  contactReasons: Array<Scalars['String']>;
  user: UserType;
};

export type Cooperation = {
  __typename?: 'Cooperation';
  _count?: Maybe<CooperationCount>;
  id: Scalars['Int'];
  name: Scalars['String'];
  tag: Scalars['String'];
  welcomeMessage: Scalars['String'];
  welcomeTitle: Scalars['String'];
};

export type CooperationCount = {
  __typename?: 'CooperationCount';
  student: Scalars['Int'];
};


export type CooperationCountStudentArgs = {
  where?: InputMaybe<StudentWhereInput>;
};

export type CooperationOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  student?: InputMaybe<StudentOrderByRelationAggregateInput>;
  tag?: InputMaybe<SortOrder>;
  welcomeMessage?: InputMaybe<SortOrder>;
  welcomeTitle?: InputMaybe<SortOrder>;
};

export type CooperationRelationFilter = {
  is?: InputMaybe<CooperationWhereInput>;
  isNot?: InputMaybe<CooperationWhereInput>;
};

export type CooperationWhereInput = {
  AND?: InputMaybe<Array<CooperationWhereInput>>;
  NOT?: InputMaybe<Array<CooperationWhereInput>>;
  OR?: InputMaybe<Array<CooperationWhereInput>>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  student?: InputMaybe<StudentListRelationFilter>;
  tag?: InputMaybe<StringFilter>;
  welcomeMessage?: InputMaybe<StringFilter>;
  welcomeTitle?: InputMaybe<StringFilter>;
};

export type Course = {
  __typename?: 'Course';
  _count?: Maybe<CourseCount>;
  allowContact: Scalars['Boolean'];
  category: Course_Category_Enum;
  correspondentId?: Maybe<Scalars['Int']>;
  courseState: Course_Coursestate_Enum;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['Int'];
  image?: Maybe<Scalars['String']>;
  imageKey?: Maybe<Scalars['String']>;
  isInstructor: Scalars['Boolean'];
  name: Scalars['String'];
  outline: Scalars['String'];
  publicRanking: Scalars['Int'];
  schooltype: Array<Course_Schooltype_Enum>;
  screeningComment?: Maybe<Scalars['String']>;
  shared: Scalars['Boolean'];
  subcourses: Array<Subcourse>;
  subject?: Maybe<Course_Subject_Enum>;
  tags: Array<Course_Tag>;
  updatedAt: Scalars['DateTime'];
};


export type CourseIsInstructorArgs = {
  studentId?: InputMaybe<Scalars['Float']>;
};

export enum CourseCategory {
  Club = 'club',
  Coaching = 'coaching',
  Focus = 'focus',
  HomeworkHelp = 'homework_help',
  Language = 'language',
  Revision = 'revision'
}

export type CourseCount = {
  __typename?: 'CourseCount';
  course_guest: Scalars['Int'];
  course_instructors_student: Scalars['Int'];
  course_tags_course_tag: Scalars['Int'];
  subcourse: Scalars['Int'];
};


export type CourseCountCourse_GuestArgs = {
  where?: InputMaybe<Course_GuestWhereInput>;
};


export type CourseCountCourse_Instructors_StudentArgs = {
  where?: InputMaybe<Course_Instructors_StudentWhereInput>;
};


export type CourseCountCourse_Tags_Course_TagArgs = {
  where?: InputMaybe<Course_Tags_Course_TagWhereInput>;
};


export type CourseCountSubcourseArgs = {
  where?: InputMaybe<SubcourseWhereInput>;
};

export type CourseImage = {
  __typename?: 'CourseImage';
  description: Scalars['String'];
  id: Scalars['String'];
  regularImageUrl: Scalars['String'];
  smallImageUrl: Scalars['String'];
};

export type CourseImageSearchResponse = {
  __typename?: 'CourseImageSearchResponse';
  results: Array<CourseImage>;
  total: Scalars['Float'];
  totalPages: Scalars['Float'];
};

export type CourseListRelationFilter = {
  every?: InputMaybe<CourseWhereInput>;
  none?: InputMaybe<CourseWhereInput>;
  some?: InputMaybe<CourseWhereInput>;
};

export type CourseOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CourseOrderByWithRelationInput = {
  allowContact?: InputMaybe<SortOrder>;
  category?: InputMaybe<SortOrder>;
  correspondentId?: InputMaybe<SortOrderInput>;
  courseState?: InputMaybe<SortOrder>;
  course_guest?: InputMaybe<Course_GuestOrderByRelationAggregateInput>;
  course_instructors_student?: InputMaybe<Course_Instructors_StudentOrderByRelationAggregateInput>;
  course_tags_course_tag?: InputMaybe<Course_Tags_Course_TagOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageKey?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  outline?: InputMaybe<SortOrder>;
  publicRanking?: InputMaybe<SortOrder>;
  schooltype?: InputMaybe<SortOrder>;
  screeningComment?: InputMaybe<SortOrderInput>;
  shared?: InputMaybe<SortOrder>;
  student?: InputMaybe<StudentOrderByWithRelationInput>;
  subcourse?: InputMaybe<SubcourseOrderByRelationAggregateInput>;
  subject?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CourseRelationFilter = {
  is?: InputMaybe<CourseWhereInput>;
  isNot?: InputMaybe<CourseWhereInput>;
};

export enum CourseScalarFieldEnum {
  AllowContact = 'allowContact',
  Category = 'category',
  CorrespondentId = 'correspondentId',
  CourseState = 'courseState',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  ImageKey = 'imageKey',
  Name = 'name',
  Outline = 'outline',
  PublicRanking = 'publicRanking',
  Schooltype = 'schooltype',
  ScreeningComment = 'screeningComment',
  Shared = 'shared',
  Subject = 'subject',
  UpdatedAt = 'updatedAt'
}

/** The subject of the course */
export enum CourseSubjectEnum {
  Altgriechisch = 'Altgriechisch',
  Arbeitslehre = 'Arbeitslehre',
  Biologie = 'Biologie',
  Chemie = 'Chemie',
  Deutsch = 'Deutsch',
  DeutschAlsZweitsprache = 'Deutsch_als_Zweitsprache',
  Englisch = 'Englisch',
  Erdkunde = 'Erdkunde',
  Ethik = 'Ethik',
  FranzSisch = 'Franz_sisch',
  Geschichte = 'Geschichte',
  Gesundheit = 'Gesundheit',
  Informatik = 'Informatik',
  Italienisch = 'Italienisch',
  Kunst = 'Kunst',
  Latein = 'Latein',
  LernenLernen = 'Lernen_lernen',
  Mathematik = 'Mathematik',
  Musik = 'Musik',
  NiederlNdisch = 'Niederl_ndisch',
  PDagogik = 'P_dagogik',
  Philosophie = 'Philosophie',
  Physik = 'Physik',
  Politik = 'Politik',
  Religion = 'Religion',
  Russisch = 'Russisch',
  Sachkunde = 'Sachkunde',
  Spanisch = 'Spanisch',
  Technik = 'Technik',
  Wirtschaft = 'Wirtschaft'
}

export type CourseTagCreateInput = {
  category: Scalars['String'];
  name: Scalars['String'];
};

export type CourseWhereInput = {
  AND?: InputMaybe<Array<CourseWhereInput>>;
  NOT?: InputMaybe<Array<CourseWhereInput>>;
  OR?: InputMaybe<Array<CourseWhereInput>>;
  allowContact?: InputMaybe<BoolFilter>;
  category?: InputMaybe<Enumcourse_Category_EnumFilter>;
  correspondentId?: InputMaybe<IntNullableFilter>;
  courseState?: InputMaybe<Enumcourse_Coursestate_EnumFilter>;
  course_guest?: InputMaybe<Course_GuestListRelationFilter>;
  course_instructors_student?: InputMaybe<Course_Instructors_StudentListRelationFilter>;
  course_tags_course_tag?: InputMaybe<Course_Tags_Course_TagListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  imageKey?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  outline?: InputMaybe<StringFilter>;
  publicRanking?: InputMaybe<IntFilter>;
  schooltype?: InputMaybe<Enumcourse_Schooltype_EnumNullableListFilter>;
  screeningComment?: InputMaybe<StringNullableFilter>;
  shared?: InputMaybe<BoolFilter>;
  student?: InputMaybe<StudentRelationFilter>;
  subcourse?: InputMaybe<SubcourseListRelationFilter>;
  subject?: InputMaybe<Enumcourse_Subject_EnumNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type CourseWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type Course_Attendance_LogListRelationFilter = {
  every?: InputMaybe<Course_Attendance_LogWhereInput>;
  none?: InputMaybe<Course_Attendance_LogWhereInput>;
  some?: InputMaybe<Course_Attendance_LogWhereInput>;
};

export type Course_Attendance_LogOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type Course_Attendance_LogWhereInput = {
  AND?: InputMaybe<Array<Course_Attendance_LogWhereInput>>;
  NOT?: InputMaybe<Array<Course_Attendance_LogWhereInput>>;
  OR?: InputMaybe<Array<Course_Attendance_LogWhereInput>>;
  attendedTime?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  ip?: InputMaybe<StringNullableFilter>;
  lecture?: InputMaybe<LectureRelationFilter>;
  lectureId?: InputMaybe<IntNullableFilter>;
  pupil?: InputMaybe<PupilRelationFilter>;
  pupilId?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Course_GuestListRelationFilter = {
  every?: InputMaybe<Course_GuestWhereInput>;
  none?: InputMaybe<Course_GuestWhereInput>;
  some?: InputMaybe<Course_GuestWhereInput>;
};

export type Course_GuestOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type Course_GuestWhereInput = {
  AND?: InputMaybe<Array<Course_GuestWhereInput>>;
  NOT?: InputMaybe<Array<Course_GuestWhereInput>>;
  OR?: InputMaybe<Array<Course_GuestWhereInput>>;
  course?: InputMaybe<CourseRelationFilter>;
  courseId?: InputMaybe<IntNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  firstname?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  inviterId?: InputMaybe<IntNullableFilter>;
  lastname?: InputMaybe<StringFilter>;
  student?: InputMaybe<StudentRelationFilter>;
  token?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Course_Instructors_StudentListRelationFilter = {
  every?: InputMaybe<Course_Instructors_StudentWhereInput>;
  none?: InputMaybe<Course_Instructors_StudentWhereInput>;
  some?: InputMaybe<Course_Instructors_StudentWhereInput>;
};

export type Course_Instructors_StudentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type Course_Instructors_StudentWhereInput = {
  AND?: InputMaybe<Array<Course_Instructors_StudentWhereInput>>;
  NOT?: InputMaybe<Array<Course_Instructors_StudentWhereInput>>;
  OR?: InputMaybe<Array<Course_Instructors_StudentWhereInput>>;
  course?: InputMaybe<CourseRelationFilter>;
  courseId?: InputMaybe<IntFilter>;
  student?: InputMaybe<StudentRelationFilter>;
  studentId?: InputMaybe<IntFilter>;
};

export type Course_Participation_CertificateListRelationFilter = {
  every?: InputMaybe<Course_Participation_CertificateWhereInput>;
  none?: InputMaybe<Course_Participation_CertificateWhereInput>;
  some?: InputMaybe<Course_Participation_CertificateWhereInput>;
};

export type Course_Participation_CertificateOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type Course_Participation_CertificateWhereInput = {
  AND?: InputMaybe<Array<Course_Participation_CertificateWhereInput>>;
  NOT?: InputMaybe<Array<Course_Participation_CertificateWhereInput>>;
  OR?: InputMaybe<Array<Course_Participation_CertificateWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  issuerId?: InputMaybe<IntNullableFilter>;
  pupil?: InputMaybe<PupilRelationFilter>;
  pupilId?: InputMaybe<IntNullableFilter>;
  student?: InputMaybe<StudentRelationFilter>;
  subcourse?: InputMaybe<SubcourseRelationFilter>;
  subcourseId?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Course_Tag = {
  __typename?: 'Course_tag';
  _count?: Maybe<Course_TagCount>;
  active: Scalars['Boolean'];
  category: Scalars['String'];
  id: Scalars['Int'];
  identifier: Scalars['String'];
  name: Scalars['String'];
};

export type Course_TagCount = {
  __typename?: 'Course_tagCount';
  course_tags_course_tag: Scalars['Int'];
};


export type Course_TagCountCourse_Tags_Course_TagArgs = {
  where?: InputMaybe<Course_Tags_Course_TagWhereInput>;
};

export type Course_TagOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  category?: InputMaybe<SortOrder>;
  course_tags_course_tag?: InputMaybe<Course_Tags_Course_TagOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  identifier?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type Course_TagRelationFilter = {
  is?: InputMaybe<Course_TagWhereInput>;
  isNot?: InputMaybe<Course_TagWhereInput>;
};

export enum Course_TagScalarFieldEnum {
  Active = 'active',
  Category = 'category',
  Id = 'id',
  Identifier = 'identifier',
  Name = 'name'
}

export type Course_TagWhereInput = {
  AND?: InputMaybe<Array<Course_TagWhereInput>>;
  NOT?: InputMaybe<Array<Course_TagWhereInput>>;
  OR?: InputMaybe<Array<Course_TagWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  category?: InputMaybe<StringFilter>;
  course_tags_course_tag?: InputMaybe<Course_Tags_Course_TagListRelationFilter>;
  id?: InputMaybe<IntFilter>;
  identifier?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type Course_TagWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  identifier?: InputMaybe<Scalars['String']>;
};

export type Course_Tags_Course_TagListRelationFilter = {
  every?: InputMaybe<Course_Tags_Course_TagWhereInput>;
  none?: InputMaybe<Course_Tags_Course_TagWhereInput>;
  some?: InputMaybe<Course_Tags_Course_TagWhereInput>;
};

export type Course_Tags_Course_TagOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type Course_Tags_Course_TagWhereInput = {
  AND?: InputMaybe<Array<Course_Tags_Course_TagWhereInput>>;
  NOT?: InputMaybe<Array<Course_Tags_Course_TagWhereInput>>;
  OR?: InputMaybe<Array<Course_Tags_Course_TagWhereInput>>;
  course?: InputMaybe<CourseRelationFilter>;
  courseId?: InputMaybe<IntFilter>;
  courseTagId?: InputMaybe<IntFilter>;
  course_tag?: InputMaybe<Course_TagRelationFilter>;
};

export type CreateCooperationInput = {
  name: Scalars['String'];
  tag: Scalars['String'];
  welcomeMessage: Scalars['String'];
  welcomeTitle: Scalars['String'];
};

export type CreatePushSubscriptionInput = {
  endpoint: Scalars['String'];
  expirationTime?: InputMaybe<Scalars['DateTime']>;
  keys: Scalars['JSON'];
};

export type DataWithTrends = {
  __typename?: 'DataWithTrends';
  label: Scalars['String'];
  trend: Scalars['Float'];
  value: Scalars['Float'];
};

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<Scalars['Decimal']>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  not?: InputMaybe<NestedDecimalFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']>>;
};

export type Decision = {
  __typename?: 'Decision';
  allowed: Scalars['Boolean'];
  limit?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
};

export type Enumachievement_Action_Type_EnumNullableFilter = {
  equals?: InputMaybe<Achievement_Action_Type_Enum>;
  in?: InputMaybe<Array<Achievement_Action_Type_Enum>>;
  not?: InputMaybe<NestedEnumachievement_Action_Type_EnumNullableFilter>;
  notIn?: InputMaybe<Array<Achievement_Action_Type_Enum>>;
};

export type Enumachievement_Template_For_EnumFilter = {
  equals?: InputMaybe<Achievement_Template_For_Enum>;
  in?: InputMaybe<Array<Achievement_Template_For_Enum>>;
  not?: InputMaybe<NestedEnumachievement_Template_For_EnumFilter>;
  notIn?: InputMaybe<Array<Achievement_Template_For_Enum>>;
};

export type Enumachievement_Type_EnumFilter = {
  equals?: InputMaybe<Achievement_Type_Enum>;
  in?: InputMaybe<Array<Achievement_Type_Enum>>;
  not?: InputMaybe<NestedEnumachievement_Type_EnumFilter>;
  notIn?: InputMaybe<Array<Achievement_Type_Enum>>;
};

export type Enumchat_TypeFilter = {
  equals?: InputMaybe<Chat_Type>;
  in?: InputMaybe<Array<Chat_Type>>;
  not?: InputMaybe<NestedEnumchat_TypeFilter>;
  notIn?: InputMaybe<Array<Chat_Type>>;
};

export type Enumcourse_Category_EnumFilter = {
  equals?: InputMaybe<Course_Category_Enum>;
  in?: InputMaybe<Array<Course_Category_Enum>>;
  not?: InputMaybe<NestedEnumcourse_Category_EnumFilter>;
  notIn?: InputMaybe<Array<Course_Category_Enum>>;
};

export type Enumcourse_Coursestate_EnumFilter = {
  equals?: InputMaybe<Course_Coursestate_Enum>;
  in?: InputMaybe<Array<Course_Coursestate_Enum>>;
  not?: InputMaybe<NestedEnumcourse_Coursestate_EnumFilter>;
  notIn?: InputMaybe<Array<Course_Coursestate_Enum>>;
};

export type Enumcourse_Schooltype_EnumNullableListFilter = {
  equals?: InputMaybe<Array<Course_Schooltype_Enum>>;
  has?: InputMaybe<Course_Schooltype_Enum>;
  hasEvery?: InputMaybe<Array<Course_Schooltype_Enum>>;
  hasSome?: InputMaybe<Array<Course_Schooltype_Enum>>;
  isEmpty?: InputMaybe<Scalars['Boolean']>;
};

export type Enumcourse_Subject_EnumFilter = {
  equals?: InputMaybe<Course_Subject_Enum>;
  in?: InputMaybe<Array<Course_Subject_Enum>>;
  not?: InputMaybe<NestedEnumcourse_Subject_EnumFilter>;
  notIn?: InputMaybe<Array<Course_Subject_Enum>>;
};

export type Enumcourse_Subject_EnumNullableFilter = {
  equals?: InputMaybe<Course_Subject_Enum>;
  in?: InputMaybe<Array<Course_Subject_Enum>>;
  not?: InputMaybe<NestedEnumcourse_Subject_EnumNullableFilter>;
  notIn?: InputMaybe<Array<Course_Subject_Enum>>;
};

export type Enumdissolve_ReasonNullableListFilter = {
  equals?: InputMaybe<Array<Dissolve_Reason>>;
  has?: InputMaybe<Dissolve_Reason>;
  hasEvery?: InputMaybe<Array<Dissolve_Reason>>;
  hasSome?: InputMaybe<Array<Dissolve_Reason>>;
  isEmpty?: InputMaybe<Scalars['Boolean']>;
};

export type Enumdissolved_By_EnumNullableFilter = {
  equals?: InputMaybe<Dissolved_By_Enum>;
  in?: InputMaybe<Array<Dissolved_By_Enum>>;
  not?: InputMaybe<NestedEnumdissolved_By_EnumNullableFilter>;
  notIn?: InputMaybe<Array<Dissolved_By_Enum>>;
};

export type Enumgender_EnumNullableFilter = {
  equals?: InputMaybe<Gender_Enum>;
  in?: InputMaybe<Array<Gender_Enum>>;
  not?: InputMaybe<NestedEnumgender_EnumNullableFilter>;
  notIn?: InputMaybe<Array<Gender_Enum>>;
};

export type Enumimportant_Information_Language_EnumFieldUpdateOperationsInput = {
  set?: InputMaybe<Important_Information_Language_Enum>;
};

export type Enumimportant_Information_Language_EnumFilter = {
  equals?: InputMaybe<Important_Information_Language_Enum>;
  in?: InputMaybe<Array<Important_Information_Language_Enum>>;
  not?: InputMaybe<NestedEnumimportant_Information_Language_EnumFilter>;
  notIn?: InputMaybe<Array<Important_Information_Language_Enum>>;
};

export type Enumimportant_Information_Language_EnumWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumimportant_Information_Language_EnumFilter>;
  _min?: InputMaybe<NestedEnumimportant_Information_Language_EnumFilter>;
  equals?: InputMaybe<Important_Information_Language_Enum>;
  in?: InputMaybe<Array<Important_Information_Language_Enum>>;
  not?: InputMaybe<NestedEnumimportant_Information_Language_EnumWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Important_Information_Language_Enum>>;
};

export type Enumimportant_Information_Recipients_EnumFieldUpdateOperationsInput = {
  set?: InputMaybe<Important_Information_Recipients_Enum>;
};

export type Enumimportant_Information_Recipients_EnumFilter = {
  equals?: InputMaybe<Important_Information_Recipients_Enum>;
  in?: InputMaybe<Array<Important_Information_Recipients_Enum>>;
  not?: InputMaybe<NestedEnumimportant_Information_Recipients_EnumFilter>;
  notIn?: InputMaybe<Array<Important_Information_Recipients_Enum>>;
};

export type Enumimportant_Information_Recipients_EnumWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumimportant_Information_Recipients_EnumFilter>;
  _min?: InputMaybe<NestedEnumimportant_Information_Recipients_EnumFilter>;
  equals?: InputMaybe<Important_Information_Recipients_Enum>;
  in?: InputMaybe<Array<Important_Information_Recipients_Enum>>;
  not?: InputMaybe<NestedEnumimportant_Information_Recipients_EnumWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Important_Information_Recipients_Enum>>;
};

export type Enumlearning_Assignment_StatusFilter = {
  equals?: InputMaybe<Learning_Assignment_Status>;
  in?: InputMaybe<Array<Learning_Assignment_Status>>;
  not?: InputMaybe<NestedEnumlearning_Assignment_StatusFilter>;
  notIn?: InputMaybe<Array<Learning_Assignment_Status>>;
};

export type Enumlearning_Note_TypeFilter = {
  equals?: InputMaybe<Learning_Note_Type>;
  in?: InputMaybe<Array<Learning_Note_Type>>;
  not?: InputMaybe<NestedEnumlearning_Note_TypeFilter>;
  notIn?: InputMaybe<Array<Learning_Note_Type>>;
};

export type Enumlecture_Appointmenttype_EnumFilter = {
  equals?: InputMaybe<Lecture_Appointmenttype_Enum>;
  in?: InputMaybe<Array<Lecture_Appointmenttype_Enum>>;
  not?: InputMaybe<NestedEnumlecture_Appointmenttype_EnumFilter>;
  notIn?: InputMaybe<Array<Lecture_Appointmenttype_Enum>>;
};

export type Enummessage_Translation_Language_EnumFieldUpdateOperationsInput = {
  set?: InputMaybe<Message_Translation_Language_Enum>;
};

export type Enummessage_Translation_Language_EnumFilter = {
  equals?: InputMaybe<Message_Translation_Language_Enum>;
  in?: InputMaybe<Array<Message_Translation_Language_Enum>>;
  not?: InputMaybe<NestedEnummessage_Translation_Language_EnumFilter>;
  notIn?: InputMaybe<Array<Message_Translation_Language_Enum>>;
};

export type Enumnotification_Channel_EnumNullableListFilter = {
  equals?: InputMaybe<Array<Notification_Channel_Enum>>;
  has?: InputMaybe<Notification_Channel_Enum>;
  hasEvery?: InputMaybe<Array<Notification_Channel_Enum>>;
  hasSome?: InputMaybe<Array<Notification_Channel_Enum>>;
  isEmpty?: InputMaybe<Scalars['Boolean']>;
};

export type Enumnotification_Sender_EnumNullableFilter = {
  equals?: InputMaybe<Notification_Sender_Enum>;
  in?: InputMaybe<Array<Notification_Sender_Enum>>;
  not?: InputMaybe<NestedEnumnotification_Sender_EnumNullableFilter>;
  notIn?: InputMaybe<Array<Notification_Sender_Enum>>;
};

export type Enumnotification_Type_EnumFieldUpdateOperationsInput = {
  set?: InputMaybe<Notification_Type_Enum>;
};

export type Enumnotification_Type_EnumFilter = {
  equals?: InputMaybe<Notification_Type_Enum>;
  in?: InputMaybe<Array<Notification_Type_Enum>>;
  not?: InputMaybe<NestedEnumnotification_Type_EnumFilter>;
  notIn?: InputMaybe<Array<Notification_Type_Enum>>;
};

export type Enumpupil_Email_Owner_EnumFilter = {
  equals?: InputMaybe<Pupil_Email_Owner_Enum>;
  in?: InputMaybe<Array<Pupil_Email_Owner_Enum>>;
  not?: InputMaybe<NestedEnumpupil_Email_Owner_EnumFilter>;
  notIn?: InputMaybe<Array<Pupil_Email_Owner_Enum>>;
};

export type Enumpupil_Languages_EnumNullableListFilter = {
  equals?: InputMaybe<Array<Pupil_Languages_Enum>>;
  has?: InputMaybe<Pupil_Languages_Enum>;
  hasEvery?: InputMaybe<Array<Pupil_Languages_Enum>>;
  hasSome?: InputMaybe<Array<Pupil_Languages_Enum>>;
  isEmpty?: InputMaybe<Scalars['Boolean']>;
};

export type Enumpupil_Learninggermansince_EnumNullableFilter = {
  equals?: InputMaybe<Pupil_Learninggermansince_Enum>;
  in?: InputMaybe<Array<Pupil_Learninggermansince_Enum>>;
  not?: InputMaybe<NestedEnumpupil_Learninggermansince_EnumNullableFilter>;
  notIn?: InputMaybe<Array<Pupil_Learninggermansince_Enum>>;
};

export type Enumpupil_Registrationsource_EnumFilter = {
  equals?: InputMaybe<Pupil_Registrationsource_Enum>;
  in?: InputMaybe<Array<Pupil_Registrationsource_Enum>>;
  not?: InputMaybe<NestedEnumpupil_Registrationsource_EnumFilter>;
  notIn?: InputMaybe<Array<Pupil_Registrationsource_Enum>>;
};

export type Enumpupil_Schooltype_EnumFilter = {
  equals?: InputMaybe<Pupil_Schooltype_Enum>;
  in?: InputMaybe<Array<Pupil_Schooltype_Enum>>;
  not?: InputMaybe<NestedEnumpupil_Schooltype_EnumFilter>;
  notIn?: InputMaybe<Array<Pupil_Schooltype_Enum>>;
};

export type Enumpupil_Screening_Status_EnumFilter = {
  equals?: InputMaybe<Pupil_Screening_Status_Enum>;
  in?: InputMaybe<Array<Pupil_Screening_Status_Enum>>;
  not?: InputMaybe<NestedEnumpupil_Screening_Status_EnumFilter>;
  notIn?: InputMaybe<Array<Pupil_Screening_Status_Enum>>;
};

export type Enumpupil_State_EnumFilter = {
  equals?: InputMaybe<Pupil_State_Enum>;
  in?: InputMaybe<Array<Pupil_State_Enum>>;
  not?: InputMaybe<NestedEnumpupil_State_EnumFilter>;
  notIn?: InputMaybe<Array<Pupil_State_Enum>>;
};

export type Enumschool_Schooltype_EnumNullableFilter = {
  equals?: InputMaybe<School_Schooltype_Enum>;
  in?: InputMaybe<Array<School_Schooltype_Enum>>;
  not?: InputMaybe<NestedEnumschool_Schooltype_EnumNullableFilter>;
  notIn?: InputMaybe<Array<School_Schooltype_Enum>>;
};

export type Enumschool_State_EnumFilter = {
  equals?: InputMaybe<School_State_Enum>;
  in?: InputMaybe<Array<School_State_Enum>>;
  not?: InputMaybe<NestedEnumschool_State_EnumFilter>;
  notIn?: InputMaybe<Array<School_State_Enum>>;
};

export type Enumscreening_Jobstatus_EnumNullableFilter = {
  equals?: InputMaybe<Screening_Jobstatus_Enum>;
  in?: InputMaybe<Array<Screening_Jobstatus_Enum>>;
  not?: InputMaybe<NestedEnumscreening_Jobstatus_EnumNullableFilter>;
  notIn?: InputMaybe<Array<Screening_Jobstatus_Enum>>;
};

export type Enumstudent_Languages_EnumNullableListFilter = {
  equals?: InputMaybe<Array<Student_Languages_Enum>>;
  has?: InputMaybe<Student_Languages_Enum>;
  hasEvery?: InputMaybe<Array<Student_Languages_Enum>>;
  hasSome?: InputMaybe<Array<Student_Languages_Enum>>;
  isEmpty?: InputMaybe<Scalars['Boolean']>;
};

export type Enumstudent_Registrationsource_EnumFilter = {
  equals?: InputMaybe<Student_Registrationsource_Enum>;
  in?: InputMaybe<Array<Student_Registrationsource_Enum>>;
  not?: InputMaybe<NestedEnumstudent_Registrationsource_EnumFilter>;
  notIn?: InputMaybe<Array<Student_Registrationsource_Enum>>;
};

export type Enumstudent_Screening_Status_EnumFilter = {
  equals?: InputMaybe<Student_Screening_Status_Enum>;
  in?: InputMaybe<Array<Student_Screening_Status_Enum>>;
  not?: InputMaybe<NestedEnumstudent_Screening_Status_EnumFilter>;
  notIn?: InputMaybe<Array<Student_Screening_Status_Enum>>;
};

export type Enumstudent_State_EnumNullableFilter = {
  equals?: InputMaybe<Student_State_Enum>;
  in?: InputMaybe<Array<Student_State_Enum>>;
  not?: InputMaybe<NestedEnumstudent_State_EnumNullableFilter>;
  notIn?: InputMaybe<Array<Student_State_Enum>>;
};

export type Enumsubcourse_Promotion_Type_EnumFilter = {
  equals?: InputMaybe<Subcourse_Promotion_Type_Enum>;
  in?: InputMaybe<Array<Subcourse_Promotion_Type_Enum>>;
  not?: InputMaybe<NestedEnumsubcourse_Promotion_Type_EnumFilter>;
  notIn?: InputMaybe<Array<Subcourse_Promotion_Type_Enum>>;
};

export type ExternalSchoolSearch = {
  __typename?: 'ExternalSchoolSearch';
  city?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  schooltype?: Maybe<SchoolType>;
  state: State;
  zip?: Maybe<Scalars['String']>;
};

export type ExternalSchoolSearchFilters = {
  name: Scalars['String'];
};

export type ExternalSchoolSearchOptions = {
  limit?: InputMaybe<Scalars['Int']>;
};

export enum Gender {
  Female = 'female',
  Male = 'male',
  Other = 'other'
}

export type GenerateLessonPlanInput = {
  duration: Scalars['Int'];
  expectedOutputs?: InputMaybe<Array<LessonPlanField>>;
  fileUuids?: InputMaybe<Array<Scalars['String']>>;
  grade: Scalars['Int'];
  language?: InputMaybe<Scalars['String']>;
  prompt: Scalars['String'];
  schoolType: SchoolSchoolTypeEnum;
  state: State;
  subject: CourseSubjectEnum;
};

export type Important_Information = {
  __typename?: 'Important_information';
  description: Scalars['String'];
  id: Scalars['Int'];
  language: Important_Information_Language_Enum;
  navigateTo?: Maybe<Scalars['String']>;
  recipients: Important_Information_Recipients_Enum;
  title: Scalars['String'];
};

export type Important_InformationAvgAggregate = {
  __typename?: 'Important_informationAvgAggregate';
  id?: Maybe<Scalars['Float']>;
};

export type Important_InformationAvgOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type Important_InformationCountAggregate = {
  __typename?: 'Important_informationCountAggregate';
  _all: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  language: Scalars['Int'];
  navigateTo: Scalars['Int'];
  recipients: Scalars['Int'];
  title: Scalars['Int'];
};

export type Important_InformationCountOrderByAggregateInput = {
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  navigateTo?: InputMaybe<SortOrder>;
  recipients?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type Important_InformationCreateInput = {
  description: Scalars['String'];
  language?: InputMaybe<Important_Information_Language_Enum>;
  navigateTo?: InputMaybe<Scalars['String']>;
  recipients: Important_Information_Recipients_Enum;
  title: Scalars['String'];
};

export type Important_InformationCreateManyInput = {
  description: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  language?: InputMaybe<Important_Information_Language_Enum>;
  navigateTo?: InputMaybe<Scalars['String']>;
  recipients: Important_Information_Recipients_Enum;
  title: Scalars['String'];
};

export type Important_InformationGroupBy = {
  __typename?: 'Important_informationGroupBy';
  _avg?: Maybe<Important_InformationAvgAggregate>;
  _count?: Maybe<Important_InformationCountAggregate>;
  _max?: Maybe<Important_InformationMaxAggregate>;
  _min?: Maybe<Important_InformationMinAggregate>;
  _sum?: Maybe<Important_InformationSumAggregate>;
  description: Scalars['String'];
  id: Scalars['Int'];
  language: Important_Information_Language_Enum;
  navigateTo?: Maybe<Scalars['String']>;
  recipients: Important_Information_Recipients_Enum;
  title: Scalars['String'];
};

export type Important_InformationMaxAggregate = {
  __typename?: 'Important_informationMaxAggregate';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  language?: Maybe<Important_Information_Language_Enum>;
  navigateTo?: Maybe<Scalars['String']>;
  recipients?: Maybe<Important_Information_Recipients_Enum>;
  title?: Maybe<Scalars['String']>;
};

export type Important_InformationMaxOrderByAggregateInput = {
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  navigateTo?: InputMaybe<SortOrder>;
  recipients?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type Important_InformationMinAggregate = {
  __typename?: 'Important_informationMinAggregate';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  language?: Maybe<Important_Information_Language_Enum>;
  navigateTo?: Maybe<Scalars['String']>;
  recipients?: Maybe<Important_Information_Recipients_Enum>;
  title?: Maybe<Scalars['String']>;
};

export type Important_InformationMinOrderByAggregateInput = {
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  navigateTo?: InputMaybe<SortOrder>;
  recipients?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type Important_InformationOrderByWithAggregationInput = {
  _avg?: InputMaybe<Important_InformationAvgOrderByAggregateInput>;
  _count?: InputMaybe<Important_InformationCountOrderByAggregateInput>;
  _max?: InputMaybe<Important_InformationMaxOrderByAggregateInput>;
  _min?: InputMaybe<Important_InformationMinOrderByAggregateInput>;
  _sum?: InputMaybe<Important_InformationSumOrderByAggregateInput>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  navigateTo?: InputMaybe<SortOrderInput>;
  recipients?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type Important_InformationOrderByWithRelationInput = {
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<SortOrder>;
  navigateTo?: InputMaybe<SortOrderInput>;
  recipients?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export enum Important_InformationScalarFieldEnum {
  Description = 'description',
  Id = 'id',
  Language = 'language',
  NavigateTo = 'navigateTo',
  Recipients = 'recipients',
  Title = 'title'
}

export type Important_InformationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<Important_InformationScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<Important_InformationScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<Important_InformationScalarWhereWithAggregatesInput>>;
  description?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<IntWithAggregatesFilter>;
  language?: InputMaybe<Enumimportant_Information_Language_EnumWithAggregatesFilter>;
  navigateTo?: InputMaybe<StringNullableWithAggregatesFilter>;
  recipients?: InputMaybe<Enumimportant_Information_Recipients_EnumWithAggregatesFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
};

export type Important_InformationSumAggregate = {
  __typename?: 'Important_informationSumAggregate';
  id?: Maybe<Scalars['Int']>;
};

export type Important_InformationSumOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
};

export type Important_InformationUpdateInput = {
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<Enumimportant_Information_Language_EnumFieldUpdateOperationsInput>;
  navigateTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  recipients?: InputMaybe<Enumimportant_Information_Recipients_EnumFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Important_InformationUpdateManyMutationInput = {
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<Enumimportant_Information_Language_EnumFieldUpdateOperationsInput>;
  navigateTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  recipients?: InputMaybe<Enumimportant_Information_Recipients_EnumFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type Important_InformationWhereInput = {
  AND?: InputMaybe<Array<Important_InformationWhereInput>>;
  NOT?: InputMaybe<Array<Important_InformationWhereInput>>;
  OR?: InputMaybe<Array<Important_InformationWhereInput>>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  language?: InputMaybe<Enumimportant_Information_Language_EnumFilter>;
  navigateTo?: InputMaybe<StringNullableFilter>;
  recipients?: InputMaybe<Enumimportant_Information_Recipients_EnumFilter>;
  title?: InputMaybe<StringFilter>;
};

export type Important_InformationWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type Instant_CertificateListRelationFilter = {
  every?: InputMaybe<Instant_CertificateWhereInput>;
  none?: InputMaybe<Instant_CertificateWhereInput>;
  some?: InputMaybe<Instant_CertificateWhereInput>;
};

export type Instant_CertificateOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type Instant_CertificateWhereInput = {
  AND?: InputMaybe<Array<Instant_CertificateWhereInput>>;
  NOT?: InputMaybe<Array<Instant_CertificateWhereInput>>;
  OR?: InputMaybe<Array<Instant_CertificateWhereInput>>;
  courseAppointmentsCount?: InputMaybe<IntFilter>;
  courseParticipantsCount?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  matchAppointmentsCount?: InputMaybe<IntFilter>;
  matchesCount?: InputMaybe<IntFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
  student?: InputMaybe<StudentRelationFilter>;
  studentId?: InputMaybe<IntFilter>;
  totalAppointmentsDuration?: InputMaybe<IntFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type Instructor = {
  __typename?: 'Instructor';
  aboutMe: Scalars['String'];
  firstname: Scalars['String'];
  id: Scalars['Int'];
  lastname: Scalars['String'];
};

export type Instructor_Screening = {
  __typename?: 'Instructor_screening';
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  jobStatus?: Maybe<Screening_Jobstatus_Enum>;
  knowsCoronaSchoolFrom?: Maybe<Scalars['String']>;
  screener: Screener;
  screenerId?: Maybe<Scalars['Int']>;
  status: Student_Screening_Status_Enum;
  studentId?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type Instructor_ScreeningCreateInput = {
  comment?: InputMaybe<Scalars['String']>;
  jobStatus?: InputMaybe<Screening_Jobstatus_Enum>;
  knowsCoronaSchoolFrom?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StudentScreeningStatus>;
  success: Scalars['Boolean'];
};

export type Instructor_ScreeningListRelationFilter = {
  every?: InputMaybe<Instructor_ScreeningWhereInput>;
  none?: InputMaybe<Instructor_ScreeningWhereInput>;
  some?: InputMaybe<Instructor_ScreeningWhereInput>;
};

export type Instructor_ScreeningOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type Instructor_ScreeningOrderByWithRelationInput = {
  comment?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  jobStatus?: InputMaybe<SortOrderInput>;
  knowsCoronaSchoolFrom?: InputMaybe<SortOrderInput>;
  screener?: InputMaybe<ScreenerOrderByWithRelationInput>;
  screenerId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  student?: InputMaybe<StudentOrderByWithRelationInput>;
  studentId?: InputMaybe<SortOrderInput>;
  success?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type Instructor_ScreeningRelationFilter = {
  is?: InputMaybe<Instructor_ScreeningWhereInput>;
  isNot?: InputMaybe<Instructor_ScreeningWhereInput>;
};

export type Instructor_ScreeningWhereInput = {
  AND?: InputMaybe<Array<Instructor_ScreeningWhereInput>>;
  NOT?: InputMaybe<Array<Instructor_ScreeningWhereInput>>;
  OR?: InputMaybe<Array<Instructor_ScreeningWhereInput>>;
  comment?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  jobStatus?: InputMaybe<Enumscreening_Jobstatus_EnumNullableFilter>;
  knowsCoronaSchoolFrom?: InputMaybe<StringNullableFilter>;
  screener?: InputMaybe<ScreenerRelationFilter>;
  screenerId?: InputMaybe<IntNullableFilter>;
  status?: InputMaybe<Enumstudent_Screening_Status_EnumFilter>;
  student?: InputMaybe<StudentRelationFilter>;
  studentId?: InputMaybe<IntNullableFilter>;
  success?: InputMaybe<BoolFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']>;
  divide?: InputMaybe<Scalars['Int']>;
  increment?: InputMaybe<Scalars['Int']>;
  multiply?: InputMaybe<Scalars['Int']>;
  set?: InputMaybe<Scalars['Int']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type IntNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['Int']>>;
  has?: InputMaybe<Scalars['Int']>;
  hasEvery?: InputMaybe<Array<Scalars['Int']>>;
  hasSome?: InputMaybe<Array<Scalars['Int']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']>;
};

export type IntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedIntFilter>;
  _min?: InputMaybe<NestedIntFilter>;
  _sum?: InputMaybe<NestedIntFilter>;
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type JsonFilter = {
  array_contains?: InputMaybe<Scalars['JSON']>;
  array_ends_with?: InputMaybe<Scalars['JSON']>;
  array_starts_with?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  not?: InputMaybe<Scalars['JSON']>;
  path?: InputMaybe<Array<Scalars['String']>>;
  string_contains?: InputMaybe<Scalars['String']>;
  string_ends_with?: InputMaybe<Scalars['String']>;
  string_starts_with?: InputMaybe<Scalars['String']>;
};

export type JsonNullableFilter = {
  array_contains?: InputMaybe<Scalars['JSON']>;
  array_ends_with?: InputMaybe<Scalars['JSON']>;
  array_starts_with?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  not?: InputMaybe<Scalars['JSON']>;
  path?: InputMaybe<Array<Scalars['String']>>;
  string_contains?: InputMaybe<Scalars['String']>;
  string_ends_with?: InputMaybe<Scalars['String']>;
  string_starts_with?: InputMaybe<Scalars['String']>;
};

export type JsonNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['JSON']>>;
  has?: InputMaybe<Scalars['JSON']>;
  hasEvery?: InputMaybe<Array<Scalars['JSON']>>;
  hasSome?: InputMaybe<Array<Scalars['JSON']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']>;
};

export type Jufo_Verification_TransmissionOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  student?: InputMaybe<StudentOrderByWithRelationInput>;
  studentId?: InputMaybe<SortOrderInput>;
  uuid?: InputMaybe<SortOrder>;
};

export type Jufo_Verification_TransmissionRelationFilter = {
  is?: InputMaybe<Jufo_Verification_TransmissionWhereInput>;
  isNot?: InputMaybe<Jufo_Verification_TransmissionWhereInput>;
};

export type Jufo_Verification_TransmissionWhereInput = {
  AND?: InputMaybe<Array<Jufo_Verification_TransmissionWhereInput>>;
  NOT?: InputMaybe<Array<Jufo_Verification_TransmissionWhereInput>>;
  OR?: InputMaybe<Array<Jufo_Verification_TransmissionWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  student?: InputMaybe<StudentRelationFilter>;
  studentId?: InputMaybe<IntNullableFilter>;
  uuid?: InputMaybe<StringFilter>;
};

/** languages commonly spoken at Lern-Fair (except TypeScript) */
export enum Language {
  Albanisch = 'Albanisch',
  Andere = 'Andere',
  Arabisch = 'Arabisch',
  Armenisch = 'Armenisch',
  Aserbaidschanisch = 'Aserbaidschanisch',
  Bosnisch = 'Bosnisch',
  Bulgarisch = 'Bulgarisch',
  Chinesisch = 'Chinesisch',
  Deutsch = 'Deutsch',
  Englisch = 'Englisch',
  FranzSisch = 'Franz_sisch',
  Italienisch = 'Italienisch',
  Kasachisch = 'Kasachisch',
  Kurdisch = 'Kurdisch',
  Polnisch = 'Polnisch',
  Portugiesisch = 'Portugiesisch',
  Russisch = 'Russisch',
  Spanisch = 'Spanisch',
  TRkisch = 'T_rkisch',
  Ukrainisch = 'Ukrainisch',
  Vietnamesisch = 'Vietnamesisch'
}

export enum LearningGermanySince {
  LessThanOne = 'less_than_one',
  MoreThanFour = 'more_than_four',
  OneToTwo = 'one_to_two',
  TwoToFour = 'two_to_four'
}

export type LearningNoteCreateInput = {
  assignmentId?: InputMaybe<Scalars['Int']>;
  replyToId?: InputMaybe<Scalars['Int']>;
  text: Scalars['String'];
  topicId?: InputMaybe<Scalars['Int']>;
  type: Learning_Note_Type;
};

export type Learning_Assignment = {
  __typename?: 'Learning_assignment';
  _count?: Maybe<Learning_AssignmentCount>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  notes: Array<Learning_Note>;
  status: Learning_Assignment_Status;
  task: Scalars['String'];
  topicId: Scalars['Int'];
};

export type Learning_AssignmentCount = {
  __typename?: 'Learning_assignmentCount';
  notes: Scalars['Int'];
};


export type Learning_AssignmentCountNotesArgs = {
  where?: InputMaybe<Learning_NoteWhereInput>;
};

export type Learning_AssignmentListRelationFilter = {
  every?: InputMaybe<Learning_AssignmentWhereInput>;
  none?: InputMaybe<Learning_AssignmentWhereInput>;
  some?: InputMaybe<Learning_AssignmentWhereInput>;
};

export type Learning_AssignmentRelationFilter = {
  is?: InputMaybe<Learning_AssignmentWhereInput>;
  isNot?: InputMaybe<Learning_AssignmentWhereInput>;
};

export type Learning_AssignmentWhereInput = {
  AND?: InputMaybe<Array<Learning_AssignmentWhereInput>>;
  NOT?: InputMaybe<Array<Learning_AssignmentWhereInput>>;
  OR?: InputMaybe<Array<Learning_AssignmentWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  notes?: InputMaybe<Learning_NoteListRelationFilter>;
  status?: InputMaybe<Enumlearning_Assignment_StatusFilter>;
  task?: InputMaybe<StringFilter>;
  topic?: InputMaybe<Learning_TopicRelationFilter>;
  topicId?: InputMaybe<IntFilter>;
};

export type Learning_Note = {
  __typename?: 'Learning_note';
  _count?: Maybe<Learning_NoteCount>;
  assignmentId?: Maybe<Scalars['Int']>;
  authorID?: Maybe<Scalars['String']>;
  authorName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  replies: Array<Learning_Note>;
  replyToId?: Maybe<Scalars['Int']>;
  text: Scalars['String'];
  topicId?: Maybe<Scalars['Int']>;
  type: Learning_Note_Type;
};

export type Learning_NoteCount = {
  __typename?: 'Learning_noteCount';
  repliedBy: Scalars['Int'];
};


export type Learning_NoteCountRepliedByArgs = {
  where?: InputMaybe<Learning_NoteWhereInput>;
};

export type Learning_NoteListRelationFilter = {
  every?: InputMaybe<Learning_NoteWhereInput>;
  none?: InputMaybe<Learning_NoteWhereInput>;
  some?: InputMaybe<Learning_NoteWhereInput>;
};

export type Learning_NoteRelationFilter = {
  is?: InputMaybe<Learning_NoteWhereInput>;
  isNot?: InputMaybe<Learning_NoteWhereInput>;
};

export type Learning_NoteWhereInput = {
  AND?: InputMaybe<Array<Learning_NoteWhereInput>>;
  NOT?: InputMaybe<Array<Learning_NoteWhereInput>>;
  OR?: InputMaybe<Array<Learning_NoteWhereInput>>;
  assignment?: InputMaybe<Learning_AssignmentRelationFilter>;
  assignmentId?: InputMaybe<IntNullableFilter>;
  authorID?: InputMaybe<StringNullableFilter>;
  authorName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  repliedBy?: InputMaybe<Learning_NoteListRelationFilter>;
  replyTo?: InputMaybe<Learning_NoteRelationFilter>;
  replyToId?: InputMaybe<IntNullableFilter>;
  text?: InputMaybe<StringFilter>;
  topic?: InputMaybe<Learning_TopicRelationFilter>;
  topicId?: InputMaybe<IntNullableFilter>;
  type?: InputMaybe<Enumlearning_Note_TypeFilter>;
};

export type Learning_Topic = {
  __typename?: 'Learning_topic';
  _count?: Maybe<Learning_TopicCount>;
  assignments: Array<Learning_Assignment>;
  createdAt: Scalars['DateTime'];
  finishedAssignmentsCount: Scalars['Int'];
  id: Scalars['Int'];
  matchId?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  notes: Array<Learning_Note>;
  openAssignmentsCount: Scalars['Int'];
  pupilId: Scalars['Int'];
  subject: Course_Subject_Enum;
};

export type Learning_TopicCount = {
  __typename?: 'Learning_topicCount';
  assignments: Scalars['Int'];
  notes: Scalars['Int'];
};


export type Learning_TopicCountAssignmentsArgs = {
  where?: InputMaybe<Learning_AssignmentWhereInput>;
};


export type Learning_TopicCountNotesArgs = {
  where?: InputMaybe<Learning_NoteWhereInput>;
};

export type Learning_TopicListRelationFilter = {
  every?: InputMaybe<Learning_TopicWhereInput>;
  none?: InputMaybe<Learning_TopicWhereInput>;
  some?: InputMaybe<Learning_TopicWhereInput>;
};

export type Learning_TopicOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type Learning_TopicRelationFilter = {
  is?: InputMaybe<Learning_TopicWhereInput>;
  isNot?: InputMaybe<Learning_TopicWhereInput>;
};

export type Learning_TopicWhereInput = {
  AND?: InputMaybe<Array<Learning_TopicWhereInput>>;
  NOT?: InputMaybe<Array<Learning_TopicWhereInput>>;
  OR?: InputMaybe<Array<Learning_TopicWhereInput>>;
  assignments?: InputMaybe<Learning_AssignmentListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  match?: InputMaybe<MatchRelationFilter>;
  matchId?: InputMaybe<IntNullableFilter>;
  name?: InputMaybe<StringFilter>;
  notes?: InputMaybe<Learning_NoteListRelationFilter>;
  pupil?: InputMaybe<PupilRelationFilter>;
  pupilId?: InputMaybe<IntFilter>;
  subject?: InputMaybe<Enumcourse_Subject_EnumFilter>;
};

export type Lecture = {
  __typename?: 'Lecture';
  _count?: Maybe<LectureCount>;
  appointmentType: Lecture_Appointmenttype_Enum;
  createdAt: Scalars['DateTime'];
  declinedBy: Array<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  duration: Scalars['Int'];
  id: Scalars['Int'];
  instructorId?: Maybe<Scalars['Int']>;
  isCanceled?: Maybe<Scalars['Boolean']>;
  isInstructor: Scalars['Boolean'];
  isOrganizer: Scalars['Boolean'];
  isParticipant: Scalars['Boolean'];
  joinedBy: Array<Scalars['String']>;
  match?: Maybe<Match>;
  matchId?: Maybe<Scalars['Int']>;
  organizerIds: Array<Scalars['String']>;
  organizers: Array<Organizer>;
  override_meeting_link?: Maybe<Scalars['String']>;
  participantIds: Array<Scalars['String']>;
  participants?: Maybe<Array<AppointmentParticipant>>;
  position: Scalars['Int'];
  start: Scalars['DateTime'];
  subcourse?: Maybe<Subcourse>;
  subcourseId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  total: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  zoomMeeting?: Maybe<Scalars['JSON']>;
  zoomMeetingId?: Maybe<Scalars['String']>;
  zoomMeetingPassword?: Maybe<Scalars['String']>;
  zoomMeetingReport: Array<Scalars['JSON']>;
  zoomMeetingUrl?: Maybe<Scalars['String']>;
};


export type LectureIsInstructorArgs = {
  studentId?: InputMaybe<Scalars['Float']>;
};


export type LectureIsOrganizerArgs = {
  studentId?: InputMaybe<Scalars['Float']>;
};


export type LectureOrganizersArgs = {
  skip: Scalars['Int'];
  take: Scalars['Int'];
};


export type LectureParticipantsArgs = {
  skip: Scalars['Int'];
  take: Scalars['Int'];
};

export type LectureCount = {
  __typename?: 'LectureCount';
  course_attendance_log: Scalars['Int'];
};


export type LectureCountCourse_Attendance_LogArgs = {
  where?: InputMaybe<Course_Attendance_LogWhereInput>;
};

export type LectureListRelationFilter = {
  every?: InputMaybe<LectureWhereInput>;
  none?: InputMaybe<LectureWhereInput>;
  some?: InputMaybe<LectureWhereInput>;
};

export type LectureOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type LectureOrderByWithRelationInput = {
  appointmentType?: InputMaybe<SortOrder>;
  course_attendance_log?: InputMaybe<Course_Attendance_LogOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  declinedBy?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  duration?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  instructorId?: InputMaybe<SortOrderInput>;
  isCanceled?: InputMaybe<SortOrderInput>;
  joinedBy?: InputMaybe<SortOrder>;
  match?: InputMaybe<MatchOrderByWithRelationInput>;
  matchId?: InputMaybe<SortOrderInput>;
  organizerIds?: InputMaybe<SortOrder>;
  override_meeting_link?: InputMaybe<SortOrderInput>;
  participantIds?: InputMaybe<SortOrder>;
  start?: InputMaybe<SortOrder>;
  student?: InputMaybe<StudentOrderByWithRelationInput>;
  subcourse?: InputMaybe<SubcourseOrderByWithRelationInput>;
  subcourseId?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  zoomMeetingId?: InputMaybe<SortOrderInput>;
  zoomMeetingReport?: InputMaybe<SortOrder>;
};

export type LectureRelationFilter = {
  is?: InputMaybe<LectureWhereInput>;
  isNot?: InputMaybe<LectureWhereInput>;
};

export enum LectureScalarFieldEnum {
  AppointmentType = 'appointmentType',
  CreatedAt = 'createdAt',
  DeclinedBy = 'declinedBy',
  Description = 'description',
  Duration = 'duration',
  Id = 'id',
  InstructorId = 'instructorId',
  IsCanceled = 'isCanceled',
  JoinedBy = 'joinedBy',
  MatchId = 'matchId',
  OrganizerIds = 'organizerIds',
  OverrideMeetingLink = 'override_meeting_link',
  ParticipantIds = 'participantIds',
  Start = 'start',
  SubcourseId = 'subcourseId',
  Title = 'title',
  UpdatedAt = 'updatedAt',
  ZoomMeetingId = 'zoomMeetingId',
  ZoomMeetingReport = 'zoomMeetingReport'
}

export type LectureWhereInput = {
  AND?: InputMaybe<Array<LectureWhereInput>>;
  NOT?: InputMaybe<Array<LectureWhereInput>>;
  OR?: InputMaybe<Array<LectureWhereInput>>;
  appointmentType?: InputMaybe<Enumlecture_Appointmenttype_EnumFilter>;
  course_attendance_log?: InputMaybe<Course_Attendance_LogListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  declinedBy?: InputMaybe<StringNullableListFilter>;
  description?: InputMaybe<StringNullableFilter>;
  duration?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  instructorId?: InputMaybe<IntNullableFilter>;
  isCanceled?: InputMaybe<BoolNullableFilter>;
  joinedBy?: InputMaybe<StringNullableListFilter>;
  match?: InputMaybe<MatchRelationFilter>;
  matchId?: InputMaybe<IntNullableFilter>;
  organizerIds?: InputMaybe<StringNullableListFilter>;
  override_meeting_link?: InputMaybe<StringNullableFilter>;
  participantIds?: InputMaybe<StringNullableListFilter>;
  start?: InputMaybe<DateTimeFilter>;
  student?: InputMaybe<StudentRelationFilter>;
  subcourse?: InputMaybe<SubcourseRelationFilter>;
  subcourseId?: InputMaybe<IntNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  zoomMeetingId?: InputMaybe<StringNullableFilter>;
  zoomMeetingReport?: InputMaybe<JsonNullableListFilter>;
};

export type LectureWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

/** Fields that can be generated for a lesson plan */
export enum LessonPlanField {
  AgendaExercises = 'AGENDA_EXERCISES',
  Assessment = 'ASSESSMENT',
  Homework = 'HOMEWORK',
  LearningGoal = 'LEARNING_GOAL',
  Resources = 'RESOURCES',
  Title = 'TITLE'
}

export type LessonPlanOutput = {
  __typename?: 'LessonPlanOutput';
  agendaExercises?: Maybe<Scalars['String']>;
  assessment?: Maybe<Scalars['String']>;
  duration: Scalars['Int'];
  grade: Scalars['String'];
  homework?: Maybe<Scalars['String']>;
  learningGoal?: Maybe<Scalars['String']>;
  resources?: Maybe<Scalars['String']>;
  subject: CourseSubjectEnum;
  title?: Maybe<Scalars['String']>;
};

export type Log = {
  __typename?: 'Log';
  createdAt: Scalars['DateTime'];
  data: Scalars['String'];
  id: Scalars['Int'];
  logtype: Log_Logtype_Enum;
  userID?: Maybe<Scalars['String']>;
};

export type Match = {
  __typename?: 'Match';
  _count?: Maybe<MatchCount>;
  appointments: Array<Lecture>;
  appointmentsCount: Scalars['Int'];
  chat?: Maybe<Chat>;
  createdAt: Scalars['DateTime'];
  didHaveMeeting: Scalars['Boolean'];
  dissolveReasons: Array<Dissolve_Reason>;
  dissolved: Scalars['Boolean'];
  dissolvedAt?: Maybe<Scalars['DateTime']>;
  dissolvedBy?: Maybe<Dissolved_By_Enum>;
  feedbackToPupilMail: Scalars['Boolean'];
  feedbackToStudentMail: Scalars['Boolean'];
  firstAppointmentId?: Maybe<Scalars['Int']>;
  followUpToPupilMail: Scalars['Boolean'];
  followUpToStudentMail: Scalars['Boolean'];
  id: Scalars['Int'];
  lastAppointmentId?: Maybe<Scalars['Int']>;
  matchPool?: Maybe<Scalars['String']>;
  matchPoolRunId?: Maybe<Scalars['Int']>;
  otherDissolveReason?: Maybe<Scalars['String']>;
  proposedTime?: Maybe<Scalars['DateTime']>;
  pupil: Pupil;
  pupilFirstMatchRequest?: Maybe<Scalars['DateTime']>;
  pupilId?: Maybe<Scalars['Int']>;
  student: Student;
  studentFirstMatchRequest?: Maybe<Scalars['DateTime']>;
  studentId?: Maybe<Scalars['Int']>;
  subjectsFormatted: Array<Subject>;
  topics: Array<Learning_Topic>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['String'];
};


export type MatchAppointmentsArgs = {
  cursor?: InputMaybe<Scalars['Float']>;
  direction?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Float']>;
  take?: InputMaybe<Scalars['Float']>;
};

export type MatchCount = {
  __typename?: 'MatchCount';
  learning_topics: Scalars['Int'];
  lecture: Scalars['Int'];
};


export type MatchCountLearning_TopicsArgs = {
  where?: InputMaybe<Learning_TopicWhereInput>;
};


export type MatchCountLectureArgs = {
  where?: InputMaybe<LectureWhereInput>;
};

export type MatchDissolveInput = {
  dissolveReasons: Array<Dissolve_Reason>;
  matchId: Scalars['Int'];
  otherDissolveReason?: InputMaybe<Scalars['String']>;
};

export type MatchListRelationFilter = {
  every?: InputMaybe<MatchWhereInput>;
  none?: InputMaybe<MatchWhereInput>;
  some?: InputMaybe<MatchWhereInput>;
};

export type MatchOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MatchOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  didHaveMeeting?: InputMaybe<SortOrder>;
  dissolveReasons?: InputMaybe<SortOrder>;
  dissolved?: InputMaybe<SortOrder>;
  dissolvedAt?: InputMaybe<SortOrderInput>;
  dissolvedBy?: InputMaybe<SortOrderInput>;
  feedbackToPupilMail?: InputMaybe<SortOrder>;
  feedbackToStudentMail?: InputMaybe<SortOrder>;
  followUpToPupilMail?: InputMaybe<SortOrder>;
  followUpToStudentMail?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  learning_topics?: InputMaybe<Learning_TopicOrderByRelationAggregateInput>;
  lecture?: InputMaybe<LectureOrderByRelationAggregateInput>;
  matchPool?: InputMaybe<SortOrderInput>;
  matchPoolRun?: InputMaybe<Match_Pool_RunOrderByWithRelationInput>;
  matchPoolRunId?: InputMaybe<SortOrderInput>;
  otherDissolveReason?: InputMaybe<SortOrderInput>;
  proposedTime?: InputMaybe<SortOrderInput>;
  pupil?: InputMaybe<PupilOrderByWithRelationInput>;
  pupilFirstMatchRequest?: InputMaybe<SortOrderInput>;
  pupilId?: InputMaybe<SortOrderInput>;
  student?: InputMaybe<StudentOrderByWithRelationInput>;
  studentFirstMatchRequest?: InputMaybe<SortOrderInput>;
  studentId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  uuid?: InputMaybe<SortOrder>;
};

export type MatchPool = {
  __typename?: 'MatchPool';
  automatic?: Maybe<MatchPoolAutomatic>;
  confirmInterest?: Maybe<Scalars['Boolean']>;
  confirmationRequestsToSend: Scalars['Int'];
  name: Scalars['String'];
  needsScreening?: Maybe<Scalars['Boolean']>;
  pupilsToMatch: Array<Pupil>;
  pupilsToMatchCount: Scalars['Int'];
  pupilsToRequestInterest: Array<Pupil>;
  pupilsToScreen: Array<Pupil>;
  runs: Array<Match_Pool_Run>;
  screeningInvitationsToSend: Scalars['Int'];
  statistics: StatisticType;
  studentsToMatch: Array<Student>;
  studentsToMatchCount: Scalars['Int'];
  toggles: Array<Scalars['String']>;
};


export type MatchPoolPupilsToMatchArgs = {
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Float']>;
  take?: InputMaybe<Scalars['Float']>;
  toggles?: InputMaybe<Array<Scalars['String']>>;
};


export type MatchPoolPupilsToMatchCountArgs = {
  toggles?: InputMaybe<Array<Scalars['String']>>;
};


export type MatchPoolStudentsToMatchArgs = {
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Float']>;
  take?: InputMaybe<Scalars['Float']>;
  toggles?: InputMaybe<Array<Scalars['String']>>;
};


export type MatchPoolStudentsToMatchCountArgs = {
  toggles?: InputMaybe<Array<Scalars['String']>>;
};

export type MatchPoolAutomatic = {
  __typename?: 'MatchPoolAutomatic';
  minPupils: Scalars['Float'];
  minStudents: Scalars['Float'];
};

export type MatchPoolRunResult = {
  __typename?: 'MatchPoolRunResult';
  matches: Array<TemporaryMatch>;
  stats: MatchingStats;
  timing: MatchingTiming;
};

export type MatchRelationFilter = {
  is?: InputMaybe<MatchWhereInput>;
  isNot?: InputMaybe<MatchWhereInput>;
};

export type MatchReportInput = {
  description: Scalars['String'];
  matchId: Scalars['Int'];
};

export enum MatchScalarFieldEnum {
  CreatedAt = 'createdAt',
  DidHaveMeeting = 'didHaveMeeting',
  DissolveReasons = 'dissolveReasons',
  Dissolved = 'dissolved',
  DissolvedAt = 'dissolvedAt',
  DissolvedBy = 'dissolvedBy',
  FeedbackToPupilMail = 'feedbackToPupilMail',
  FeedbackToStudentMail = 'feedbackToStudentMail',
  FollowUpToPupilMail = 'followUpToPupilMail',
  FollowUpToStudentMail = 'followUpToStudentMail',
  Id = 'id',
  MatchPool = 'matchPool',
  MatchPoolRunId = 'matchPoolRunId',
  OtherDissolveReason = 'otherDissolveReason',
  ProposedTime = 'proposedTime',
  PupilFirstMatchRequest = 'pupilFirstMatchRequest',
  PupilId = 'pupilId',
  StudentFirstMatchRequest = 'studentFirstMatchRequest',
  StudentId = 'studentId',
  UpdatedAt = 'updatedAt',
  Uuid = 'uuid'
}

export type MatchWhereInput = {
  AND?: InputMaybe<Array<MatchWhereInput>>;
  NOT?: InputMaybe<Array<MatchWhereInput>>;
  OR?: InputMaybe<Array<MatchWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  didHaveMeeting?: InputMaybe<BoolFilter>;
  dissolveReasons?: InputMaybe<Enumdissolve_ReasonNullableListFilter>;
  dissolved?: InputMaybe<BoolFilter>;
  dissolvedAt?: InputMaybe<DateTimeNullableFilter>;
  dissolvedBy?: InputMaybe<Enumdissolved_By_EnumNullableFilter>;
  feedbackToPupilMail?: InputMaybe<BoolFilter>;
  feedbackToStudentMail?: InputMaybe<BoolFilter>;
  followUpToPupilMail?: InputMaybe<BoolFilter>;
  followUpToStudentMail?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  learning_topics?: InputMaybe<Learning_TopicListRelationFilter>;
  lecture?: InputMaybe<LectureListRelationFilter>;
  matchPool?: InputMaybe<StringNullableFilter>;
  matchPoolRun?: InputMaybe<Match_Pool_RunRelationFilter>;
  matchPoolRunId?: InputMaybe<IntNullableFilter>;
  otherDissolveReason?: InputMaybe<StringNullableFilter>;
  proposedTime?: InputMaybe<DateTimeNullableFilter>;
  pupil?: InputMaybe<PupilRelationFilter>;
  pupilFirstMatchRequest?: InputMaybe<DateTimeNullableFilter>;
  pupilId?: InputMaybe<IntNullableFilter>;
  student?: InputMaybe<StudentRelationFilter>;
  studentFirstMatchRequest?: InputMaybe<DateTimeNullableFilter>;
  studentId?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type MatchWhereUniqueInput = {
  UQ_MATCH?: InputMaybe<MatchUq_MatchCompoundUniqueInput>;
  id?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['String']>;
};

export type Match_Pool_Run = {
  __typename?: 'Match_pool_run';
  _count?: Maybe<Match_Pool_RunCount>;
  id: Scalars['Int'];
  matchesCreated: Scalars['Int'];
  matchingPool: Scalars['String'];
  runAt: Scalars['DateTime'];
  stats: Scalars['JSON'];
};

export type Match_Pool_RunCount = {
  __typename?: 'Match_pool_runCount';
  matches: Scalars['Int'];
};


export type Match_Pool_RunCountMatchesArgs = {
  where?: InputMaybe<MatchWhereInput>;
};

export type Match_Pool_RunOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  matches?: InputMaybe<MatchOrderByRelationAggregateInput>;
  matchesCreated?: InputMaybe<SortOrder>;
  matchingPool?: InputMaybe<SortOrder>;
  runAt?: InputMaybe<SortOrder>;
  stats?: InputMaybe<SortOrder>;
};

export type Match_Pool_RunRelationFilter = {
  is?: InputMaybe<Match_Pool_RunWhereInput>;
  isNot?: InputMaybe<Match_Pool_RunWhereInput>;
};

export type Match_Pool_RunWhereInput = {
  AND?: InputMaybe<Array<Match_Pool_RunWhereInput>>;
  NOT?: InputMaybe<Array<Match_Pool_RunWhereInput>>;
  OR?: InputMaybe<Array<Match_Pool_RunWhereInput>>;
  id?: InputMaybe<IntFilter>;
  matches?: InputMaybe<MatchListRelationFilter>;
  matchesCreated?: InputMaybe<IntFilter>;
  matchingPool?: InputMaybe<StringFilter>;
  runAt?: InputMaybe<DateTimeFilter>;
  stats?: InputMaybe<JsonFilter>;
};

export type MatchingStats = {
  __typename?: 'MatchingStats';
  averageWaitingDaysMatchedHelpee?: Maybe<Scalars['Float']>;
  edgeCount?: Maybe<Scalars['Float']>;
  helpeeCount?: Maybe<Scalars['Float']>;
  helperCount?: Maybe<Scalars['Float']>;
  matchCount?: Maybe<Scalars['Float']>;
  matchingCost?: Maybe<Scalars['Float']>;
  mostWaitingDaysUnmatchedHelpee?: Maybe<Scalars['Float']>;
  numberOfCoveredSubjects?: Maybe<Scalars['Float']>;
  numberOfMatchingEdgesWithMatchingState?: Maybe<Scalars['Float']>;
  numberOfOfferedSubjects?: Maybe<Scalars['Float']>;
  numberOfUncoveredSubjects?: Maybe<Scalars['Float']>;
  subjectStats: Array<MatchingSubjectNameStats>;
};

export type MatchingSubjectNameStats = {
  __typename?: 'MatchingSubjectNameStats';
  name: Scalars['String'];
  stats: MatchingSubjectStats;
};

export type MatchingSubjectStats = {
  __typename?: 'MatchingSubjectStats';
  fulfilledRequests: Scalars['Float'];
  offered: Scalars['Float'];
  requested: Scalars['Float'];
  requestedMandatory: Scalars['Float'];
};

export type MatchingTiming = {
  __typename?: 'MatchingTiming';
  commit: Scalars['Float'];
  matching: Scalars['Float'];
  preparation: Scalars['Float'];
};

export type MeUpdateInput = {
  firstname?: InputMaybe<Scalars['String']>;
  lastTimeCheckedNotifications?: InputMaybe<Scalars['DateTime']>;
  lastname?: InputMaybe<Scalars['String']>;
  notificationPreferences?: InputMaybe<PreferencesInput>;
  pupil?: InputMaybe<PupilUpdateInput>;
  student?: InputMaybe<StudentUpdateInput>;
};

export type MedianTimeToMatch = {
  __typename?: 'MedianTimeToMatch';
  median_days_pupil: Scalars['Float'];
  median_days_student: Scalars['Float'];
};

export type Message_Translation = {
  __typename?: 'Message_translation';
  id: Scalars['Int'];
  language: Message_Translation_Language_Enum;
  navigateTo?: Maybe<Scalars['String']>;
  notificationId?: Maybe<Scalars['Int']>;
  sampleMessage: NotificationMessage;
  template?: Maybe<Scalars['JSON']>;
};

export type Message_TranslationCreateManyNotificationInput = {
  id?: InputMaybe<Scalars['Int']>;
  language?: InputMaybe<Message_Translation_Language_Enum>;
  navigateTo?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['JSON']>;
};

export type Message_TranslationCreateManyNotificationInputEnvelope = {
  data: Array<Message_TranslationCreateManyNotificationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type Message_TranslationCreateNestedManyWithoutNotificationInput = {
  connect?: InputMaybe<Array<Message_TranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Message_TranslationCreateOrConnectWithoutNotificationInput>>;
  create?: InputMaybe<Array<Message_TranslationCreateWithoutNotificationInput>>;
  createMany?: InputMaybe<Message_TranslationCreateManyNotificationInputEnvelope>;
};

export type Message_TranslationCreateOrConnectWithoutNotificationInput = {
  create: Message_TranslationCreateWithoutNotificationInput;
  where: Message_TranslationWhereUniqueInput;
};

export type Message_TranslationCreateWithoutNotificationInput = {
  language?: InputMaybe<Message_Translation_Language_Enum>;
  navigateTo?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['JSON']>;
};

export type Message_TranslationListRelationFilter = {
  every?: InputMaybe<Message_TranslationWhereInput>;
  none?: InputMaybe<Message_TranslationWhereInput>;
  some?: InputMaybe<Message_TranslationWhereInput>;
};

export type Message_TranslationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type Message_TranslationScalarWhereInput = {
  AND?: InputMaybe<Array<Message_TranslationScalarWhereInput>>;
  NOT?: InputMaybe<Array<Message_TranslationScalarWhereInput>>;
  OR?: InputMaybe<Array<Message_TranslationScalarWhereInput>>;
  id?: InputMaybe<IntFilter>;
  language?: InputMaybe<Enummessage_Translation_Language_EnumFilter>;
  navigateTo?: InputMaybe<StringNullableFilter>;
  notificationId?: InputMaybe<IntNullableFilter>;
  template?: InputMaybe<JsonNullableFilter>;
};

export type Message_TranslationUpdateManyMutationInput = {
  language?: InputMaybe<Enummessage_Translation_Language_EnumFieldUpdateOperationsInput>;
  navigateTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  template?: InputMaybe<Scalars['JSON']>;
};

export type Message_TranslationUpdateManyWithWhereWithoutNotificationInput = {
  data: Message_TranslationUpdateManyMutationInput;
  where: Message_TranslationScalarWhereInput;
};

export type Message_TranslationUpdateManyWithoutNotificationNestedInput = {
  connect?: InputMaybe<Array<Message_TranslationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<Message_TranslationCreateOrConnectWithoutNotificationInput>>;
  create?: InputMaybe<Array<Message_TranslationCreateWithoutNotificationInput>>;
  createMany?: InputMaybe<Message_TranslationCreateManyNotificationInputEnvelope>;
  delete?: InputMaybe<Array<Message_TranslationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<Message_TranslationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<Message_TranslationWhereUniqueInput>>;
  set?: InputMaybe<Array<Message_TranslationWhereUniqueInput>>;
  update?: InputMaybe<Array<Message_TranslationUpdateWithWhereUniqueWithoutNotificationInput>>;
  updateMany?: InputMaybe<Array<Message_TranslationUpdateManyWithWhereWithoutNotificationInput>>;
  upsert?: InputMaybe<Array<Message_TranslationUpsertWithWhereUniqueWithoutNotificationInput>>;
};

export type Message_TranslationUpdateWithWhereUniqueWithoutNotificationInput = {
  data: Message_TranslationUpdateWithoutNotificationInput;
  where: Message_TranslationWhereUniqueInput;
};

export type Message_TranslationUpdateWithoutNotificationInput = {
  language?: InputMaybe<Enummessage_Translation_Language_EnumFieldUpdateOperationsInput>;
  navigateTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  template?: InputMaybe<Scalars['JSON']>;
};

export type Message_TranslationUpsertWithWhereUniqueWithoutNotificationInput = {
  create: Message_TranslationCreateWithoutNotificationInput;
  update: Message_TranslationUpdateWithoutNotificationInput;
  where: Message_TranslationWhereUniqueInput;
};

export type Message_TranslationWhereInput = {
  AND?: InputMaybe<Array<Message_TranslationWhereInput>>;
  NOT?: InputMaybe<Array<Message_TranslationWhereInput>>;
  OR?: InputMaybe<Array<Message_TranslationWhereInput>>;
  id?: InputMaybe<IntFilter>;
  language?: InputMaybe<Enummessage_Translation_Language_EnumFilter>;
  navigateTo?: InputMaybe<StringNullableFilter>;
  notification?: InputMaybe<NotificationRelationFilter>;
  notificationId?: InputMaybe<IntNullableFilter>;
  template?: InputMaybe<JsonNullableFilter>;
};

export type Message_TranslationWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _actionTakenAt?: Maybe<Scalars['JSON']>;
  _clearFilestore: Scalars['Boolean'];
  _executeJob: Scalars['Boolean'];
  _getRateLimits: Scalars['String'];
  _resetRateLimits: Scalars['Boolean'];
  _userActionTaken: Scalars['Boolean'];
  _verifyEmail: Scalars['Boolean'];
  achievementTemplateActivate: Scalars['Boolean'];
  achievementTemplateCreate: Scalars['Int'];
  achievementTemplateDeactivate: Scalars['Boolean'];
  achievementTemplateUpdate: Scalars['Boolean'];
  addPupilScreenings: Scalars['Boolean'];
  adminIncreasePupilGrades: Scalars['Boolean'];
  appointmentAddZoomMeeting: Scalars['Boolean'];
  appointmentCancel: Scalars['Boolean'];
  appointmentDecline: Scalars['Boolean'];
  appointmentDeleteZoomMeeting: Scalars['Boolean'];
  appointmentGroupCreate: Scalars['Boolean'];
  appointmentMatchCreate: Scalars['Boolean'];
  appointmentOverrideMeetingLink: Scalars['Boolean'];
  appointmentSaveMeetingReport: Scalars['Boolean'];
  appointmentTrackJoin: Scalars['Boolean'];
  appointmentUpdate: Scalars['Boolean'];
  appointmentZoomLinkGet: Scalars['String'];
  appointmentsGroupCreate: Scalars['Boolean'];
  appointmentsMatchCreate: Scalars['Boolean'];
  certificateOfConductCreate: Scalars['Boolean'];
  certificateOfConductUpdate: Scalars['Boolean'];
  chatDeactivate: Scalars['Boolean'];
  chatReactivate: Scalars['Boolean'];
  concreteNotificationBulkCreate: Scalars['Boolean'];
  concreteNotificationCancel: Scalars['Boolean'];
  concreteNotificationCancelDraft: Scalars['Boolean'];
  concreteNotificationPublishDraft: Scalars['Boolean'];
  concreteNotificationReschedule: Scalars['Boolean'];
  contactChatCreate: Scalars['String'];
  cooperationCreate: Scalars['Boolean'];
  courseAddInstructor: Scalars['Boolean'];
  courseAllow: Scalars['Boolean'];
  courseCreate: Course;
  courseDelete: Scalars['Boolean'];
  courseDeleteInstructor: Scalars['Boolean'];
  courseDeny: Scalars['Boolean'];
  courseEdit: Course;
  courseMarkShared: Course;
  courseSetImage: Scalars['Boolean'];
  courseSetTags: Scalars['Boolean'];
  courseSubmit: Scalars['Boolean'];
  courseTagActivate: Scalars['Boolean'];
  courseTagCreate: Course_Tag;
  courseTagDelete: Course_Tag;
  createCookieSession: Scalars['Boolean'];
  createManyImportant_information: AffectedRowsOutput;
  createOneImportant_information: Important_Information;
  deleteManyImportant_information: AffectedRowsOutput;
  deleteOneImportant_information?: Maybe<Important_Information>;
  generateLessonPlan: LessonPlanOutput;
  instantCertificateCreate: Scalars['String'];
  isEmailAvailable: Scalars['Boolean'];
  learningAssignmentCreate: Learning_Assignment;
  learningAssignmentFinish: Scalars['Boolean'];
  learningAssignmentPropose: Scalars['String'];
  learningNoteChangeType: Scalars['Boolean'];
  learningNoteCreate: Learning_Note;
  learningTopicCreate: Learning_Topic;
  loginPassword: Scalars['Boolean'];
  loginPasswordLegacy: Scalars['Boolean'];
  loginRefresh: Scalars['Boolean'];
  loginToken: Scalars['Boolean'];
  loginWithSSO: SsoAuthStatus;
  logout: Scalars['Boolean'];
  markAchievementAsSeen: Scalars['Boolean'];
  matchAdd: Scalars['Boolean'];
  matchChatCreate: Scalars['String'];
  matchCreateAdHocMeeting?: Maybe<AdHocMeeting>;
  matchDissolve: Scalars['Boolean'];
  matchPoolRun: MatchPoolRunResult;
  matchReactivate: Scalars['Boolean'];
  matchReport: Scalars['Boolean'];
  meActivate: Scalars['Boolean'];
  meBecomeInstructor: Scalars['Boolean'];
  meBecomeParticipant: Scalars['Boolean'];
  meBecomeStatePupil: Scalars['Boolean'];
  meBecomeTutee: Scalars['Boolean'];
  meBecomeTutor: Scalars['Boolean'];
  meChangeEmail: Scalars['Boolean'];
  meDeactivate: Scalars['Boolean'];
  meRegisterPupil: Pupil;
  meRegisterStudent: Student;
  meUpdate: Scalars['Boolean'];
  notificationActivate: Scalars['Boolean'];
  notificationBulkActionRun: Scalars['Boolean'];
  notificationCreate: Notification;
  notificationDelete: Scalars['Boolean'];
  notificationSetMessageTranslation: Scalars['Boolean'];
  notificationUpdate: Scalars['Boolean'];
  participantChatCreate: Scalars['String'];
  participationCertificateAsPDF: Scalars['String'];
  participationCertificateCreate: Scalars['Boolean'];
  participationCertificateNotify: Scalars['Boolean'];
  participationCertificateSign: Scalars['Boolean'];
  participationCertificateUpdate: Scalars['Boolean'];
  passwordCreate: Scalars['Boolean'];
  prospectChatCreate: Scalars['String'];
  pupilActivate: Scalars['Boolean'];
  pupilCreateMatchRequest: Scalars['Boolean'];
  pupilCreateScreening: Scalars['Boolean'];
  pupilDeactivate: Scalars['Boolean'];
  pupilDeleteMatchRequest: Scalars['Boolean'];
  pupilInvalidateScreening: Scalars['Boolean'];
  pupilMissedScreening: Scalars['Boolean'];
  pupilRegisterPlusMany: Array<PupilRegisterPlusManyOutput>;
  pupilUpdate: Scalars['Boolean'];
  pupilUpdateScreening: Scalars['Boolean'];
  pupilUpdateSubjects: Scalars['Boolean'];
  screenerActivate: Scalars['Boolean'];
  screenerAllowScreening: Scalars['Boolean'];
  screenerCreate: Scalars['String'];
  screenerSuggest: Scalars['Boolean'];
  screenerTrust: Scalars['Boolean'];
  studentCancelCoC: Scalars['Boolean'];
  studentCreateMatchRequest: Scalars['Boolean'];
  studentCreateZoomUser: Scalars['JSON'];
  studentDeactivate: Scalars['Boolean'];
  studentDeleteMatchRequest: Scalars['Boolean'];
  studentDeleteZoomUser: Scalars['Boolean'];
  studentGetRemissionRequestAsPDF: Scalars['String'];
  studentInstructorScreeningCreate: Scalars['Boolean'];
  studentInstructorScreeningUpdate: Scalars['Boolean'];
  studentReactivate: Scalars['Boolean'];
  studentRegisterPlusMany: Array<StudentRegisterPlusManyOutput>;
  studentRequestCoC: Scalars['Boolean'];
  studentRequireOnboarding: Scalars['Boolean'];
  studentTutorScreeningCreate: Scalars['Boolean'];
  studentTutorScreeningUpdate: Scalars['Boolean'];
  studentUpdate: Scalars['Boolean'];
  subcourseAddInstructor: Scalars['Boolean'];
  subcourseCancel: Scalars['Boolean'];
  subcourseCreate: Subcourse;
  subcourseDelete: Scalars['Boolean'];
  subcourseDeleteInstructor: Scalars['Boolean'];
  subcourseEdit: Subcourse;
  subcourseFill: Scalars['Boolean'];
  subcourseGroupChatCreate: Scalars['String'];
  subcourseJoin: Scalars['Boolean'];
  subcourseJoinAsMentor: Scalars['Boolean'];
  subcourseJoinFromProspects: Scalars['Boolean'];
  subcourseJoinFromWaitinglist: Scalars['Boolean'];
  subcourseJoinManual: Scalars['Boolean'];
  subcourseJoinWaitinglist: Scalars['Boolean'];
  subcourseLeave: Scalars['Boolean'];
  subcourseLeaveWaitinglist: Scalars['Boolean'];
  subcourseMentorLeave: Scalars['Boolean'];
  subcourseNotifyInstructor: Scalars['Boolean'];
  subcourseNotifyParticipants: Scalars['Boolean'];
  subcoursePromote: Scalars['Boolean'];
  subcoursePublish: Scalars['Boolean'];
  suggestSessionToken: Scalars['String'];
  tokenCreate: Scalars['String'];
  tokenCreateAdmin: Scalars['String'];
  tokenRequest: Scalars['Boolean'];
  tokenRevoke: Scalars['Boolean'];
  tutoringInterestConfirm: Scalars['Boolean'];
  tutoringInterestCreate: Scalars['Boolean'];
  tutoringInterestRefuse: Scalars['Boolean'];
  tutoringInterestRequest: Scalars['Boolean'];
  updateManyImportant_information: AffectedRowsOutput;
  updateOneImportant_information?: Maybe<Important_Information>;
  upsertOneImportant_information: Important_Information;
  userContactSupport: Scalars['Boolean'];
  userDetermineLoginOptions: Scalars['String'];
  userPushSubcriptionAdd: Scalars['Boolean'];
  userPushSubcriptionRemove: Scalars['Boolean'];
  userSendAppFeedback: Scalars['Boolean'];
};


export type Mutation_ActionTakenAtArgs = {
  action: Scalars['String'];
  at: Scalars['DateTime'];
  context: Scalars['JSON'];
  dryRun: Scalars['Boolean'];
  noDuplicates?: InputMaybe<Scalars['Boolean']>;
  userID: Scalars['String'];
};


export type Mutation_ExecuteJobArgs = {
  job: Scalars['String'];
};


export type Mutation_UserActionTakenArgs = {
  action: Scalars['String'];
  userID: Scalars['String'];
};


export type Mutation_VerifyEmailArgs = {
  userID: Scalars['String'];
};


export type MutationAchievementTemplateActivateArgs = {
  achievementTemplateId: Scalars['Int'];
};


export type MutationAchievementTemplateCreateArgs = {
  data: AchievementTemplateCreateInput;
};


export type MutationAchievementTemplateDeactivateArgs = {
  achievementTemplateId: Scalars['Int'];
};


export type MutationAchievementTemplateUpdateArgs = {
  achievementTemplateId: Scalars['Int'];
  update: AchievementTemplateUpdateInput;
};


export type MutationAddPupilScreeningsArgs = {
  matchPool: Scalars['String'];
  toSendCount: Scalars['Float'];
};


export type MutationAppointmentAddZoomMeetingArgs = {
  appointmentId: Scalars['Int'];
};


export type MutationAppointmentCancelArgs = {
  appointmentId: Scalars['Float'];
};


export type MutationAppointmentDeclineArgs = {
  appointmentId: Scalars['Float'];
};


export type MutationAppointmentDeleteZoomMeetingArgs = {
  appointmentId: Scalars['Float'];
};


export type MutationAppointmentGroupCreateArgs = {
  appointment: AppointmentCreateGroupInput;
};


export type MutationAppointmentMatchCreateArgs = {
  appointment: AppointmentCreateMatchInput;
};


export type MutationAppointmentOverrideMeetingLinkArgs = {
  lectureWhere: LectureWhereInput;
  overrideLink: Scalars['String'];
};


export type MutationAppointmentSaveMeetingReportArgs = {
  appointmentId: Scalars['Float'];
};


export type MutationAppointmentTrackJoinArgs = {
  appointmentId: Scalars['Float'];
};


export type MutationAppointmentUpdateArgs = {
  appointmentToBeUpdated: AppointmentUpdateInput;
};


export type MutationAppointmentZoomLinkGetArgs = {
  appointmentId: Scalars['Float'];
};


export type MutationAppointmentsGroupCreateArgs = {
  appointments: Array<AppointmentCreateGroupInput>;
  subcourseId: Scalars['Float'];
};


export type MutationAppointmentsMatchCreateArgs = {
  appointments: Array<AppointmentCreateMatchInput>;
  matchId: Scalars['Float'];
};


export type MutationCertificateOfConductCreateArgs = {
  criminalRecords: Scalars['Boolean'];
  dateOfInspection: Scalars['DateTime'];
  dateOfIssue: Scalars['DateTime'];
  studentId: Scalars['Float'];
};


export type MutationCertificateOfConductUpdateArgs = {
  criminalRecord: Scalars['Boolean'];
  dateOfInspection: Scalars['DateTime'];
  dateOfIssue: Scalars['DateTime'];
  studentId: Scalars['Float'];
};


export type MutationChatDeactivateArgs = {
  conversationId: Scalars['String'];
};


export type MutationChatReactivateArgs = {
  conversationId: Scalars['String'];
};


export type MutationConcreteNotificationBulkCreateArgs = {
  context: Scalars['JSON'];
  notificationId: Scalars['Int'];
  skipDraft: Scalars['Boolean'];
  startAt: Scalars['DateTime'];
  userIds: Array<Scalars['String']>;
};


export type MutationConcreteNotificationCancelArgs = {
  id: Scalars['Float'];
};


export type MutationConcreteNotificationCancelDraftArgs = {
  contextID: Scalars['String'];
  notificationId: Scalars['Int'];
};


export type MutationConcreteNotificationPublishDraftArgs = {
  contextID: Scalars['String'];
  notificationId: Scalars['Int'];
};


export type MutationConcreteNotificationRescheduleArgs = {
  id: Scalars['Float'];
  sendAt: Scalars['DateTime'];
};


export type MutationContactChatCreateArgs = {
  contactUserId: Scalars['String'];
};


export type MutationCooperationCreateArgs = {
  data: CreateCooperationInput;
};


export type MutationCourseAddInstructorArgs = {
  courseId: Scalars['Float'];
  studentId: Scalars['Float'];
};


export type MutationCourseAllowArgs = {
  courseId: Scalars['Float'];
  screeningComment?: InputMaybe<Scalars['String']>;
};


export type MutationCourseCreateArgs = {
  course: PublicCourseCreateInput;
  studentId?: InputMaybe<Scalars['Float']>;
};


export type MutationCourseDeleteArgs = {
  courseId: Scalars['Float'];
};


export type MutationCourseDeleteInstructorArgs = {
  courseId: Scalars['Float'];
  studentId: Scalars['Float'];
};


export type MutationCourseDenyArgs = {
  courseId: Scalars['Float'];
  screeningComment?: InputMaybe<Scalars['String']>;
};


export type MutationCourseEditArgs = {
  course: PublicCourseEditInput;
  courseId: Scalars['Float'];
};


export type MutationCourseMarkSharedArgs = {
  courseId: Scalars['Float'];
  shared: Scalars['Boolean'];
};


export type MutationCourseSetImageArgs = {
  courseId: Scalars['Float'];
  fileId: Scalars['String'];
};


export type MutationCourseSetTagsArgs = {
  courseId: Scalars['Float'];
  courseTagIds: Array<Scalars['Float']>;
};


export type MutationCourseSubmitArgs = {
  courseId: Scalars['Float'];
};


export type MutationCourseTagActivateArgs = {
  active: Scalars['Boolean'];
  courseTagId: Scalars['Float'];
};


export type MutationCourseTagCreateArgs = {
  data: CourseTagCreateInput;
};


export type MutationCourseTagDeleteArgs = {
  courseTagId: Scalars['Float'];
};


export type MutationCreateManyImportant_InformationArgs = {
  data: Array<Important_InformationCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateOneImportant_InformationArgs = {
  data: Important_InformationCreateInput;
};


export type MutationDeleteManyImportant_InformationArgs = {
  where?: InputMaybe<Important_InformationWhereInput>;
};


export type MutationDeleteOneImportant_InformationArgs = {
  where: Important_InformationWhereUniqueInput;
};


export type MutationGenerateLessonPlanArgs = {
  data: GenerateLessonPlanInput;
};


export type MutationInstantCertificateCreateArgs = {
  lang: Scalars['String'];
};


export type MutationIsEmailAvailableArgs = {
  email: Scalars['String'];
};


export type MutationLearningAssignmentCreateArgs = {
  task: Scalars['String'];
  topicId: Scalars['Int'];
};


export type MutationLearningAssignmentFinishArgs = {
  assignmentId: Scalars['Int'];
};


export type MutationLearningAssignmentProposeArgs = {
  topicId: Scalars['Int'];
};


export type MutationLearningNoteChangeTypeArgs = {
  noteId: Scalars['Int'];
  type: Scalars['String'];
};


export type MutationLearningNoteCreateArgs = {
  note: LearningNoteCreateInput;
};


export type MutationLearningTopicCreateArgs = {
  matchId: Scalars['Int'];
  name: Scalars['String'];
  subject: Scalars['String'];
};


export type MutationLoginPasswordArgs = {
  deviceId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationLoginPasswordLegacyArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationLoginTokenArgs = {
  deviceId?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


export type MutationLoginWithSsoArgs = {
  code: Scalars['String'];
  referrer: Scalars['String'];
};


export type MutationMarkAchievementAsSeenArgs = {
  achievementId: Scalars['Float'];
};


export type MutationMatchAddArgs = {
  poolName: Scalars['String'];
  pupilId: Scalars['Float'];
  studentId: Scalars['Float'];
};


export type MutationMatchChatCreateArgs = {
  matcheeUserId: Scalars['String'];
};


export type MutationMatchCreateAdHocMeetingArgs = {
  matchId: Scalars['Int'];
};


export type MutationMatchDissolveArgs = {
  info: MatchDissolveInput;
};


export type MutationMatchPoolRunArgs = {
  apply: Scalars['Boolean'];
  name: Scalars['String'];
  toggles?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationMatchReactivateArgs = {
  matchId: Scalars['Int'];
};


export type MutationMatchReportArgs = {
  report: MatchReportInput;
};


export type MutationMeBecomeInstructorArgs = {
  data?: InputMaybe<BecomeInstructorInput>;
  studentId?: InputMaybe<Scalars['Float']>;
};


export type MutationMeBecomeParticipantArgs = {
  pupilId?: InputMaybe<Scalars['Float']>;
};


export type MutationMeBecomeStatePupilArgs = {
  data: BecomeStatePupilInput;
  pupilId?: InputMaybe<Scalars['Float']>;
};


export type MutationMeBecomeTuteeArgs = {
  data: BecomeTuteeInput;
  pupilId?: InputMaybe<Scalars['Float']>;
};


export type MutationMeBecomeTutorArgs = {
  data?: InputMaybe<BecomeTutorInput>;
  studentId?: InputMaybe<Scalars['Float']>;
};


export type MutationMeChangeEmailArgs = {
  email: Scalars['String'];
};


export type MutationMeDeactivateArgs = {
  reason?: InputMaybe<Scalars['String']>;
};


export type MutationMeRegisterPupilArgs = {
  data: RegisterPupilInput;
  noEmail?: InputMaybe<Scalars['Boolean']>;
};


export type MutationMeRegisterStudentArgs = {
  data: RegisterStudentInput;
  noEmail?: InputMaybe<Scalars['Boolean']>;
};


export type MutationMeUpdateArgs = {
  update: MeUpdateInput;
};


export type MutationNotificationActivateArgs = {
  active: Scalars['Boolean'];
  notificationId: Scalars['Float'];
};


export type MutationNotificationBulkActionRunArgs = {
  apply: Scalars['Boolean'];
  id: Scalars['String'];
};


export type MutationNotificationCreateArgs = {
  notification: NotificationCreateInput;
};


export type MutationNotificationDeleteArgs = {
  notificationId: Scalars['Int'];
};


export type MutationNotificationSetMessageTranslationArgs = {
  body: Scalars['String'];
  headline: Scalars['String'];
  language?: InputMaybe<Scalars['String']>;
  modalText?: InputMaybe<Scalars['String']>;
  navigateTo: Scalars['String'];
  notificationId: Scalars['Float'];
};


export type MutationNotificationUpdateArgs = {
  notificationId: Scalars['Float'];
  update: NotificationUpdateInput;
};


export type MutationParticipantChatCreateArgs = {
  memberUserId: Scalars['String'];
  subcourseId: Scalars['Float'];
};


export type MutationParticipationCertificateAsPdfArgs = {
  language: Scalars['String'];
  uuid: Scalars['String'];
};


export type MutationParticipationCertificateCreateArgs = {
  certificateData: CertificateCreationInput;
  matchId: Scalars['String'];
};


export type MutationParticipationCertificateNotifyArgs = {
  certificateId: Scalars['String'];
};


export type MutationParticipationCertificateSignArgs = {
  certificateId: Scalars['String'];
  signatureLocation: Scalars['String'];
  signatureParent?: InputMaybe<Scalars['String']>;
  signaturePupil?: InputMaybe<Scalars['String']>;
};


export type MutationParticipationCertificateUpdateArgs = {
  certificateId: Scalars['String'];
  data: CertificateUpdateInput;
};


export type MutationPasswordCreateArgs = {
  password: Scalars['String'];
};


export type MutationProspectChatCreateArgs = {
  instructorUserId: Scalars['String'];
  subcourseId: Scalars['Float'];
};


export type MutationPupilActivateArgs = {
  pupilId: Scalars['Float'];
};


export type MutationPupilCreateMatchRequestArgs = {
  pupilId?: InputMaybe<Scalars['Float']>;
};


export type MutationPupilCreateScreeningArgs = {
  pupilId: Scalars['Float'];
  silent?: InputMaybe<Scalars['Boolean']>;
};


export type MutationPupilDeactivateArgs = {
  pupilId: Scalars['Float'];
};


export type MutationPupilDeleteMatchRequestArgs = {
  pupilId?: InputMaybe<Scalars['Float']>;
};


export type MutationPupilInvalidateScreeningArgs = {
  pupilScreeningId: Scalars['Float'];
};


export type MutationPupilMissedScreeningArgs = {
  comment: Scalars['String'];
  pupilScreeningId: Scalars['Float'];
};


export type MutationPupilRegisterPlusManyArgs = {
  data: PupilRegisterPlusManyInput;
};


export type MutationPupilUpdateArgs = {
  data: PupilUpdateInput;
  pupilId?: InputMaybe<Scalars['Float']>;
};


export type MutationPupilUpdateScreeningArgs = {
  data: PupilScreeningUpdateInput;
  pupilScreeningId: Scalars['Float'];
};


export type MutationPupilUpdateSubjectsArgs = {
  data: PupilUpdateSubjectsInput;
  pupilId: Scalars['Float'];
};


export type MutationScreenerActivateArgs = {
  active: Scalars['Boolean'];
  screenerId: Scalars['Float'];
};


export type MutationScreenerAllowScreeningArgs = {
  courses: Scalars['Boolean'];
  pupils: Scalars['Boolean'];
  screenerId: Scalars['Float'];
  students: Scalars['Boolean'];
};


export type MutationScreenerCreateArgs = {
  data: ScreenerCreateInput;
};


export type MutationScreenerSuggestArgs = {
  suggestionNotificationId: Scalars['Int'];
  userID: Scalars['String'];
};


export type MutationScreenerTrustArgs = {
  screenerId: Scalars['Float'];
  trusted: Scalars['Boolean'];
};


export type MutationStudentCancelCoCArgs = {
  studentId: Scalars['Float'];
};


export type MutationStudentCreateMatchRequestArgs = {
  studentId?: InputMaybe<Scalars['Float']>;
};


export type MutationStudentCreateZoomUserArgs = {
  studentId: Scalars['Float'];
};


export type MutationStudentDeactivateArgs = {
  studentId: Scalars['Float'];
};


export type MutationStudentDeleteMatchRequestArgs = {
  studentId?: InputMaybe<Scalars['Float']>;
};


export type MutationStudentDeleteZoomUserArgs = {
  studentId: Scalars['Float'];
};


export type MutationStudentInstructorScreeningCreateArgs = {
  screening: Instructor_ScreeningCreateInput;
  skipCoC?: InputMaybe<Scalars['Boolean']>;
  studentId: Scalars['Float'];
};


export type MutationStudentInstructorScreeningUpdateArgs = {
  data: ScreeningUpdateInput;
  screeningId: Scalars['Float'];
};


export type MutationStudentReactivateArgs = {
  reason: Scalars['String'];
  studentId: Scalars['Float'];
};


export type MutationStudentRegisterPlusManyArgs = {
  data: StudentRegisterPlusManyInput;
};


export type MutationStudentRequestCoCArgs = {
  studentId: Scalars['Float'];
};


export type MutationStudentRequireOnboardingArgs = {
  studentId: Scalars['Float'];
};


export type MutationStudentTutorScreeningCreateArgs = {
  screening: Instructor_ScreeningCreateInput;
  studentId: Scalars['Float'];
};


export type MutationStudentTutorScreeningUpdateArgs = {
  data: ScreeningUpdateInput;
  screeningId: Scalars['Float'];
};


export type MutationStudentUpdateArgs = {
  data: StudentUpdateInput;
  studentId?: InputMaybe<Scalars['Float']>;
};


export type MutationSubcourseAddInstructorArgs = {
  studentId: Scalars['Float'];
  subcourseId: Scalars['Float'];
};


export type MutationSubcourseCancelArgs = {
  subcourseId: Scalars['Float'];
};


export type MutationSubcourseCreateArgs = {
  courseId: Scalars['Float'];
  studentId?: InputMaybe<Scalars['Float']>;
  subcourse: PublicSubcourseCreateInput;
};


export type MutationSubcourseDeleteArgs = {
  subcourseId: Scalars['Float'];
};


export type MutationSubcourseDeleteInstructorArgs = {
  studentId: Scalars['Float'];
  subcourseId: Scalars['Float'];
};


export type MutationSubcourseEditArgs = {
  subcourse: PublicSubcourseEditInput;
  subcourseId: Scalars['Float'];
};


export type MutationSubcourseFillArgs = {
  subcourseId: Scalars['Float'];
};


export type MutationSubcourseGroupChatCreateArgs = {
  groupChatType: Scalars['String'];
  subcourseId: Scalars['Float'];
};


export type MutationSubcourseJoinArgs = {
  pupilId?: InputMaybe<Scalars['Float']>;
  subcourseId: Scalars['Float'];
};


export type MutationSubcourseJoinAsMentorArgs = {
  studentId?: InputMaybe<Scalars['Float']>;
  subcourseId: Scalars['Float'];
};


export type MutationSubcourseJoinFromProspectsArgs = {
  pupilId: Scalars['Float'];
  subcourseId: Scalars['Float'];
};


export type MutationSubcourseJoinFromWaitinglistArgs = {
  pupilId: Scalars['Float'];
  subcourseId: Scalars['Float'];
};


export type MutationSubcourseJoinManualArgs = {
  pupilId: Scalars['Float'];
  subcourseId: Scalars['Float'];
};


export type MutationSubcourseJoinWaitinglistArgs = {
  pupilId?: InputMaybe<Scalars['Float']>;
  subcourseId: Scalars['Float'];
};


export type MutationSubcourseLeaveArgs = {
  pupilId?: InputMaybe<Scalars['Float']>;
  subcourseId: Scalars['Float'];
};


export type MutationSubcourseLeaveWaitinglistArgs = {
  pupilId?: InputMaybe<Scalars['Float']>;
  subcourseId: Scalars['Float'];
};


export type MutationSubcourseMentorLeaveArgs = {
  studentId?: InputMaybe<Scalars['Float']>;
  subcourseId: Scalars['Float'];
};


export type MutationSubcourseNotifyInstructorArgs = {
  body: Scalars['String'];
  fileIDs: Array<Scalars['String']>;
  subcourseId: Scalars['Int'];
  title: Scalars['String'];
};


export type MutationSubcourseNotifyParticipantsArgs = {
  body: Scalars['String'];
  fileIDs: Array<Scalars['String']>;
  participantIDs: Array<Scalars['Int']>;
  subcourseId: Scalars['Int'];
  title: Scalars['String'];
};


export type MutationSubcoursePromoteArgs = {
  subcourseId: Scalars['Float'];
};


export type MutationSubcoursePublishArgs = {
  subcourseId: Scalars['Float'];
};


export type MutationTokenCreateArgs = {
  description?: InputMaybe<Scalars['String']>;
  deviceId?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
};


export type MutationTokenCreateAdminArgs = {
  description?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type MutationTokenRequestArgs = {
  action?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  redirectTo?: InputMaybe<Scalars['String']>;
};


export type MutationTokenRevokeArgs = {
  id?: InputMaybe<Scalars['Float']>;
  invalidateSessions: Scalars['Boolean'];
  token?: InputMaybe<Scalars['String']>;
};


export type MutationTutoringInterestConfirmArgs = {
  token: Scalars['String'];
};


export type MutationTutoringInterestCreateArgs = {
  pupilId: Scalars['Float'];
  status: Scalars['String'];
};


export type MutationTutoringInterestRefuseArgs = {
  token: Scalars['String'];
};


export type MutationTutoringInterestRequestArgs = {
  pupilId: Scalars['Float'];
};


export type MutationUpdateManyImportant_InformationArgs = {
  data: Important_InformationUpdateManyMutationInput;
  where?: InputMaybe<Important_InformationWhereInput>;
};


export type MutationUpdateOneImportant_InformationArgs = {
  data: Important_InformationUpdateInput;
  where: Important_InformationWhereUniqueInput;
};


export type MutationUpsertOneImportant_InformationArgs = {
  create: Important_InformationCreateInput;
  update: Important_InformationUpdateInput;
  where: Important_InformationWhereUniqueInput;
};


export type MutationUserContactSupportArgs = {
  message: SupportMessage;
};


export type MutationUserDetermineLoginOptionsArgs = {
  email: Scalars['String'];
};


export type MutationUserPushSubcriptionAddArgs = {
  subscription: CreatePushSubscriptionInput;
};


export type MutationUserPushSubcriptionRemoveArgs = {
  subscriptionID: Scalars['Int'];
};


export type MutationUserSendAppFeedbackArgs = {
  message: AppFeedback;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type NestedBytesNullableFilter = {
  equals?: InputMaybe<Scalars['Byte']>;
  in?: InputMaybe<Array<Scalars['Byte']>>;
  not?: InputMaybe<NestedBytesNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Byte']>>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedDecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']>;
  gt?: InputMaybe<Scalars['Decimal']>;
  gte?: InputMaybe<Scalars['Decimal']>;
  in?: InputMaybe<Array<Scalars['Decimal']>>;
  lt?: InputMaybe<Scalars['Decimal']>;
  lte?: InputMaybe<Scalars['Decimal']>;
  not?: InputMaybe<NestedDecimalFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']>>;
};

export type NestedEnumachievement_Action_Type_EnumNullableFilter = {
  equals?: InputMaybe<Achievement_Action_Type_Enum>;
  in?: InputMaybe<Array<Achievement_Action_Type_Enum>>;
  not?: InputMaybe<NestedEnumachievement_Action_Type_EnumNullableFilter>;
  notIn?: InputMaybe<Array<Achievement_Action_Type_Enum>>;
};

export type NestedEnumachievement_Template_For_EnumFilter = {
  equals?: InputMaybe<Achievement_Template_For_Enum>;
  in?: InputMaybe<Array<Achievement_Template_For_Enum>>;
  not?: InputMaybe<NestedEnumachievement_Template_For_EnumFilter>;
  notIn?: InputMaybe<Array<Achievement_Template_For_Enum>>;
};

export type NestedEnumachievement_Type_EnumFilter = {
  equals?: InputMaybe<Achievement_Type_Enum>;
  in?: InputMaybe<Array<Achievement_Type_Enum>>;
  not?: InputMaybe<NestedEnumachievement_Type_EnumFilter>;
  notIn?: InputMaybe<Array<Achievement_Type_Enum>>;
};

export type NestedEnumchat_TypeFilter = {
  equals?: InputMaybe<Chat_Type>;
  in?: InputMaybe<Array<Chat_Type>>;
  not?: InputMaybe<NestedEnumchat_TypeFilter>;
  notIn?: InputMaybe<Array<Chat_Type>>;
};

export type NestedEnumcourse_Category_EnumFilter = {
  equals?: InputMaybe<Course_Category_Enum>;
  in?: InputMaybe<Array<Course_Category_Enum>>;
  not?: InputMaybe<NestedEnumcourse_Category_EnumFilter>;
  notIn?: InputMaybe<Array<Course_Category_Enum>>;
};

export type NestedEnumcourse_Coursestate_EnumFilter = {
  equals?: InputMaybe<Course_Coursestate_Enum>;
  in?: InputMaybe<Array<Course_Coursestate_Enum>>;
  not?: InputMaybe<NestedEnumcourse_Coursestate_EnumFilter>;
  notIn?: InputMaybe<Array<Course_Coursestate_Enum>>;
};

export type NestedEnumcourse_Subject_EnumFilter = {
  equals?: InputMaybe<Course_Subject_Enum>;
  in?: InputMaybe<Array<Course_Subject_Enum>>;
  not?: InputMaybe<NestedEnumcourse_Subject_EnumFilter>;
  notIn?: InputMaybe<Array<Course_Subject_Enum>>;
};

export type NestedEnumcourse_Subject_EnumNullableFilter = {
  equals?: InputMaybe<Course_Subject_Enum>;
  in?: InputMaybe<Array<Course_Subject_Enum>>;
  not?: InputMaybe<NestedEnumcourse_Subject_EnumNullableFilter>;
  notIn?: InputMaybe<Array<Course_Subject_Enum>>;
};

export type NestedEnumdissolved_By_EnumNullableFilter = {
  equals?: InputMaybe<Dissolved_By_Enum>;
  in?: InputMaybe<Array<Dissolved_By_Enum>>;
  not?: InputMaybe<NestedEnumdissolved_By_EnumNullableFilter>;
  notIn?: InputMaybe<Array<Dissolved_By_Enum>>;
};

export type NestedEnumgender_EnumNullableFilter = {
  equals?: InputMaybe<Gender_Enum>;
  in?: InputMaybe<Array<Gender_Enum>>;
  not?: InputMaybe<NestedEnumgender_EnumNullableFilter>;
  notIn?: InputMaybe<Array<Gender_Enum>>;
};

export type NestedEnumimportant_Information_Language_EnumFilter = {
  equals?: InputMaybe<Important_Information_Language_Enum>;
  in?: InputMaybe<Array<Important_Information_Language_Enum>>;
  not?: InputMaybe<NestedEnumimportant_Information_Language_EnumFilter>;
  notIn?: InputMaybe<Array<Important_Information_Language_Enum>>;
};

export type NestedEnumimportant_Information_Language_EnumWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumimportant_Information_Language_EnumFilter>;
  _min?: InputMaybe<NestedEnumimportant_Information_Language_EnumFilter>;
  equals?: InputMaybe<Important_Information_Language_Enum>;
  in?: InputMaybe<Array<Important_Information_Language_Enum>>;
  not?: InputMaybe<NestedEnumimportant_Information_Language_EnumWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Important_Information_Language_Enum>>;
};

export type NestedEnumimportant_Information_Recipients_EnumFilter = {
  equals?: InputMaybe<Important_Information_Recipients_Enum>;
  in?: InputMaybe<Array<Important_Information_Recipients_Enum>>;
  not?: InputMaybe<NestedEnumimportant_Information_Recipients_EnumFilter>;
  notIn?: InputMaybe<Array<Important_Information_Recipients_Enum>>;
};

export type NestedEnumimportant_Information_Recipients_EnumWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumimportant_Information_Recipients_EnumFilter>;
  _min?: InputMaybe<NestedEnumimportant_Information_Recipients_EnumFilter>;
  equals?: InputMaybe<Important_Information_Recipients_Enum>;
  in?: InputMaybe<Array<Important_Information_Recipients_Enum>>;
  not?: InputMaybe<NestedEnumimportant_Information_Recipients_EnumWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Important_Information_Recipients_Enum>>;
};

export type NestedEnumlearning_Assignment_StatusFilter = {
  equals?: InputMaybe<Learning_Assignment_Status>;
  in?: InputMaybe<Array<Learning_Assignment_Status>>;
  not?: InputMaybe<NestedEnumlearning_Assignment_StatusFilter>;
  notIn?: InputMaybe<Array<Learning_Assignment_Status>>;
};

export type NestedEnumlearning_Note_TypeFilter = {
  equals?: InputMaybe<Learning_Note_Type>;
  in?: InputMaybe<Array<Learning_Note_Type>>;
  not?: InputMaybe<NestedEnumlearning_Note_TypeFilter>;
  notIn?: InputMaybe<Array<Learning_Note_Type>>;
};

export type NestedEnumlecture_Appointmenttype_EnumFilter = {
  equals?: InputMaybe<Lecture_Appointmenttype_Enum>;
  in?: InputMaybe<Array<Lecture_Appointmenttype_Enum>>;
  not?: InputMaybe<NestedEnumlecture_Appointmenttype_EnumFilter>;
  notIn?: InputMaybe<Array<Lecture_Appointmenttype_Enum>>;
};

export type NestedEnummessage_Translation_Language_EnumFilter = {
  equals?: InputMaybe<Message_Translation_Language_Enum>;
  in?: InputMaybe<Array<Message_Translation_Language_Enum>>;
  not?: InputMaybe<NestedEnummessage_Translation_Language_EnumFilter>;
  notIn?: InputMaybe<Array<Message_Translation_Language_Enum>>;
};

export type NestedEnumnotification_Sender_EnumNullableFilter = {
  equals?: InputMaybe<Notification_Sender_Enum>;
  in?: InputMaybe<Array<Notification_Sender_Enum>>;
  not?: InputMaybe<NestedEnumnotification_Sender_EnumNullableFilter>;
  notIn?: InputMaybe<Array<Notification_Sender_Enum>>;
};

export type NestedEnumnotification_Type_EnumFilter = {
  equals?: InputMaybe<Notification_Type_Enum>;
  in?: InputMaybe<Array<Notification_Type_Enum>>;
  not?: InputMaybe<NestedEnumnotification_Type_EnumFilter>;
  notIn?: InputMaybe<Array<Notification_Type_Enum>>;
};

export type NestedEnumpupil_Email_Owner_EnumFilter = {
  equals?: InputMaybe<Pupil_Email_Owner_Enum>;
  in?: InputMaybe<Array<Pupil_Email_Owner_Enum>>;
  not?: InputMaybe<NestedEnumpupil_Email_Owner_EnumFilter>;
  notIn?: InputMaybe<Array<Pupil_Email_Owner_Enum>>;
};

export type NestedEnumpupil_Learninggermansince_EnumNullableFilter = {
  equals?: InputMaybe<Pupil_Learninggermansince_Enum>;
  in?: InputMaybe<Array<Pupil_Learninggermansince_Enum>>;
  not?: InputMaybe<NestedEnumpupil_Learninggermansince_EnumNullableFilter>;
  notIn?: InputMaybe<Array<Pupil_Learninggermansince_Enum>>;
};

export type NestedEnumpupil_Registrationsource_EnumFilter = {
  equals?: InputMaybe<Pupil_Registrationsource_Enum>;
  in?: InputMaybe<Array<Pupil_Registrationsource_Enum>>;
  not?: InputMaybe<NestedEnumpupil_Registrationsource_EnumFilter>;
  notIn?: InputMaybe<Array<Pupil_Registrationsource_Enum>>;
};

export type NestedEnumpupil_Schooltype_EnumFilter = {
  equals?: InputMaybe<Pupil_Schooltype_Enum>;
  in?: InputMaybe<Array<Pupil_Schooltype_Enum>>;
  not?: InputMaybe<NestedEnumpupil_Schooltype_EnumFilter>;
  notIn?: InputMaybe<Array<Pupil_Schooltype_Enum>>;
};

export type NestedEnumpupil_Screening_Status_EnumFilter = {
  equals?: InputMaybe<Pupil_Screening_Status_Enum>;
  in?: InputMaybe<Array<Pupil_Screening_Status_Enum>>;
  not?: InputMaybe<NestedEnumpupil_Screening_Status_EnumFilter>;
  notIn?: InputMaybe<Array<Pupil_Screening_Status_Enum>>;
};

export type NestedEnumpupil_State_EnumFilter = {
  equals?: InputMaybe<Pupil_State_Enum>;
  in?: InputMaybe<Array<Pupil_State_Enum>>;
  not?: InputMaybe<NestedEnumpupil_State_EnumFilter>;
  notIn?: InputMaybe<Array<Pupil_State_Enum>>;
};

export type NestedEnumschool_Schooltype_EnumNullableFilter = {
  equals?: InputMaybe<School_Schooltype_Enum>;
  in?: InputMaybe<Array<School_Schooltype_Enum>>;
  not?: InputMaybe<NestedEnumschool_Schooltype_EnumNullableFilter>;
  notIn?: InputMaybe<Array<School_Schooltype_Enum>>;
};

export type NestedEnumschool_State_EnumFilter = {
  equals?: InputMaybe<School_State_Enum>;
  in?: InputMaybe<Array<School_State_Enum>>;
  not?: InputMaybe<NestedEnumschool_State_EnumFilter>;
  notIn?: InputMaybe<Array<School_State_Enum>>;
};

export type NestedEnumscreening_Jobstatus_EnumNullableFilter = {
  equals?: InputMaybe<Screening_Jobstatus_Enum>;
  in?: InputMaybe<Array<Screening_Jobstatus_Enum>>;
  not?: InputMaybe<NestedEnumscreening_Jobstatus_EnumNullableFilter>;
  notIn?: InputMaybe<Array<Screening_Jobstatus_Enum>>;
};

export type NestedEnumstudent_Registrationsource_EnumFilter = {
  equals?: InputMaybe<Student_Registrationsource_Enum>;
  in?: InputMaybe<Array<Student_Registrationsource_Enum>>;
  not?: InputMaybe<NestedEnumstudent_Registrationsource_EnumFilter>;
  notIn?: InputMaybe<Array<Student_Registrationsource_Enum>>;
};

export type NestedEnumstudent_Screening_Status_EnumFilter = {
  equals?: InputMaybe<Student_Screening_Status_Enum>;
  in?: InputMaybe<Array<Student_Screening_Status_Enum>>;
  not?: InputMaybe<NestedEnumstudent_Screening_Status_EnumFilter>;
  notIn?: InputMaybe<Array<Student_Screening_Status_Enum>>;
};

export type NestedEnumstudent_State_EnumNullableFilter = {
  equals?: InputMaybe<Student_State_Enum>;
  in?: InputMaybe<Array<Student_State_Enum>>;
  not?: InputMaybe<NestedEnumstudent_State_EnumNullableFilter>;
  notIn?: InputMaybe<Array<Student_State_Enum>>;
};

export type NestedEnumsubcourse_Promotion_Type_EnumFilter = {
  equals?: InputMaybe<Subcourse_Promotion_Type_Enum>;
  in?: InputMaybe<Array<Subcourse_Promotion_Type_Enum>>;
  not?: InputMaybe<NestedEnumsubcourse_Promotion_Type_EnumFilter>;
  notIn?: InputMaybe<Array<Subcourse_Promotion_Type_Enum>>;
};

export type NestedFloatFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedIntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedIntFilter>;
  _min?: InputMaybe<NestedIntFilter>;
  _sum?: InputMaybe<NestedIntFilter>;
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type Notification = {
  __typename?: 'Notification';
  _count?: Maybe<NotificationCount>;
  active: Scalars['Boolean'];
  cancelledOnAction: Array<Scalars['String']>;
  delay?: Maybe<Scalars['Int']>;
  description: Scalars['String'];
  disabledChannels: Array<Notification_Channel_Enum>;
  hookDescription?: Maybe<Scalars['String']>;
  hookID?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  interval?: Maybe<Scalars['Int']>;
  mailjetTemplateId?: Maybe<Scalars['Int']>;
  /** The message translation will be rendered in the user's language with a concrete notification context to produce the message the user sees */
  messageTranslations: Array<Message_Translation>;
  onActions: Array<Scalars['String']>;
  recipient: Scalars['Int'];
  sample_context?: Maybe<Scalars['JSON']>;
  sender?: Maybe<Notification_Sender_Enum>;
  type: Notification_Type_Enum;
  /**
   * Returns an array of tuples ['nested.path', 'example value']
   * These Variables can be used inside the messages and Mailjet Templates created for this notification, like:
   *  ['user.firstname', 'Jonas'] -> Mailjet: {{var:user.firstname}}, Message: {{user.firstname}}
   * Additionally they can be set when manually sending out the concrete notification by passing in a context:
   *  { user: { firstname: 'Jeff' } }
   */
  variables: Array<Array<Scalars['String']>>;
};

export type NotificationActionType = {
  __typename?: 'NotificationActionType';
  description: Scalars['String'];
  id: Scalars['String'];
  recommendedCancelations?: Maybe<Array<Scalars['String']>>;
  sampleContext?: Maybe<Scalars['JSON']>;
};

export type NotificationCount = {
  __typename?: 'NotificationCount';
  concrete_notification: Scalars['Int'];
  message_translation: Scalars['Int'];
};


export type NotificationCountConcrete_NotificationArgs = {
  where?: InputMaybe<Concrete_NotificationWhereInput>;
};


export type NotificationCountMessage_TranslationArgs = {
  where?: InputMaybe<Message_TranslationWhereInput>;
};

export type NotificationCreateInput = {
  active: Scalars['Boolean'];
  cancelledOnAction?: InputMaybe<NotificationCreatecancelledOnActionInput>;
  concrete_notification?: InputMaybe<Concrete_NotificationCreateNestedManyWithoutNotificationInput>;
  delay?: InputMaybe<Scalars['Int']>;
  description: Scalars['String'];
  disabledChannels?: InputMaybe<NotificationCreatedisabledChannelsInput>;
  hookID?: InputMaybe<Scalars['String']>;
  interval?: InputMaybe<Scalars['Int']>;
  mailjetTemplateId?: InputMaybe<Scalars['Int']>;
  message_translation?: InputMaybe<Message_TranslationCreateNestedManyWithoutNotificationInput>;
  onActions?: InputMaybe<NotificationCreateonActionsInput>;
  recipient: Scalars['Int'];
  sample_context?: InputMaybe<Scalars['JSON']>;
  sender?: InputMaybe<Notification_Sender_Enum>;
  type?: InputMaybe<Notification_Type_Enum>;
};

export type NotificationCreatecancelledOnActionInput = {
  set: Array<Scalars['String']>;
};

export type NotificationCreatedisabledChannelsInput = {
  set: Array<Notification_Channel_Enum>;
};

export type NotificationCreateonActionsInput = {
  set: Array<Scalars['String']>;
};

export type NotificationMessage = {
  __typename?: 'NotificationMessage';
  body: Scalars['String'];
  headline: Scalars['String'];
  modalText?: Maybe<Scalars['String']>;
  navigateTo?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type NotificationOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  cancelledOnAction?: InputMaybe<SortOrder>;
  concrete_notification?: InputMaybe<Concrete_NotificationOrderByRelationAggregateInput>;
  delay?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrder>;
  disabledChannels?: InputMaybe<SortOrder>;
  hookID?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  interval?: InputMaybe<SortOrderInput>;
  mailjetTemplateId?: InputMaybe<SortOrderInput>;
  message_translation?: InputMaybe<Message_TranslationOrderByRelationAggregateInput>;
  onActions?: InputMaybe<SortOrder>;
  recipient?: InputMaybe<SortOrder>;
  sample_context?: InputMaybe<SortOrderInput>;
  sender?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
};

export type NotificationRelationFilter = {
  is?: InputMaybe<NotificationWhereInput>;
  isNot?: InputMaybe<NotificationWhereInput>;
};

export enum NotificationScalarFieldEnum {
  Active = 'active',
  CancelledOnAction = 'cancelledOnAction',
  Delay = 'delay',
  Description = 'description',
  DisabledChannels = 'disabledChannels',
  HookId = 'hookID',
  Id = 'id',
  Interval = 'interval',
  MailjetTemplateId = 'mailjetTemplateId',
  OnActions = 'onActions',
  Recipient = 'recipient',
  SampleContext = 'sample_context',
  Sender = 'sender',
  Type = 'type'
}

export type NotificationUpdateInput = {
  active?: InputMaybe<BoolFieldUpdateOperationsInput>;
  cancelledOnAction?: InputMaybe<NotificationUpdatecancelledOnActionInput>;
  concrete_notification?: InputMaybe<Concrete_NotificationUpdateManyWithoutNotificationNestedInput>;
  delay?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  disabledChannels?: InputMaybe<NotificationUpdatedisabledChannelsInput>;
  hookID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  interval?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  mailjetTemplateId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  message_translation?: InputMaybe<Message_TranslationUpdateManyWithoutNotificationNestedInput>;
  onActions?: InputMaybe<NotificationUpdateonActionsInput>;
  recipient?: InputMaybe<IntFieldUpdateOperationsInput>;
  sample_context?: InputMaybe<Scalars['JSON']>;
  sender?: InputMaybe<NullableEnumnotification_Sender_EnumFieldUpdateOperationsInput>;
  type?: InputMaybe<Enumnotification_Type_EnumFieldUpdateOperationsInput>;
};

export type NotificationUpdatecancelledOnActionInput = {
  push?: InputMaybe<Array<Scalars['String']>>;
  set?: InputMaybe<Array<Scalars['String']>>;
};

export type NotificationUpdatedisabledChannelsInput = {
  push?: InputMaybe<Array<Notification_Channel_Enum>>;
  set?: InputMaybe<Array<Notification_Channel_Enum>>;
};

export type NotificationUpdateonActionsInput = {
  push?: InputMaybe<Array<Scalars['String']>>;
  set?: InputMaybe<Array<Scalars['String']>>;
};

export type NotificationWhereInput = {
  AND?: InputMaybe<Array<NotificationWhereInput>>;
  NOT?: InputMaybe<Array<NotificationWhereInput>>;
  OR?: InputMaybe<Array<NotificationWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  cancelledOnAction?: InputMaybe<StringNullableListFilter>;
  concrete_notification?: InputMaybe<Concrete_NotificationListRelationFilter>;
  delay?: InputMaybe<IntNullableFilter>;
  description?: InputMaybe<StringFilter>;
  disabledChannels?: InputMaybe<Enumnotification_Channel_EnumNullableListFilter>;
  hookID?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  interval?: InputMaybe<IntNullableFilter>;
  mailjetTemplateId?: InputMaybe<IntNullableFilter>;
  message_translation?: InputMaybe<Message_TranslationListRelationFilter>;
  onActions?: InputMaybe<StringNullableListFilter>;
  recipient?: InputMaybe<IntFilter>;
  sample_context?: InputMaybe<JsonNullableFilter>;
  sender?: InputMaybe<Enumnotification_Sender_EnumNullableFilter>;
  type?: InputMaybe<Enumnotification_Type_EnumFilter>;
};

export type NotificationWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type NullableEnumnotification_Sender_EnumFieldUpdateOperationsInput = {
  set?: InputMaybe<Notification_Sender_Enum>;
};

export type NullableIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']>;
  divide?: InputMaybe<Scalars['Int']>;
  increment?: InputMaybe<Scalars['Int']>;
  multiply?: InputMaybe<Scalars['Int']>;
  set?: InputMaybe<Scalars['Int']>;
};

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']>;
};

export enum NullsOrder {
  First = 'first',
  Last = 'last'
}

export type Organizer = {
  __typename?: 'Organizer';
  firstname: Scalars['String'];
  id: Scalars['Int'];
  lastname: Scalars['String'];
  user: UserType;
  userID?: Maybe<Scalars['String']>;
};

export type OtherParticipant = {
  __typename?: 'OtherParticipant';
  aboutMe: Scalars['String'];
  firstname: Scalars['String'];
  grade: Scalars['String'];
  gradeAsInt: Scalars['Int'];
  id: Scalars['Int'];
};

export type Participant = {
  __typename?: 'Participant';
  aboutMe: Scalars['String'];
  firstname: Scalars['String'];
  grade: Scalars['String'];
  gradeAsInt: Scalars['Int'];
  id: Scalars['Int'];
  lastname: Scalars['String'];
  schooltype: Pupil_Schooltype_Enum;
};

export type Participation_Certificate = {
  __typename?: 'Participation_certificate';
  categories: Scalars['String'];
  certificateDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  hoursPerWeek: Scalars['Decimal'];
  hoursTotal: Scalars['Decimal'];
  id: Scalars['Int'];
  medium: Scalars['String'];
  ongoingLessons: Scalars['Boolean'];
  pupil: Pupil;
  pupilId?: Maybe<Scalars['Int']>;
  signatureDate?: Maybe<Scalars['DateTime']>;
  signatureLocation?: Maybe<Scalars['String']>;
  signatureParent?: Maybe<Scalars['Byte']>;
  signaturePupil?: Maybe<Scalars['Byte']>;
  startDate: Scalars['DateTime'];
  state: Scalars['String'];
  student: Student;
  studentId?: Maybe<Scalars['Int']>;
  subjects: Scalars['String'];
  subjectsFormatted: Array<Scalars['String']>;
  uuid: Scalars['String'];
};

export type Participation_CertificateListRelationFilter = {
  every?: InputMaybe<Participation_CertificateWhereInput>;
  none?: InputMaybe<Participation_CertificateWhereInput>;
  some?: InputMaybe<Participation_CertificateWhereInput>;
};

export type Participation_CertificateOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type Participation_CertificateWhereInput = {
  AND?: InputMaybe<Array<Participation_CertificateWhereInput>>;
  NOT?: InputMaybe<Array<Participation_CertificateWhereInput>>;
  OR?: InputMaybe<Array<Participation_CertificateWhereInput>>;
  categories?: InputMaybe<StringFilter>;
  certificateDate?: InputMaybe<DateTimeFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  hoursPerWeek?: InputMaybe<DecimalFilter>;
  hoursTotal?: InputMaybe<DecimalFilter>;
  id?: InputMaybe<IntFilter>;
  medium?: InputMaybe<StringFilter>;
  ongoingLessons?: InputMaybe<BoolFilter>;
  pupil?: InputMaybe<PupilRelationFilter>;
  pupilId?: InputMaybe<IntNullableFilter>;
  signatureDate?: InputMaybe<DateTimeNullableFilter>;
  signatureLocation?: InputMaybe<StringNullableFilter>;
  signatureParent?: InputMaybe<BytesNullableFilter>;
  signaturePupil?: InputMaybe<BytesNullableFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
  state?: InputMaybe<StringFilter>;
  student?: InputMaybe<StudentRelationFilter>;
  studentId?: InputMaybe<IntNullableFilter>;
  subjects?: InputMaybe<StringFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export type PreferencesInput = {
  advice?: InputMaybe<ChannelInput>;
  alternative?: InputMaybe<ChannelInput>;
  announcement?: InputMaybe<ChannelInput>;
  appointment?: InputMaybe<ChannelInput>;
  call?: InputMaybe<ChannelInput>;
  chat?: InputMaybe<ChannelInput>;
  event?: InputMaybe<ChannelInput>;
  news?: InputMaybe<ChannelInput>;
  request?: InputMaybe<ChannelInput>;
  suggestion?: InputMaybe<ChannelInput>;
  survey?: InputMaybe<ChannelInput>;
};

export type ProspectParticipant = {
  __typename?: 'ProspectParticipant';
  aboutMe: Scalars['String'];
  conversationId: Scalars['String'];
  firstname: Scalars['String'];
  grade: Scalars['String'];
  gradeAsInt: Scalars['Int'];
  id: Scalars['Int'];
  lastname: Scalars['String'];
  schooltype: Pupil_Schooltype_Enum;
};

export type PublicCourseCreateInput = {
  allowContact: Scalars['Boolean'];
  category: CourseCategory;
  description: Scalars['String'];
  name: Scalars['String'];
  outline: Scalars['String'];
  schooltype?: InputMaybe<Course_Schooltype_Enum>;
  subject?: InputMaybe<Course_Subject_Enum>;
};

export type PublicCourseEditInput = {
  allowContact?: InputMaybe<Scalars['Boolean']>;
  category?: InputMaybe<CourseCategory>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  outline?: InputMaybe<Scalars['String']>;
  schooltype?: InputMaybe<Course_Schooltype_Enum>;
  subject?: InputMaybe<Course_Subject_Enum>;
};

export type PublicLectureInput = {
  duration: Scalars['Int'];
  instructorId?: InputMaybe<Scalars['Int']>;
  start: Scalars['DateTime'];
};

export type PublicSubcourseCreateInput = {
  allowChatContactParticipants?: InputMaybe<Scalars['Boolean']>;
  allowChatContactProspects?: InputMaybe<Scalars['Boolean']>;
  groupChatType?: InputMaybe<Chat_Type>;
  joinAfterStart: Scalars['Boolean'];
  lectures?: InputMaybe<Array<PublicLectureInput>>;
  maxGrade: Scalars['Int'];
  maxParticipants: Scalars['Int'];
  minGrade: Scalars['Int'];
};

export type PublicSubcourseEditInput = {
  allowChatContactParticipants?: InputMaybe<Scalars['Boolean']>;
  allowChatContactProspects?: InputMaybe<Scalars['Boolean']>;
  groupChatType?: InputMaybe<Chat_Type>;
  joinAfterStart?: InputMaybe<Scalars['Boolean']>;
  maxGrade?: InputMaybe<Scalars['Int']>;
  maxParticipants?: InputMaybe<Scalars['Int']>;
  minGrade?: InputMaybe<Scalars['Int']>;
};

export type Pupil = {
  __typename?: 'Pupil';
  _count?: Maybe<PupilCount>;
  aboutMe: Scalars['String'];
  active: Scalars['Boolean'];
  canJoinSubcourses: Decision;
  canRequestMatch: Decision;
  coduToken?: Maybe<Scalars['String']>;
  concreteNotifications: Array<Concrete_Notification>;
  createdAt: Scalars['DateTime'];
  descriptionForMatch: Scalars['String'];
  descriptionForScreening: Scalars['String'];
  email: Scalars['String'];
  emailOwner: Pupil_Email_Owner_Enum;
  firstMatchRequest?: Maybe<Scalars['DateTime']>;
  firstname?: Maybe<Scalars['String']>;
  grade?: Maybe<Scalars['String']>;
  gradeAsInt: Scalars['Int'];
  gradeUpdatedAt?: Maybe<Scalars['DateTime']>;
  hasSpecialNeeds: Scalars['Boolean'];
  id: Scalars['Int'];
  isParticipant: Scalars['Boolean'];
  isPupil: Scalars['Boolean'];
  isRedacted: Scalars['Boolean'];
  languages: Array<Pupil_Languages_Enum>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastTimeCheckedNotifications?: Maybe<Scalars['DateTime']>;
  lastUpdatedSettingsViaBlocker?: Maybe<Scalars['DateTime']>;
  lastname?: Maybe<Scalars['String']>;
  learningGermanSince?: Maybe<Pupil_Learninggermansince_Enum>;
  matchReason: Scalars['String'];
  matches: Array<Match>;
  matchingPriority: Scalars['Int'];
  msg?: Maybe<Scalars['String']>;
  newsletter: Scalars['Boolean'];
  notificationPreferences?: Maybe<Scalars['JSON']>;
  onlyMatchWith?: Maybe<Gender_Enum>;
  openMatchRequestCount: Scalars['Int'];
  participationCertificatesToSign: Array<Participation_Certificate>;
  referredById?: Maybe<Scalars['String']>;
  registrationSource: Pupil_Registrationsource_Enum;
  school?: Maybe<School>;
  schoolId?: Maybe<Scalars['Int']>;
  schooltype: Pupil_Schooltype_Enum;
  screenings: Array<Pupil_Screening>;
  state: Pupil_State_Enum;
  subcoursesJoined: Array<Subcourse>;
  subcoursesWaitingList: Array<Subcourse>;
  subjects?: Maybe<Scalars['String']>;
  subjectsFormatted: Array<Subject>;
  teacherEmailAddress?: Maybe<Scalars['String']>;
  totalSubcoursesJoined: Scalars['Int'];
  tutoringInterestConfirmation?: Maybe<Pupil_Tutoring_Interest_Confirmation_Request>;
  updatedAt: Scalars['DateTime'];
  user: UserType;
  verifiedAt?: Maybe<Scalars['DateTime']>;
  wix_creation_date: Scalars['DateTime'];
  wix_id: Scalars['String'];
};


export type PupilSubcoursesJoinedArgs = {
  excludePast?: InputMaybe<Scalars['Boolean']>;
  onlyPast?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type PupilSubcoursesWaitingListArgs = {
  search?: InputMaybe<Scalars['String']>;
};

export type PupilCount = {
  __typename?: 'PupilCount';
  course_attendance_log: Scalars['Int'];
  course_participation_certificate: Scalars['Int'];
  learning_topics: Scalars['Int'];
  match: Scalars['Int'];
  participation_certificate: Scalars['Int'];
  pupil_screening: Scalars['Int'];
  pupil_tutoring_interest_confirmation_request: Scalars['Int'];
  subcourse_participants_pupil: Scalars['Int'];
  waiting_list_enrollment: Scalars['Int'];
};


export type PupilCountCourse_Attendance_LogArgs = {
  where?: InputMaybe<Course_Attendance_LogWhereInput>;
};


export type PupilCountCourse_Participation_CertificateArgs = {
  where?: InputMaybe<Course_Participation_CertificateWhereInput>;
};


export type PupilCountLearning_TopicsArgs = {
  where?: InputMaybe<Learning_TopicWhereInput>;
};


export type PupilCountMatchArgs = {
  where?: InputMaybe<MatchWhereInput>;
};


export type PupilCountParticipation_CertificateArgs = {
  where?: InputMaybe<Participation_CertificateWhereInput>;
};


export type PupilCountPupil_ScreeningArgs = {
  where?: InputMaybe<Pupil_ScreeningWhereInput>;
};


export type PupilCountPupil_Tutoring_Interest_Confirmation_RequestArgs = {
  where?: InputMaybe<Pupil_Tutoring_Interest_Confirmation_RequestWhereInput>;
};


export type PupilCountSubcourse_Participants_PupilArgs = {
  where?: InputMaybe<Subcourse_Participants_PupilWhereInput>;
};


export type PupilCountWaiting_List_EnrollmentArgs = {
  where?: InputMaybe<Waiting_List_EnrollmentWhereInput>;
};

export enum PupilEmailOwner {
  Other = 'other',
  Parent = 'parent',
  Pupil = 'pupil',
  Unknown = 'unknown'
}

export type PupilListRelationFilter = {
  every?: InputMaybe<PupilWhereInput>;
  none?: InputMaybe<PupilWhereInput>;
  some?: InputMaybe<PupilWhereInput>;
};

export type PupilOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PupilOrderByWithRelationInput = {
  aboutMe?: InputMaybe<SortOrder>;
  active?: InputMaybe<SortOrder>;
  coduToken?: InputMaybe<SortOrderInput>;
  course_attendance_log?: InputMaybe<Course_Attendance_LogOrderByRelationAggregateInput>;
  course_participation_certificate?: InputMaybe<Course_Participation_CertificateOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  descriptionForMatch?: InputMaybe<SortOrder>;
  descriptionForScreening?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  emailOwner?: InputMaybe<SortOrder>;
  firstMatchRequest?: InputMaybe<SortOrderInput>;
  firstname?: InputMaybe<SortOrderInput>;
  grade?: InputMaybe<SortOrderInput>;
  gradeUpdatedAt?: InputMaybe<SortOrderInput>;
  hasSpecialNeeds?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isParticipant?: InputMaybe<SortOrder>;
  isPupil?: InputMaybe<SortOrder>;
  isRedacted?: InputMaybe<SortOrder>;
  languages?: InputMaybe<SortOrder>;
  lastLogin?: InputMaybe<SortOrderInput>;
  lastTimeCheckedNotifications?: InputMaybe<SortOrderInput>;
  lastUpdatedSettingsViaBlocker?: InputMaybe<SortOrderInput>;
  lastname?: InputMaybe<SortOrderInput>;
  learningGermanSince?: InputMaybe<SortOrderInput>;
  learning_topics?: InputMaybe<Learning_TopicOrderByRelationAggregateInput>;
  match?: InputMaybe<MatchOrderByRelationAggregateInput>;
  matchReason?: InputMaybe<SortOrder>;
  matchingPriority?: InputMaybe<SortOrder>;
  msg?: InputMaybe<SortOrderInput>;
  newsletter?: InputMaybe<SortOrder>;
  notificationPreferences?: InputMaybe<SortOrderInput>;
  onlyMatchWith?: InputMaybe<SortOrderInput>;
  openMatchRequestCount?: InputMaybe<SortOrder>;
  participation_certificate?: InputMaybe<Participation_CertificateOrderByRelationAggregateInput>;
  pupil_screening?: InputMaybe<Pupil_ScreeningOrderByRelationAggregateInput>;
  pupil_tutoring_interest_confirmation_request?: InputMaybe<Pupil_Tutoring_Interest_Confirmation_RequestOrderByRelationAggregateInput>;
  referredById?: InputMaybe<SortOrderInput>;
  registrationSource?: InputMaybe<SortOrder>;
  school?: InputMaybe<SchoolOrderByWithRelationInput>;
  schoolId?: InputMaybe<SortOrderInput>;
  schooltype?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  subcourse_participants_pupil?: InputMaybe<Subcourse_Participants_PupilOrderByRelationAggregateInput>;
  subjects?: InputMaybe<SortOrderInput>;
  teacherEmailAddress?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  verifiedAt?: InputMaybe<SortOrderInput>;
  waiting_list_enrollment?: InputMaybe<Waiting_List_EnrollmentOrderByRelationAggregateInput>;
  wix_creation_date?: InputMaybe<SortOrder>;
  wix_id?: InputMaybe<SortOrder>;
};

export type PupilRegisterPlusInput = {
  activate?: InputMaybe<BecomeTuteeInput>;
  email: Scalars['String'];
  register?: InputMaybe<RegisterPupilInput>;
};

export type PupilRegisterPlusManyInput = {
  entries: Array<PupilRegisterPlusInput>;
};

export type PupilRegisterPlusManyOutput = {
  __typename?: 'PupilRegisterPlusManyOutput';
  email?: Maybe<Scalars['String']>;
  reason: Scalars['String'];
  success: Scalars['Boolean'];
};

export type PupilRelationFilter = {
  is?: InputMaybe<PupilWhereInput>;
  isNot?: InputMaybe<PupilWhereInput>;
};

export enum PupilScalarFieldEnum {
  AboutMe = 'aboutMe',
  Active = 'active',
  CoduToken = 'coduToken',
  CreatedAt = 'createdAt',
  DescriptionForMatch = 'descriptionForMatch',
  DescriptionForScreening = 'descriptionForScreening',
  Email = 'email',
  EmailOwner = 'emailOwner',
  FirstMatchRequest = 'firstMatchRequest',
  Firstname = 'firstname',
  Grade = 'grade',
  GradeUpdatedAt = 'gradeUpdatedAt',
  HasSpecialNeeds = 'hasSpecialNeeds',
  Id = 'id',
  IsParticipant = 'isParticipant',
  IsPupil = 'isPupil',
  IsRedacted = 'isRedacted',
  Languages = 'languages',
  LastLogin = 'lastLogin',
  LastTimeCheckedNotifications = 'lastTimeCheckedNotifications',
  LastUpdatedSettingsViaBlocker = 'lastUpdatedSettingsViaBlocker',
  Lastname = 'lastname',
  LearningGermanSince = 'learningGermanSince',
  MatchReason = 'matchReason',
  MatchingPriority = 'matchingPriority',
  Msg = 'msg',
  Newsletter = 'newsletter',
  NotificationPreferences = 'notificationPreferences',
  OnlyMatchWith = 'onlyMatchWith',
  OpenMatchRequestCount = 'openMatchRequestCount',
  ReferredById = 'referredById',
  RegistrationSource = 'registrationSource',
  SchoolId = 'schoolId',
  Schooltype = 'schooltype',
  State = 'state',
  Subjects = 'subjects',
  TeacherEmailAddress = 'teacherEmailAddress',
  UpdatedAt = 'updatedAt',
  VerifiedAt = 'verifiedAt',
  WixCreationDate = 'wix_creation_date',
  WixId = 'wix_id'
}

export enum PupilScreeningStatus {
  Dispute = 'dispute',
  Pending = 'pending',
  Rejection = 'rejection',
  Success = 'success'
}

export type PupilScreeningUpdateInput = {
  comment?: InputMaybe<Scalars['String']>;
  knowsCoronaSchoolFrom?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<PupilScreeningStatus>;
};

export type PupilUpdateInput = {
  aboutMe?: InputMaybe<Scalars['String']>;
  descriptionForMatch?: InputMaybe<Scalars['String']>;
  descriptionForScreening?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  gradeAsInt?: InputMaybe<Scalars['Int']>;
  hasSpecialNeeds?: InputMaybe<Scalars['Boolean']>;
  languages?: InputMaybe<Array<Language>>;
  lastTimeCheckedNotifications?: InputMaybe<Scalars['DateTime']>;
  lastname?: InputMaybe<Scalars['String']>;
  matchReason?: InputMaybe<Scalars['String']>;
  notificationPreferences?: InputMaybe<PreferencesInput>;
  onlyMatchWith?: InputMaybe<Gender>;
  registrationSource?: InputMaybe<RegistrationSource>;
  school?: InputMaybe<RegistrationSchool>;
  schooltype?: InputMaybe<SchoolType>;
  state?: InputMaybe<State>;
  subjects?: InputMaybe<Array<SubjectInput>>;
};

export type PupilUpdateSubjectsInput = {
  subjects?: InputMaybe<Array<SubjectInput>>;
};

export type PupilWhereInput = {
  AND?: InputMaybe<Array<PupilWhereInput>>;
  NOT?: InputMaybe<Array<PupilWhereInput>>;
  OR?: InputMaybe<Array<PupilWhereInput>>;
  aboutMe?: InputMaybe<StringFilter>;
  active?: InputMaybe<BoolFilter>;
  coduToken?: InputMaybe<StringNullableFilter>;
  course_attendance_log?: InputMaybe<Course_Attendance_LogListRelationFilter>;
  course_participation_certificate?: InputMaybe<Course_Participation_CertificateListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  descriptionForMatch?: InputMaybe<StringFilter>;
  descriptionForScreening?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  emailOwner?: InputMaybe<Enumpupil_Email_Owner_EnumFilter>;
  firstMatchRequest?: InputMaybe<DateTimeNullableFilter>;
  firstname?: InputMaybe<StringNullableFilter>;
  grade?: InputMaybe<StringNullableFilter>;
  gradeUpdatedAt?: InputMaybe<DateTimeNullableFilter>;
  hasSpecialNeeds?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  isParticipant?: InputMaybe<BoolFilter>;
  isPupil?: InputMaybe<BoolFilter>;
  isRedacted?: InputMaybe<BoolFilter>;
  languages?: InputMaybe<Enumpupil_Languages_EnumNullableListFilter>;
  lastLogin?: InputMaybe<DateTimeNullableFilter>;
  lastTimeCheckedNotifications?: InputMaybe<DateTimeNullableFilter>;
  lastUpdatedSettingsViaBlocker?: InputMaybe<DateTimeNullableFilter>;
  lastname?: InputMaybe<StringNullableFilter>;
  learningGermanSince?: InputMaybe<Enumpupil_Learninggermansince_EnumNullableFilter>;
  learning_topics?: InputMaybe<Learning_TopicListRelationFilter>;
  match?: InputMaybe<MatchListRelationFilter>;
  matchReason?: InputMaybe<StringFilter>;
  matchingPriority?: InputMaybe<IntFilter>;
  msg?: InputMaybe<StringNullableFilter>;
  newsletter?: InputMaybe<BoolFilter>;
  notificationPreferences?: InputMaybe<JsonNullableFilter>;
  onlyMatchWith?: InputMaybe<Enumgender_EnumNullableFilter>;
  openMatchRequestCount?: InputMaybe<IntFilter>;
  participation_certificate?: InputMaybe<Participation_CertificateListRelationFilter>;
  pupil_screening?: InputMaybe<Pupil_ScreeningListRelationFilter>;
  pupil_tutoring_interest_confirmation_request?: InputMaybe<Pupil_Tutoring_Interest_Confirmation_RequestListRelationFilter>;
  referredById?: InputMaybe<StringNullableFilter>;
  registrationSource?: InputMaybe<Enumpupil_Registrationsource_EnumFilter>;
  school?: InputMaybe<SchoolRelationFilter>;
  schoolId?: InputMaybe<IntNullableFilter>;
  schooltype?: InputMaybe<Enumpupil_Schooltype_EnumFilter>;
  state?: InputMaybe<Enumpupil_State_EnumFilter>;
  subcourse_participants_pupil?: InputMaybe<Subcourse_Participants_PupilListRelationFilter>;
  subjects?: InputMaybe<StringNullableFilter>;
  teacherEmailAddress?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  verifiedAt?: InputMaybe<DateTimeNullableFilter>;
  waiting_list_enrollment?: InputMaybe<Waiting_List_EnrollmentListRelationFilter>;
  wix_creation_date?: InputMaybe<DateTimeFilter>;
  wix_id?: InputMaybe<StringFilter>;
};

export type PupilWhereUniqueInput = {
  coduToken?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  wix_id?: InputMaybe<Scalars['String']>;
};

export type Pupil_Screening = {
  __typename?: 'Pupil_screening';
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  invalidated: Scalars['Boolean'];
  knowsCoronaSchoolFrom?: Maybe<Scalars['String']>;
  pupil: Pupil;
  pupilId?: Maybe<Scalars['Int']>;
  screenerIds: Array<Scalars['Int']>;
  screeners: Array<Screener>;
  status: Pupil_Screening_Status_Enum;
  updatedAt: Scalars['DateTime'];
};

export type Pupil_ScreeningListRelationFilter = {
  every?: InputMaybe<Pupil_ScreeningWhereInput>;
  none?: InputMaybe<Pupil_ScreeningWhereInput>;
  some?: InputMaybe<Pupil_ScreeningWhereInput>;
};

export type Pupil_ScreeningOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type Pupil_ScreeningOrderByWithRelationInput = {
  comment?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  invalidated?: InputMaybe<SortOrder>;
  knowsCoronaSchoolFrom?: InputMaybe<SortOrderInput>;
  pupil?: InputMaybe<PupilOrderByWithRelationInput>;
  pupilId?: InputMaybe<SortOrderInput>;
  screenerIds?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum Pupil_ScreeningScalarFieldEnum {
  Comment = 'comment',
  CreatedAt = 'createdAt',
  Id = 'id',
  Invalidated = 'invalidated',
  KnowsCoronaSchoolFrom = 'knowsCoronaSchoolFrom',
  PupilId = 'pupilId',
  ScreenerIds = 'screenerIds',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type Pupil_ScreeningWhereInput = {
  AND?: InputMaybe<Array<Pupil_ScreeningWhereInput>>;
  NOT?: InputMaybe<Array<Pupil_ScreeningWhereInput>>;
  OR?: InputMaybe<Array<Pupil_ScreeningWhereInput>>;
  comment?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  invalidated?: InputMaybe<BoolFilter>;
  knowsCoronaSchoolFrom?: InputMaybe<StringNullableFilter>;
  pupil?: InputMaybe<PupilRelationFilter>;
  pupilId?: InputMaybe<IntNullableFilter>;
  screenerIds?: InputMaybe<IntNullableListFilter>;
  status?: InputMaybe<Enumpupil_Screening_Status_EnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Pupil_ScreeningWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type Pupil_Tutoring_Interest_Confirmation_Request = {
  __typename?: 'Pupil_tutoring_interest_confirmation_request';
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  invalidated: Scalars['Boolean'];
  pupilId?: Maybe<Scalars['Int']>;
  reminderSentDate?: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
  token: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type Pupil_Tutoring_Interest_Confirmation_RequestListRelationFilter = {
  every?: InputMaybe<Pupil_Tutoring_Interest_Confirmation_RequestWhereInput>;
  none?: InputMaybe<Pupil_Tutoring_Interest_Confirmation_RequestWhereInput>;
  some?: InputMaybe<Pupil_Tutoring_Interest_Confirmation_RequestWhereInput>;
};

export type Pupil_Tutoring_Interest_Confirmation_RequestOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type Pupil_Tutoring_Interest_Confirmation_RequestWhereInput = {
  AND?: InputMaybe<Array<Pupil_Tutoring_Interest_Confirmation_RequestWhereInput>>;
  NOT?: InputMaybe<Array<Pupil_Tutoring_Interest_Confirmation_RequestWhereInput>>;
  OR?: InputMaybe<Array<Pupil_Tutoring_Interest_Confirmation_RequestWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  invalidated?: InputMaybe<BoolFilter>;
  pupil?: InputMaybe<PupilRelationFilter>;
  pupilId?: InputMaybe<IntNullableFilter>;
  reminderSentDate?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<StringFilter>;
  token?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Push_Subscription = {
  __typename?: 'Push_subscription';
  endpoint: Scalars['String'];
  expirationTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  keys: Scalars['JSON'];
  userID: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  achievementTemplates: Array<Achievement_Template>;
  aggregateImportant_information: AggregateImportant_Information;
  appointment: Lecture;
  concreteNotificationCampaign: Array<Campaign>;
  concrete_notification?: Maybe<Concrete_Notification>;
  concrete_notifications: Array<Concrete_Notification>;
  cooperations: Array<Cooperation>;
  courseImages: CourseImageSearchResponse;
  courseSearch: Array<Course>;
  courseTags: Array<Course_Tag>;
  course_tags: Array<Course_Tag>;
  courses: Array<Course>;
  externalSchoolSearch: Array<ExternalSchoolSearch>;
  findFirstImportant_information?: Maybe<Important_Information>;
  findFirstImportant_informationOrThrow?: Maybe<Important_Information>;
  getImportant_information?: Maybe<Important_Information>;
  groupByImportant_information: Array<Important_InformationGroupBy>;
  important_information?: Maybe<Important_Information>;
  important_informations: Array<Important_Information>;
  interestConfirmationRate: Scalars['Float'];
  learningAssignment: Learning_Assignment;
  learningTopic: Learning_Topic;
  lectures: Array<Lecture>;
  match: Match;
  match_pool: MatchPool;
  match_pools: Array<MatchPool>;
  matches: Array<Match>;
  me: UserType;
  myContactOptions: Array<Contact>;
  myRoles: Array<Scalars['String']>;
  notificationActions: Array<NotificationActionType>;
  notificationBulkRuns: Array<BulkRun>;
  notifications: Array<Notification>;
  otherInstructors: Array<Instructor>;
  pupil_screenings: Array<Pupil_Screening>;
  pupils: Array<Pupil>;
  pupilsToBeScreened: Array<Pupil>;
  pushPublicKey?: Maybe<Scalars['String']>;
  schools: Array<School>;
  screeners: Array<Screener>;
  statistics: Statistics;
  students: Array<Student>;
  studentsToBeScreened: Array<Student>;
  subcourse?: Maybe<Subcourse>;
  subcourseSearch: Array<Subcourse>;
  subcourses: Array<Subcourse>;
  subcoursesPublic: Array<Subcourse>;
  subjects: Array<Scalars['String']>;
  templateCourses: Array<Course>;
  usersForCampaign: Array<UserType>;
  usersSearch: Array<UserType>;
  zoomUserLicenses?: Maybe<Scalars['JSON']>;
};


export type QueryAggregateImportant_InformationArgs = {
  cursor?: InputMaybe<Important_InformationWhereUniqueInput>;
  orderBy?: InputMaybe<Array<Important_InformationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Important_InformationWhereInput>;
};


export type QueryAppointmentArgs = {
  appointmentId: Scalars['Float'];
};


export type QueryConcrete_NotificationArgs = {
  concreteNotificationId: Scalars['Int'];
};


export type QueryConcrete_NotificationsArgs = {
  cursor?: InputMaybe<Concrete_NotificationWhereUniqueInput>;
  distinct?: InputMaybe<Array<Concrete_NotificationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<Concrete_NotificationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Concrete_NotificationWhereInput>;
};


export type QueryCourseImagesArgs = {
  page: Scalars['Float'];
  search: Scalars['String'];
  take: Scalars['Float'];
};


export type QueryCourseSearchArgs = {
  search: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take: Scalars['Int'];
};


export type QueryCourseTagsArgs = {
  category: Scalars['String'];
};


export type QueryCourse_TagsArgs = {
  cursor?: InputMaybe<Course_TagWhereUniqueInput>;
  distinct?: InputMaybe<Array<Course_TagScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<Course_TagOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Course_TagWhereInput>;
};


export type QueryCoursesArgs = {
  cursor?: InputMaybe<CourseWhereUniqueInput>;
  distinct?: InputMaybe<Array<CourseScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CourseOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CourseWhereInput>;
};


export type QueryExternalSchoolSearchArgs = {
  filters: ExternalSchoolSearchFilters;
  options: ExternalSchoolSearchOptions;
};


export type QueryFindFirstImportant_InformationArgs = {
  cursor?: InputMaybe<Important_InformationWhereUniqueInput>;
  distinct?: InputMaybe<Array<Important_InformationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<Important_InformationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Important_InformationWhereInput>;
};


export type QueryFindFirstImportant_InformationOrThrowArgs = {
  cursor?: InputMaybe<Important_InformationWhereUniqueInput>;
  distinct?: InputMaybe<Array<Important_InformationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<Important_InformationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Important_InformationWhereInput>;
};


export type QueryGetImportant_InformationArgs = {
  where: Important_InformationWhereUniqueInput;
};


export type QueryGroupByImportant_InformationArgs = {
  by: Array<Important_InformationScalarFieldEnum>;
  having?: InputMaybe<Important_InformationScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<Important_InformationOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Important_InformationWhereInput>;
};


export type QueryImportant_InformationArgs = {
  where: Important_InformationWhereUniqueInput;
};


export type QueryImportant_InformationsArgs = {
  cursor?: InputMaybe<Important_InformationWhereUniqueInput>;
  distinct?: InputMaybe<Array<Important_InformationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<Important_InformationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Important_InformationWhereInput>;
};


export type QueryLearningAssignmentArgs = {
  id: Scalars['Int'];
};


export type QueryLearningTopicArgs = {
  id: Scalars['Int'];
};


export type QueryLecturesArgs = {
  cursor?: InputMaybe<LectureWhereUniqueInput>;
  distinct?: InputMaybe<Array<LectureScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LectureOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LectureWhereInput>;
};


export type QueryMatchArgs = {
  matchId: Scalars['Int'];
};


export type QueryMatch_PoolArgs = {
  name: Scalars['String'];
};


export type QueryMatchesArgs = {
  cursor?: InputMaybe<MatchWhereUniqueInput>;
  distinct?: InputMaybe<Array<MatchScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MatchOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MatchWhereInput>;
};


export type QueryNotificationsArgs = {
  cursor?: InputMaybe<NotificationWhereUniqueInput>;
  distinct?: InputMaybe<Array<NotificationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NotificationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NotificationWhereInput>;
};


export type QueryOtherInstructorsArgs = {
  search: Scalars['String'];
  skip: Scalars['Int'];
  take: Scalars['Int'];
};


export type QueryPupil_ScreeningsArgs = {
  cursor?: InputMaybe<Pupil_ScreeningWhereUniqueInput>;
  distinct?: InputMaybe<Array<Pupil_ScreeningScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<Pupil_ScreeningOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<Pupil_ScreeningWhereInput>;
};


export type QueryPupilsArgs = {
  cursor?: InputMaybe<PupilWhereUniqueInput>;
  distinct?: InputMaybe<Array<PupilScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PupilOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PupilWhereInput>;
};


export type QueryPupilsToBeScreenedArgs = {
  onlyDisputed?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySchoolsArgs = {
  cursor?: InputMaybe<SchoolWhereUniqueInput>;
  distinct?: InputMaybe<Array<SchoolScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SchoolOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SchoolWhereInput>;
};


export type QueryScreenersArgs = {
  cursor?: InputMaybe<ScreenerWhereUniqueInput>;
  distinct?: InputMaybe<Array<ScreenerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ScreenerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ScreenerWhereInput>;
};


export type QueryStatisticsArgs = {
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};


export type QueryStudentsArgs = {
  cursor?: InputMaybe<StudentWhereUniqueInput>;
  distinct?: InputMaybe<Array<StudentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<StudentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<StudentWhereInput>;
};


export type QuerySubcourseArgs = {
  subcourseId: Scalars['Int'];
};


export type QuerySubcourseSearchArgs = {
  courseStates?: InputMaybe<Array<Scalars['String']>>;
  orderBy?: InputMaybe<Scalars['String']>;
  search: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take: Scalars['Int'];
};


export type QuerySubcoursesArgs = {
  cursor?: InputMaybe<SubcourseWhereUniqueInput>;
  distinct?: InputMaybe<Array<SubcourseScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SubcourseOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SubcourseWhereInput>;
};


export type QuerySubcoursesPublicArgs = {
  excludeKnown?: InputMaybe<Scalars['Boolean']>;
  onlyJoinable?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Float']>;
  take?: InputMaybe<Scalars['Float']>;
};


export type QueryTemplateCoursesArgs = {
  search: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  studentId?: InputMaybe<Scalars['Float']>;
  take: Scalars['Int'];
};


export type QueryUsersForCampaignArgs = {
  pupilQuery?: InputMaybe<PupilWhereInput>;
  studentQuery?: InputMaybe<StudentWhereInput>;
};


export type QueryUsersSearchArgs = {
  only?: InputMaybe<Scalars['String']>;
  query: Scalars['String'];
  take?: InputMaybe<Scalars['Int']>;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type Range = {
  __typename?: 'Range';
  max: Scalars['Int'];
  min: Scalars['Int'];
};

export type RangeInput = {
  max: Scalars['Int'];
  min: Scalars['Int'];
};

export type RegisterPupilInput = {
  aboutMe?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  emailOwner: PupilEmailOwner;
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  newsletter: Scalars['Boolean'];
  redirectTo?: InputMaybe<Scalars['String']>;
  referredById?: InputMaybe<Scalars['String']>;
  registrationSource: RegistrationSource;
  school?: InputMaybe<RegistrationSchool>;
};

export type RegisterStudentInput = {
  aboutMe?: InputMaybe<Scalars['String']>;
  cooperationTag?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  newsletter: Scalars['Boolean'];
  redirectTo?: InputMaybe<Scalars['String']>;
  referredById?: InputMaybe<Scalars['String']>;
  registrationSource: RegistrationSource;
};

export type RegistrationSchool = {
  city?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  schooltype?: InputMaybe<SchoolType>;
  state?: InputMaybe<State>;
  zip?: InputMaybe<Scalars['String']>;
};

/** How the user came to Lern-Fair. The 'Cooperation' value has a special meaning, see 'state pupil' */
export enum RegistrationSource {
  Codu = 'codu',
  Cooperation = 'cooperation',
  Drehtuer = 'drehtuer',
  Normal = 'normal',
  Other = 'other',
  Plus = 'plus'
}

export type Remission_RequestOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  student?: InputMaybe<StudentOrderByWithRelationInput>;
  studentId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  uuid?: InputMaybe<SortOrder>;
};

export type Remission_RequestRelationFilter = {
  is?: InputMaybe<Remission_RequestWhereInput>;
  isNot?: InputMaybe<Remission_RequestWhereInput>;
};

export type Remission_RequestWhereInput = {
  AND?: InputMaybe<Array<Remission_RequestWhereInput>>;
  NOT?: InputMaybe<Array<Remission_RequestWhereInput>>;
  OR?: InputMaybe<Array<Remission_RequestWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  student?: InputMaybe<StudentRelationFilter>;
  studentId?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  uuid?: InputMaybe<StringFilter>;
};

export enum SsoAuthStatus {
  Error = 'error',
  Link = 'link',
  Register = 'register',
  Success = 'success'
}

export type School = {
  __typename?: 'School';
  _count?: Maybe<SchoolCount>;
  city?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name: Scalars['String'];
  schooltype?: Maybe<School_Schooltype_Enum>;
  state: School_State_Enum;
  updatedAt: Scalars['DateTime'];
  zip?: Maybe<Scalars['String']>;
};

export type SchoolCount = {
  __typename?: 'SchoolCount';
  pupil: Scalars['Int'];
};


export type SchoolCountPupilArgs = {
  where?: InputMaybe<PupilWhereInput>;
};

export type SchoolOrderByWithRelationInput = {
  city?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  pupil?: InputMaybe<PupilOrderByRelationAggregateInput>;
  schooltype?: InputMaybe<SortOrderInput>;
  state?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  zip?: InputMaybe<SortOrderInput>;
};

export type SchoolRelationFilter = {
  is?: InputMaybe<SchoolWhereInput>;
  isNot?: InputMaybe<SchoolWhereInput>;
};

export enum SchoolScalarFieldEnum {
  City = 'city',
  CreatedAt = 'createdAt',
  Email = 'email',
  Id = 'id',
  Name = 'name',
  Schooltype = 'schooltype',
  State = 'state',
  UpdatedAt = 'updatedAt',
  Zip = 'zip'
}

/** The type of school */
export enum SchoolSchoolTypeEnum {
  Berufsschule = 'berufsschule',
  FRderschule = 'f_rderschule',
  Gesamtschule = 'gesamtschule',
  Grundschule = 'grundschule',
  Gymnasium = 'gymnasium',
  Hauptschule = 'hauptschule',
  Other = 'other',
  Realschule = 'realschule'
}

export enum SchoolType {
  Berufsschule = 'berufsschule',
  FRderschule = 'f_rderschule',
  Gesamtschule = 'gesamtschule',
  Grundschule = 'grundschule',
  Gymnasium = 'gymnasium',
  Hauptschule = 'hauptschule',
  Other = 'other',
  Realschule = 'realschule'
}

export type SchoolWhereInput = {
  AND?: InputMaybe<Array<SchoolWhereInput>>;
  NOT?: InputMaybe<Array<SchoolWhereInput>>;
  OR?: InputMaybe<Array<SchoolWhereInput>>;
  city?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  pupil?: InputMaybe<PupilListRelationFilter>;
  schooltype?: InputMaybe<Enumschool_Schooltype_EnumNullableFilter>;
  state?: InputMaybe<Enumschool_State_EnumFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  zip?: InputMaybe<StringNullableFilter>;
};

export type SchoolWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
  name_state_city?: InputMaybe<SchoolNameStateCityCompoundUniqueInput>;
};

export type Screener = {
  __typename?: 'Screener';
  _count?: Maybe<ScreenerCount>;
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  firstname?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  isRedacted: Scalars['Boolean'];
  is_course_screener: Scalars['Boolean'];
  is_pupil_screener: Scalars['Boolean'];
  is_student_screener: Scalars['Boolean'];
  is_trusted: Scalars['Boolean'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastTimeCheckedNotifications?: Maybe<Scalars['DateTime']>;
  lastname?: Maybe<Scalars['String']>;
  notificationPreferences?: Maybe<Scalars['JSON']>;
  oldNumberID?: Maybe<Scalars['Int']>;
  password: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  user: UserType;
  verified?: Maybe<Scalars['Boolean']>;
  verifiedAt?: Maybe<Scalars['DateTime']>;
};

export type ScreenerCount = {
  __typename?: 'ScreenerCount';
  instructor_screening: Scalars['Int'];
  screenings: Scalars['Int'];
};


export type ScreenerCountInstructor_ScreeningArgs = {
  where?: InputMaybe<Instructor_ScreeningWhereInput>;
};


export type ScreenerCountScreeningsArgs = {
  where?: InputMaybe<ScreeningWhereInput>;
};

export type ScreenerCreateInput = {
  email: Scalars['String'];
  firstname: Scalars['String'];
  lastname: Scalars['String'];
};

export type ScreenerOrderByWithRelationInput = {
  active?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  firstname?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  instructor_screening?: InputMaybe<Instructor_ScreeningOrderByRelationAggregateInput>;
  isRedacted?: InputMaybe<SortOrder>;
  is_course_screener?: InputMaybe<SortOrder>;
  is_pupil_screener?: InputMaybe<SortOrder>;
  is_student_screener?: InputMaybe<SortOrder>;
  is_trusted?: InputMaybe<SortOrder>;
  lastLogin?: InputMaybe<SortOrderInput>;
  lastTimeCheckedNotifications?: InputMaybe<SortOrderInput>;
  lastname?: InputMaybe<SortOrderInput>;
  notificationPreferences?: InputMaybe<SortOrderInput>;
  oldNumberID?: InputMaybe<SortOrderInput>;
  password?: InputMaybe<SortOrder>;
  screenings?: InputMaybe<ScreeningOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
  verified?: InputMaybe<SortOrderInput>;
  verifiedAt?: InputMaybe<SortOrderInput>;
};

export type ScreenerRelationFilter = {
  is?: InputMaybe<ScreenerWhereInput>;
  isNot?: InputMaybe<ScreenerWhereInput>;
};

export enum ScreenerScalarFieldEnum {
  Active = 'active',
  CreatedAt = 'createdAt',
  Email = 'email',
  Firstname = 'firstname',
  Id = 'id',
  IsRedacted = 'isRedacted',
  IsCourseScreener = 'is_course_screener',
  IsPupilScreener = 'is_pupil_screener',
  IsStudentScreener = 'is_student_screener',
  IsTrusted = 'is_trusted',
  LastLogin = 'lastLogin',
  LastTimeCheckedNotifications = 'lastTimeCheckedNotifications',
  Lastname = 'lastname',
  NotificationPreferences = 'notificationPreferences',
  OldNumberId = 'oldNumberID',
  Password = 'password',
  UpdatedAt = 'updatedAt',
  Verified = 'verified',
  VerifiedAt = 'verifiedAt'
}

export type ScreenerWhereInput = {
  AND?: InputMaybe<Array<ScreenerWhereInput>>;
  NOT?: InputMaybe<Array<ScreenerWhereInput>>;
  OR?: InputMaybe<Array<ScreenerWhereInput>>;
  active?: InputMaybe<BoolFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  email?: InputMaybe<StringFilter>;
  firstname?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  instructor_screening?: InputMaybe<Instructor_ScreeningListRelationFilter>;
  isRedacted?: InputMaybe<BoolFilter>;
  is_course_screener?: InputMaybe<BoolFilter>;
  is_pupil_screener?: InputMaybe<BoolFilter>;
  is_student_screener?: InputMaybe<BoolFilter>;
  is_trusted?: InputMaybe<BoolFilter>;
  lastLogin?: InputMaybe<DateTimeNullableFilter>;
  lastTimeCheckedNotifications?: InputMaybe<DateTimeNullableFilter>;
  lastname?: InputMaybe<StringNullableFilter>;
  notificationPreferences?: InputMaybe<JsonNullableFilter>;
  oldNumberID?: InputMaybe<IntNullableFilter>;
  password?: InputMaybe<StringFilter>;
  screenings?: InputMaybe<ScreeningListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  verified?: InputMaybe<BoolNullableFilter>;
  verifiedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type ScreenerWhereUniqueInput = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  oldNumberID?: InputMaybe<Scalars['Int']>;
};

export type Screening = {
  __typename?: 'Screening';
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  jobStatus?: Maybe<Screening_Jobstatus_Enum>;
  knowsCoronaSchoolFrom?: Maybe<Scalars['String']>;
  screener: Screener;
  screenerId?: Maybe<Scalars['Int']>;
  status: Student_Screening_Status_Enum;
  studentId?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
};

export type ScreeningListRelationFilter = {
  every?: InputMaybe<ScreeningWhereInput>;
  none?: InputMaybe<ScreeningWhereInput>;
  some?: InputMaybe<ScreeningWhereInput>;
};

export type ScreeningOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ScreeningOrderByWithRelationInput = {
  comment?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  jobStatus?: InputMaybe<SortOrderInput>;
  knowsCoronaSchoolFrom?: InputMaybe<SortOrderInput>;
  screener?: InputMaybe<ScreenerOrderByWithRelationInput>;
  screenerId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  student?: InputMaybe<StudentOrderByWithRelationInput>;
  studentId?: InputMaybe<SortOrderInput>;
  success?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ScreeningRelationFilter = {
  is?: InputMaybe<ScreeningWhereInput>;
  isNot?: InputMaybe<ScreeningWhereInput>;
};

export type ScreeningUpdateInput = {
  comment?: InputMaybe<Scalars['String']>;
};

export type ScreeningWhereInput = {
  AND?: InputMaybe<Array<ScreeningWhereInput>>;
  NOT?: InputMaybe<Array<ScreeningWhereInput>>;
  OR?: InputMaybe<Array<ScreeningWhereInput>>;
  comment?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  jobStatus?: InputMaybe<Enumscreening_Jobstatus_EnumNullableFilter>;
  knowsCoronaSchoolFrom?: InputMaybe<StringNullableFilter>;
  screener?: InputMaybe<ScreenerRelationFilter>;
  screenerId?: InputMaybe<IntNullableFilter>;
  status?: InputMaybe<Enumstudent_Screening_Status_EnumFilter>;
  student?: InputMaybe<StudentRelationFilter>;
  studentId?: InputMaybe<IntNullableFilter>;
  success?: InputMaybe<BoolFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type Secret = {
  __typename?: 'Secret';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  idpClientId?: Maybe<Scalars['String']>;
  lastUsed?: Maybe<Scalars['DateTime']>;
  lastUsedDeviceId?: Maybe<Scalars['String']>;
  secret: Scalars['String'];
  type: Secret_Type_Enum;
  userId: Scalars['String'];
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortOrderInput = {
  nulls?: InputMaybe<NullsOrder>;
  sort: SortOrder;
};

/** A state in the federal republic of germany */
export enum State {
  At = 'at',
  Bb = 'bb',
  Be = 'be',
  Bw = 'bw',
  By = 'by',
  Ch = 'ch',
  Hb = 'hb',
  He = 'he',
  Hh = 'hh',
  Mv = 'mv',
  Ni = 'ni',
  Nw = 'nw',
  Other = 'other',
  Rp = 'rp',
  Sh = 'sh',
  Sl = 'sl',
  Sn = 'sn',
  St = 'st',
  Th = 'th'
}

export type StatisticType = {
  __typename?: 'StatisticType';
  averageMatchesPerMonth: Scalars['Float'];
  matchesByMonth: Scalars['JSON'];
  predictedPupilMatchTime: Scalars['Float'];
  subjectDemand: Array<SubjectDemand>;
};

export type Statistics = {
  __typename?: 'Statistics';
  activeMatches: Scalars['Int'];
  attendedCoursePlaces: Array<ByMonth>;
  averageMatchesOfTutee: Scalars['Float'];
  averageMatchesOfTutors: Scalars['Float'];
  deactivationReasons: Array<ByMonth>;
  dissolvedMatches: Array<DataWithTrends>;
  from?: Maybe<Scalars['String']>;
  helperRegistrations: Array<ByMonth>;
  helperRegistrationsByJob: Array<ByMonth>;
  helperRegistrationsByState: Array<ByMonth>;
  helperRegistrationsByUniversity: Array<ByMonth>;
  instructorScreenings: Array<ByMonth>;
  interestConfirmationsByState: Array<ByMonth>;
  knowsCoronaSchoolFrom: Array<ByMonth>;
  loginsToday: Scalars['Int'];
  matchesByDuration: Array<Bucket>;
  medianTimeToMatch: MedianTimeToMatch;
  notificationsSent: Array<ByMonth>;
  nowDissolvedMatchesAfterThreeMonths: Array<ByMonth>;
  nowDissolvedMatchesBeforeThreeMonths: Array<ByMonth>;
  nowFirstMatches: Array<ByMonth>;
  nowFirstMatchesStudent: Array<ByMonth>;
  nowMatches: Array<ByMonth>;
  numCourseAppointments: Scalars['Int'];
  numDissolvedMatchesByReason: Scalars['Int'];
  numPupilsAtLeastOneMatch: Scalars['Int'];
  numPupilsOnWaitingList: Scalars['Int'];
  numStudentsAtLeastOneMatch: Scalars['Int'];
  numSubcourses: Array<ByMonth>;
  offeredCoursePlaces: Array<ByMonth>;
  offeredLectures: Array<ByMonth>;
  pupilRegistrations: Array<ByMonth>;
  pupilRegistrationsByGrade: Array<ByMonth>;
  pupilRegistrationsBySchooltype: Array<ByMonth>;
  pupilRegistrationsByState: Array<ByMonth>;
  pupilScreenings: Array<ByMonth>;
  pupilsParticipatingInCourses: Array<ByMonth>;
  rateDissolvedMatchesLasted30Days: Scalars['Float'];
  ratePupilsInTargetAudience: Scalars['Float'];
  rateSuccessfulCoCsInstructors: Scalars['Float'];
  rateSuccessfulCoCsTutors: Scalars['Float'];
  registeredHelpersHavingScreening: Array<ByMonth>;
  timeCommitment: Array<Bucket>;
  to?: Maybe<Scalars['String']>;
  tutorLifetime: Array<Bucket>;
  tutorScreenings: Array<ByMonth>;
};


export type StatisticsDeactivationReasonsArgs = {
  type: Scalars['String'];
};


export type StatisticsKnowsCoronaSchoolFromArgs = {
  type: Scalars['String'];
};


export type StatisticsNumCourseAppointmentsArgs = {
  category?: InputMaybe<Scalars['String']>;
};


export type StatisticsNumDissolvedMatchesByReasonArgs = {
  reason: Scalars['String'];
};


export type StatisticsNumSubcoursesArgs = {
  category: CourseCategory;
};


export type StatisticsOfferedLecturesArgs = {
  category: CourseCategory;
};


export type StatisticsPupilScreeningsArgs = {
  status: Scalars['String'];
};


export type StatisticsTutorLifetimeArgs = {
  onlyInactive: Scalars['Boolean'];
};

export type Step = {
  __typename?: 'Step';
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['String']>>;
  has?: InputMaybe<Scalars['String']>;
  hasEvery?: InputMaybe<Array<Scalars['String']>>;
  hasSome?: InputMaybe<Array<Scalars['String']>>;
  isEmpty?: InputMaybe<Scalars['Boolean']>;
};

export type StringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type Student = {
  __typename?: 'Student';
  _count?: Maybe<StudentCount>;
  aboutMe: Scalars['String'];
  active: Scalars['Boolean'];
  canCreateCourse: Decision;
  canRequestMatch: Decision;
  certificateOfConduct?: Maybe<Certificate_Of_Conduct>;
  certificateOfConductDeactivationDate?: Maybe<Scalars['DateTime']>;
  certificateOfConductPresent: Scalars['Boolean'];
  cooperationID?: Maybe<Scalars['Int']>;
  coursesInstructing: Array<Course>;
  createdAt: Scalars['DateTime'];
  descriptionForMatch: Scalars['String'];
  descriptionForScreening: Scalars['String'];
  email: Scalars['String'];
  feedback?: Maybe<Scalars['String']>;
  firstMatchRequest?: Maybe<Scalars['DateTime']>;
  firstname?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender_Enum>;
  hasDoneEthicsOnboarding?: Maybe<Scalars['Boolean']>;
  hasSpecialExperience: Scalars['Boolean'];
  id: Scalars['Int'];
  instructorScreenings: Array<Instructor_Screening>;
  isCodu: Scalars['Boolean'];
  isInstructor: Scalars['Boolean'];
  isRedacted: Scalars['Boolean'];
  isStudent: Scalars['Boolean'];
  isUniversityStudent?: Maybe<Scalars['Boolean']>;
  languages: Array<Student_Languages_Enum>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastSentInstructorScreeningInvitationDate?: Maybe<Scalars['DateTime']>;
  lastSentScreeningInvitationDate?: Maybe<Scalars['DateTime']>;
  lastTimeCheckedNotifications?: Maybe<Scalars['DateTime']>;
  lastUpdatedSettingsViaBlocker?: Maybe<Scalars['DateTime']>;
  lastname?: Maybe<Scalars['String']>;
  matches: Array<Match>;
  msg?: Maybe<Scalars['String']>;
  newsletter: Scalars['Boolean'];
  notificationPreferences?: Maybe<Scalars['JSON']>;
  openMatchRequestCount: Scalars['Int'];
  participationCertificates: Array<Participation_Certificate>;
  phone?: Maybe<Scalars['String']>;
  referredById?: Maybe<Scalars['String']>;
  registrationSource: Student_Registrationsource_Enum;
  sentInstructorScreeningReminderCount: Scalars['Int'];
  sentScreeningReminderCount: Scalars['Int'];
  state?: Maybe<Student_State_Enum>;
  subcoursesInstructing: Array<Subcourse>;
  subcoursesMentoring: Array<Subcourse>;
  subjects?: Maybe<Scalars['String']>;
  subjectsFormatted: Array<Subject>;
  supportsInDaZ?: Maybe<Scalars['Boolean']>;
  totalLecturesOrganized: Scalars['Int'];
  tutorScreenings: Array<Screening>;
  university?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user: UserType;
  verifiedAt?: Maybe<Scalars['DateTime']>;
  wix_creation_date: Scalars['DateTime'];
  wix_id: Scalars['String'];
  zoomUserId?: Maybe<Scalars['String']>;
};


export type StudentSubcoursesInstructingArgs = {
  excludeCancelled?: InputMaybe<Scalars['Boolean']>;
  excludePast?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type StudentSubcoursesMentoringArgs = {
  excludeCancelled?: InputMaybe<Scalars['Boolean']>;
  excludePast?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};

export type StudentCount = {
  __typename?: 'StudentCount';
  course: Scalars['Int'];
  course_guest: Scalars['Int'];
  course_instructors_student: Scalars['Int'];
  course_participation_certificate: Scalars['Int'];
  instant_certificate: Scalars['Int'];
  lecture: Scalars['Int'];
  match: Scalars['Int'];
  participation_certificate: Scalars['Int'];
  subcourse_instructors_student: Scalars['Int'];
  subcourse_mentors_student: Scalars['Int'];
};


export type StudentCountCourseArgs = {
  where?: InputMaybe<CourseWhereInput>;
};


export type StudentCountCourse_GuestArgs = {
  where?: InputMaybe<Course_GuestWhereInput>;
};


export type StudentCountCourse_Instructors_StudentArgs = {
  where?: InputMaybe<Course_Instructors_StudentWhereInput>;
};


export type StudentCountCourse_Participation_CertificateArgs = {
  where?: InputMaybe<Course_Participation_CertificateWhereInput>;
};


export type StudentCountInstant_CertificateArgs = {
  where?: InputMaybe<Instant_CertificateWhereInput>;
};


export type StudentCountLectureArgs = {
  where?: InputMaybe<LectureWhereInput>;
};


export type StudentCountMatchArgs = {
  where?: InputMaybe<MatchWhereInput>;
};


export type StudentCountParticipation_CertificateArgs = {
  where?: InputMaybe<Participation_CertificateWhereInput>;
};


export type StudentCountSubcourse_Instructors_StudentArgs = {
  where?: InputMaybe<Subcourse_Instructors_StudentWhereInput>;
};


export type StudentCountSubcourse_Mentors_StudentArgs = {
  where?: InputMaybe<Subcourse_Mentors_StudentWhereInput>;
};

/** languages commonly spoken at Lern-Fair (except TypeScript) */
export enum StudentLanguage {
  Albanisch = 'Albanisch',
  Andere = 'Andere',
  Arabisch = 'Arabisch',
  Armenisch = 'Armenisch',
  Aserbaidschanisch = 'Aserbaidschanisch',
  Bosnisch = 'Bosnisch',
  Bulgarisch = 'Bulgarisch',
  Chinesisch = 'Chinesisch',
  Deutsch = 'Deutsch',
  Englisch = 'Englisch',
  FranzSisch = 'Franz_sisch',
  Italienisch = 'Italienisch',
  Kasachisch = 'Kasachisch',
  Kurdisch = 'Kurdisch',
  Polnisch = 'Polnisch',
  Portugiesisch = 'Portugiesisch',
  Russisch = 'Russisch',
  Spanisch = 'Spanisch',
  TRkisch = 'T_rkisch',
  Ukrainisch = 'Ukrainisch',
  Vietnamesisch = 'Vietnamesisch'
}

export type StudentListRelationFilter = {
  every?: InputMaybe<StudentWhereInput>;
  none?: InputMaybe<StudentWhereInput>;
  some?: InputMaybe<StudentWhereInput>;
};

export type StudentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type StudentOrderByWithRelationInput = {
  aboutMe?: InputMaybe<SortOrder>;
  active?: InputMaybe<SortOrder>;
  certificate_of_conduct?: InputMaybe<Certificate_Of_ConductOrderByWithRelationInput>;
  cooperation?: InputMaybe<CooperationOrderByWithRelationInput>;
  cooperationID?: InputMaybe<SortOrderInput>;
  course?: InputMaybe<CourseOrderByRelationAggregateInput>;
  course_guest?: InputMaybe<Course_GuestOrderByRelationAggregateInput>;
  course_instructors_student?: InputMaybe<Course_Instructors_StudentOrderByRelationAggregateInput>;
  course_participation_certificate?: InputMaybe<Course_Participation_CertificateOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  descriptionForMatch?: InputMaybe<SortOrder>;
  descriptionForScreening?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  feedback?: InputMaybe<SortOrderInput>;
  firstMatchRequest?: InputMaybe<SortOrderInput>;
  firstname?: InputMaybe<SortOrderInput>;
  gender?: InputMaybe<SortOrderInput>;
  hasDoneEthicsOnboarding?: InputMaybe<SortOrderInput>;
  hasSpecialExperience?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  instant_certificate?: InputMaybe<Instant_CertificateOrderByRelationAggregateInput>;
  instructor_screening?: InputMaybe<Instructor_ScreeningOrderByWithRelationInput>;
  isCodu?: InputMaybe<SortOrder>;
  isInstructor?: InputMaybe<SortOrder>;
  isRedacted?: InputMaybe<SortOrder>;
  isStudent?: InputMaybe<SortOrder>;
  isUniversityStudent?: InputMaybe<SortOrderInput>;
  jufo_verification_transmission?: InputMaybe<Jufo_Verification_TransmissionOrderByWithRelationInput>;
  languages?: InputMaybe<SortOrder>;
  lastLogin?: InputMaybe<SortOrderInput>;
  lastSentInstructorScreeningInvitationDate?: InputMaybe<SortOrderInput>;
  lastSentScreeningInvitationDate?: InputMaybe<SortOrderInput>;
  lastTimeCheckedNotifications?: InputMaybe<SortOrderInput>;
  lastUpdatedSettingsViaBlocker?: InputMaybe<SortOrderInput>;
  lastname?: InputMaybe<SortOrderInput>;
  lecture?: InputMaybe<LectureOrderByRelationAggregateInput>;
  match?: InputMaybe<MatchOrderByRelationAggregateInput>;
  msg?: InputMaybe<SortOrderInput>;
  newsletter?: InputMaybe<SortOrder>;
  notificationPreferences?: InputMaybe<SortOrderInput>;
  openMatchRequestCount?: InputMaybe<SortOrder>;
  participation_certificate?: InputMaybe<Participation_CertificateOrderByRelationAggregateInput>;
  phone?: InputMaybe<SortOrderInput>;
  referredById?: InputMaybe<SortOrderInput>;
  registrationSource?: InputMaybe<SortOrder>;
  remission_request?: InputMaybe<Remission_RequestOrderByWithRelationInput>;
  screening?: InputMaybe<ScreeningOrderByWithRelationInput>;
  sentInstructorScreeningReminderCount?: InputMaybe<SortOrder>;
  sentScreeningReminderCount?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrderInput>;
  subcourse_instructors_student?: InputMaybe<Subcourse_Instructors_StudentOrderByRelationAggregateInput>;
  subcourse_mentors_student?: InputMaybe<Subcourse_Mentors_StudentOrderByRelationAggregateInput>;
  subjects?: InputMaybe<SortOrderInput>;
  supportsInDaZ?: InputMaybe<SortOrderInput>;
  university?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  verifiedAt?: InputMaybe<SortOrderInput>;
  wix_creation_date?: InputMaybe<SortOrder>;
  wix_id?: InputMaybe<SortOrder>;
  zoomUserId?: InputMaybe<SortOrderInput>;
};

export type StudentRegisterPlusInput = {
  activate?: InputMaybe<BecomeTutorInput>;
  email: Scalars['String'];
  register?: InputMaybe<RegisterStudentInput>;
  screen?: InputMaybe<Instructor_ScreeningCreateInput>;
};

export type StudentRegisterPlusManyInput = {
  entries: Array<StudentRegisterPlusInput>;
};

export type StudentRegisterPlusManyOutput = {
  __typename?: 'StudentRegisterPlusManyOutput';
  email?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type StudentRelationFilter = {
  is?: InputMaybe<StudentWhereInput>;
  isNot?: InputMaybe<StudentWhereInput>;
};

export enum StudentScalarFieldEnum {
  AboutMe = 'aboutMe',
  Active = 'active',
  CooperationId = 'cooperationID',
  CreatedAt = 'createdAt',
  DescriptionForMatch = 'descriptionForMatch',
  DescriptionForScreening = 'descriptionForScreening',
  Email = 'email',
  Feedback = 'feedback',
  FirstMatchRequest = 'firstMatchRequest',
  Firstname = 'firstname',
  Gender = 'gender',
  HasDoneEthicsOnboarding = 'hasDoneEthicsOnboarding',
  HasSpecialExperience = 'hasSpecialExperience',
  Id = 'id',
  IsCodu = 'isCodu',
  IsInstructor = 'isInstructor',
  IsRedacted = 'isRedacted',
  IsStudent = 'isStudent',
  IsUniversityStudent = 'isUniversityStudent',
  Languages = 'languages',
  LastLogin = 'lastLogin',
  LastSentInstructorScreeningInvitationDate = 'lastSentInstructorScreeningInvitationDate',
  LastSentScreeningInvitationDate = 'lastSentScreeningInvitationDate',
  LastTimeCheckedNotifications = 'lastTimeCheckedNotifications',
  LastUpdatedSettingsViaBlocker = 'lastUpdatedSettingsViaBlocker',
  Lastname = 'lastname',
  Msg = 'msg',
  Newsletter = 'newsletter',
  NotificationPreferences = 'notificationPreferences',
  OpenMatchRequestCount = 'openMatchRequestCount',
  Phone = 'phone',
  ReferredById = 'referredById',
  RegistrationSource = 'registrationSource',
  SentInstructorScreeningReminderCount = 'sentInstructorScreeningReminderCount',
  SentScreeningReminderCount = 'sentScreeningReminderCount',
  State = 'state',
  Subjects = 'subjects',
  SupportsInDaZ = 'supportsInDaZ',
  University = 'university',
  UpdatedAt = 'updatedAt',
  VerifiedAt = 'verifiedAt',
  WixCreationDate = 'wix_creation_date',
  WixId = 'wix_id',
  ZoomUserId = 'zoomUserId'
}

export enum StudentScreeningStatus {
  Missed = 'missed',
  Pending = 'pending',
  Rejection = 'rejection',
  Success = 'success'
}

/** A state in the federal republic of germany */
export enum StudentState {
  At = 'at',
  Bb = 'bb',
  Be = 'be',
  Bw = 'bw',
  By = 'by',
  Ch = 'ch',
  Hb = 'hb',
  He = 'he',
  Hh = 'hh',
  Mv = 'mv',
  Ni = 'ni',
  Nw = 'nw',
  Other = 'other',
  Rp = 'rp',
  Sh = 'sh',
  Sl = 'sl',
  Sn = 'sn',
  St = 'st',
  Th = 'th'
}

export type StudentUpdateInput = {
  aboutMe?: InputMaybe<Scalars['String']>;
  descriptionForMatch?: InputMaybe<Scalars['String']>;
  descriptionForScreening?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstname?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  hasDoneEthicsOnboarding?: InputMaybe<Scalars['Boolean']>;
  hasSpecialExperience?: InputMaybe<Scalars['Boolean']>;
  languages?: InputMaybe<Array<StudentLanguage>>;
  lastTimeCheckedNotifications?: InputMaybe<Scalars['DateTime']>;
  lastname?: InputMaybe<Scalars['String']>;
  notificationPreferences?: InputMaybe<PreferencesInput>;
  registrationSource?: InputMaybe<RegistrationSource>;
  state?: InputMaybe<StudentState>;
  subjects?: InputMaybe<Array<SubjectInput>>;
  university?: InputMaybe<Scalars['String']>;
};

export type StudentWhereInput = {
  AND?: InputMaybe<Array<StudentWhereInput>>;
  NOT?: InputMaybe<Array<StudentWhereInput>>;
  OR?: InputMaybe<Array<StudentWhereInput>>;
  aboutMe?: InputMaybe<StringFilter>;
  active?: InputMaybe<BoolFilter>;
  certificate_of_conduct?: InputMaybe<Certificate_Of_ConductRelationFilter>;
  cooperation?: InputMaybe<CooperationRelationFilter>;
  cooperationID?: InputMaybe<IntNullableFilter>;
  course?: InputMaybe<CourseListRelationFilter>;
  course_guest?: InputMaybe<Course_GuestListRelationFilter>;
  course_instructors_student?: InputMaybe<Course_Instructors_StudentListRelationFilter>;
  course_participation_certificate?: InputMaybe<Course_Participation_CertificateListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  descriptionForMatch?: InputMaybe<StringFilter>;
  descriptionForScreening?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  feedback?: InputMaybe<StringNullableFilter>;
  firstMatchRequest?: InputMaybe<DateTimeNullableFilter>;
  firstname?: InputMaybe<StringNullableFilter>;
  gender?: InputMaybe<Enumgender_EnumNullableFilter>;
  hasDoneEthicsOnboarding?: InputMaybe<BoolNullableFilter>;
  hasSpecialExperience?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  instant_certificate?: InputMaybe<Instant_CertificateListRelationFilter>;
  instructor_screening?: InputMaybe<Instructor_ScreeningRelationFilter>;
  isCodu?: InputMaybe<BoolFilter>;
  isInstructor?: InputMaybe<BoolFilter>;
  isRedacted?: InputMaybe<BoolFilter>;
  isStudent?: InputMaybe<BoolFilter>;
  isUniversityStudent?: InputMaybe<BoolNullableFilter>;
  jufo_verification_transmission?: InputMaybe<Jufo_Verification_TransmissionRelationFilter>;
  languages?: InputMaybe<Enumstudent_Languages_EnumNullableListFilter>;
  lastLogin?: InputMaybe<DateTimeNullableFilter>;
  lastSentInstructorScreeningInvitationDate?: InputMaybe<DateTimeNullableFilter>;
  lastSentScreeningInvitationDate?: InputMaybe<DateTimeNullableFilter>;
  lastTimeCheckedNotifications?: InputMaybe<DateTimeNullableFilter>;
  lastUpdatedSettingsViaBlocker?: InputMaybe<DateTimeNullableFilter>;
  lastname?: InputMaybe<StringNullableFilter>;
  lecture?: InputMaybe<LectureListRelationFilter>;
  match?: InputMaybe<MatchListRelationFilter>;
  msg?: InputMaybe<StringNullableFilter>;
  newsletter?: InputMaybe<BoolFilter>;
  notificationPreferences?: InputMaybe<JsonNullableFilter>;
  openMatchRequestCount?: InputMaybe<IntFilter>;
  participation_certificate?: InputMaybe<Participation_CertificateListRelationFilter>;
  phone?: InputMaybe<StringNullableFilter>;
  referredById?: InputMaybe<StringNullableFilter>;
  registrationSource?: InputMaybe<Enumstudent_Registrationsource_EnumFilter>;
  remission_request?: InputMaybe<Remission_RequestRelationFilter>;
  screening?: InputMaybe<ScreeningRelationFilter>;
  sentInstructorScreeningReminderCount?: InputMaybe<IntFilter>;
  sentScreeningReminderCount?: InputMaybe<IntFilter>;
  state?: InputMaybe<Enumstudent_State_EnumNullableFilter>;
  subcourse_instructors_student?: InputMaybe<Subcourse_Instructors_StudentListRelationFilter>;
  subcourse_mentors_student?: InputMaybe<Subcourse_Mentors_StudentListRelationFilter>;
  subjects?: InputMaybe<StringNullableFilter>;
  supportsInDaZ?: InputMaybe<BoolNullableFilter>;
  university?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  verifiedAt?: InputMaybe<DateTimeNullableFilter>;
  wix_creation_date?: InputMaybe<DateTimeFilter>;
  wix_id?: InputMaybe<StringFilter>;
  zoomUserId?: InputMaybe<StringNullableFilter>;
};

export type StudentWhereUniqueInput = {
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  wix_id?: InputMaybe<Scalars['String']>;
};

export type Subcourse = {
  __typename?: 'Subcourse';
  _count?: Maybe<SubcourseCount>;
  allowChatContactParticipants: Scalars['Boolean'];
  allowChatContactProspects: Scalars['Boolean'];
  alreadyPromoted: Scalars['Boolean'];
  appointments: Array<Lecture>;
  canCancel: Decision;
  canContactInstructor: Decision;
  canContactParticipants: Decision;
  canDelete: Decision;
  canEdit: Decision;
  canJoin: Decision;
  canJoinWaitinglist: Decision;
  canPromote: Decision;
  canPublish: Decision;
  cancelled: Scalars['Boolean'];
  capacity: Scalars['Float'];
  chat?: Maybe<Chat>;
  conversationId?: Maybe<Scalars['String']>;
  course: Course;
  courseId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  firstLecture?: Maybe<Lecture>;
  groupChatType: Chat_Type;
  id: Scalars['Int'];
  instructors: Array<Instructor>;
  isInstructor: Scalars['Boolean'];
  isMentor: Scalars['Boolean'];
  isOnWaitingList: Scalars['Boolean'];
  isParticipant: Scalars['Boolean'];
  joinAfterStart: Scalars['Boolean'];
  lectures: Array<Lecture>;
  maxGrade: Scalars['Int'];
  maxParticipants: Scalars['Int'];
  minGrade: Scalars['Int'];
  nextLecture?: Maybe<Lecture>;
  ongoingLecture?: Maybe<Lecture>;
  otherParticipants: Array<OtherParticipant>;
  participants: Array<Participant>;
  participantsAsPupil: Array<Pupil>;
  participantsCount: Scalars['Float'];
  prospectChats: Array<Scalars['JSON']>;
  prospectParticipants: Array<ProspectParticipant>;
  published: Scalars['Boolean'];
  publishedAt?: Maybe<Scalars['DateTime']>;
  pupilsOnWaitinglist: Array<Participant>;
  pupilsWaiting: Array<Pupil>;
  pupilsWaitingCount: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
  wasPromotedByAdmin: Scalars['Boolean'];
  wasPromotedByInstructor: Scalars['Boolean'];
};


export type SubcourseCanJoinArgs = {
  pupilId?: InputMaybe<Scalars['Float']>;
};


export type SubcourseCanJoinWaitinglistArgs = {
  pupilId?: InputMaybe<Scalars['Float']>;
};


export type SubcourseIsInstructorArgs = {
  studentId?: InputMaybe<Scalars['Float']>;
};


export type SubcourseIsMentorArgs = {
  studentId?: InputMaybe<Scalars['Float']>;
};


export type SubcourseIsOnWaitingListArgs = {
  pupilId?: InputMaybe<Scalars['Float']>;
};


export type SubcourseIsParticipantArgs = {
  pupilId?: InputMaybe<Scalars['Float']>;
};

export type SubcourseCount = {
  __typename?: 'SubcourseCount';
  course_participation_certificate: Scalars['Int'];
  lecture: Scalars['Int'];
  subcourse_instructors_student: Scalars['Int'];
  subcourse_mentors_student: Scalars['Int'];
  subcourse_participants_pupil: Scalars['Int'];
  subcourse_promotions: Scalars['Int'];
  waiting_list_enrollment: Scalars['Int'];
};


export type SubcourseCountCourse_Participation_CertificateArgs = {
  where?: InputMaybe<Course_Participation_CertificateWhereInput>;
};


export type SubcourseCountLectureArgs = {
  where?: InputMaybe<LectureWhereInput>;
};


export type SubcourseCountSubcourse_Instructors_StudentArgs = {
  where?: InputMaybe<Subcourse_Instructors_StudentWhereInput>;
};


export type SubcourseCountSubcourse_Mentors_StudentArgs = {
  where?: InputMaybe<Subcourse_Mentors_StudentWhereInput>;
};


export type SubcourseCountSubcourse_Participants_PupilArgs = {
  where?: InputMaybe<Subcourse_Participants_PupilWhereInput>;
};


export type SubcourseCountSubcourse_PromotionsArgs = {
  where?: InputMaybe<Subcourse_PromotionWhereInput>;
};


export type SubcourseCountWaiting_List_EnrollmentArgs = {
  where?: InputMaybe<Waiting_List_EnrollmentWhereInput>;
};

export type SubcourseListRelationFilter = {
  every?: InputMaybe<SubcourseWhereInput>;
  none?: InputMaybe<SubcourseWhereInput>;
  some?: InputMaybe<SubcourseWhereInput>;
};

export type SubcourseOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type SubcourseOrderByWithRelationInput = {
  allowChatContactParticipants?: InputMaybe<SortOrder>;
  allowChatContactProspects?: InputMaybe<SortOrder>;
  alreadyPromoted?: InputMaybe<SortOrder>;
  cancelled?: InputMaybe<SortOrder>;
  conversationId?: InputMaybe<SortOrderInput>;
  course?: InputMaybe<CourseOrderByWithRelationInput>;
  courseId?: InputMaybe<SortOrderInput>;
  course_participation_certificate?: InputMaybe<Course_Participation_CertificateOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  groupChatType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  joinAfterStart?: InputMaybe<SortOrder>;
  lecture?: InputMaybe<LectureOrderByRelationAggregateInput>;
  maxGrade?: InputMaybe<SortOrder>;
  maxParticipants?: InputMaybe<SortOrder>;
  minGrade?: InputMaybe<SortOrder>;
  prospectChats?: InputMaybe<SortOrder>;
  published?: InputMaybe<SortOrder>;
  publishedAt?: InputMaybe<SortOrderInput>;
  subcourse_instructors_student?: InputMaybe<Subcourse_Instructors_StudentOrderByRelationAggregateInput>;
  subcourse_mentors_student?: InputMaybe<Subcourse_Mentors_StudentOrderByRelationAggregateInput>;
  subcourse_participants_pupil?: InputMaybe<Subcourse_Participants_PupilOrderByRelationAggregateInput>;
  subcourse_promotions?: InputMaybe<Subcourse_PromotionOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
  waiting_list_enrollment?: InputMaybe<Waiting_List_EnrollmentOrderByRelationAggregateInput>;
};

export type SubcourseRelationFilter = {
  is?: InputMaybe<SubcourseWhereInput>;
  isNot?: InputMaybe<SubcourseWhereInput>;
};

export enum SubcourseScalarFieldEnum {
  AllowChatContactParticipants = 'allowChatContactParticipants',
  AllowChatContactProspects = 'allowChatContactProspects',
  AlreadyPromoted = 'alreadyPromoted',
  Cancelled = 'cancelled',
  ConversationId = 'conversationId',
  CourseId = 'courseId',
  CreatedAt = 'createdAt',
  GroupChatType = 'groupChatType',
  Id = 'id',
  JoinAfterStart = 'joinAfterStart',
  MaxGrade = 'maxGrade',
  MaxParticipants = 'maxParticipants',
  MinGrade = 'minGrade',
  ProspectChats = 'prospectChats',
  Published = 'published',
  PublishedAt = 'publishedAt',
  UpdatedAt = 'updatedAt'
}

export type SubcourseWhereInput = {
  AND?: InputMaybe<Array<SubcourseWhereInput>>;
  NOT?: InputMaybe<Array<SubcourseWhereInput>>;
  OR?: InputMaybe<Array<SubcourseWhereInput>>;
  allowChatContactParticipants?: InputMaybe<BoolFilter>;
  allowChatContactProspects?: InputMaybe<BoolFilter>;
  alreadyPromoted?: InputMaybe<BoolFilter>;
  cancelled?: InputMaybe<BoolFilter>;
  conversationId?: InputMaybe<StringNullableFilter>;
  course?: InputMaybe<CourseRelationFilter>;
  courseId?: InputMaybe<IntNullableFilter>;
  course_participation_certificate?: InputMaybe<Course_Participation_CertificateListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  groupChatType?: InputMaybe<Enumchat_TypeFilter>;
  id?: InputMaybe<IntFilter>;
  joinAfterStart?: InputMaybe<BoolFilter>;
  lecture?: InputMaybe<LectureListRelationFilter>;
  maxGrade?: InputMaybe<IntFilter>;
  maxParticipants?: InputMaybe<IntFilter>;
  minGrade?: InputMaybe<IntFilter>;
  prospectChats?: InputMaybe<JsonNullableListFilter>;
  published?: InputMaybe<BoolFilter>;
  publishedAt?: InputMaybe<DateTimeNullableFilter>;
  subcourse_instructors_student?: InputMaybe<Subcourse_Instructors_StudentListRelationFilter>;
  subcourse_mentors_student?: InputMaybe<Subcourse_Mentors_StudentListRelationFilter>;
  subcourse_participants_pupil?: InputMaybe<Subcourse_Participants_PupilListRelationFilter>;
  subcourse_promotions?: InputMaybe<Subcourse_PromotionListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  waiting_list_enrollment?: InputMaybe<Waiting_List_EnrollmentListRelationFilter>;
};

export type SubcourseWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type Subcourse_Instructors_StudentListRelationFilter = {
  every?: InputMaybe<Subcourse_Instructors_StudentWhereInput>;
  none?: InputMaybe<Subcourse_Instructors_StudentWhereInput>;
  some?: InputMaybe<Subcourse_Instructors_StudentWhereInput>;
};

export type Subcourse_Instructors_StudentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type Subcourse_Instructors_StudentWhereInput = {
  AND?: InputMaybe<Array<Subcourse_Instructors_StudentWhereInput>>;
  NOT?: InputMaybe<Array<Subcourse_Instructors_StudentWhereInput>>;
  OR?: InputMaybe<Array<Subcourse_Instructors_StudentWhereInput>>;
  student?: InputMaybe<StudentRelationFilter>;
  studentId?: InputMaybe<IntFilter>;
  subcourse?: InputMaybe<SubcourseRelationFilter>;
  subcourseId?: InputMaybe<IntFilter>;
};

export type Subcourse_Mentors_StudentListRelationFilter = {
  every?: InputMaybe<Subcourse_Mentors_StudentWhereInput>;
  none?: InputMaybe<Subcourse_Mentors_StudentWhereInput>;
  some?: InputMaybe<Subcourse_Mentors_StudentWhereInput>;
};

export type Subcourse_Mentors_StudentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type Subcourse_Mentors_StudentWhereInput = {
  AND?: InputMaybe<Array<Subcourse_Mentors_StudentWhereInput>>;
  NOT?: InputMaybe<Array<Subcourse_Mentors_StudentWhereInput>>;
  OR?: InputMaybe<Array<Subcourse_Mentors_StudentWhereInput>>;
  student?: InputMaybe<StudentRelationFilter>;
  studentId?: InputMaybe<IntFilter>;
  subcourse?: InputMaybe<SubcourseRelationFilter>;
  subcourseId?: InputMaybe<IntFilter>;
};

export type Subcourse_Participants_PupilListRelationFilter = {
  every?: InputMaybe<Subcourse_Participants_PupilWhereInput>;
  none?: InputMaybe<Subcourse_Participants_PupilWhereInput>;
  some?: InputMaybe<Subcourse_Participants_PupilWhereInput>;
};

export type Subcourse_Participants_PupilOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type Subcourse_Participants_PupilWhereInput = {
  AND?: InputMaybe<Array<Subcourse_Participants_PupilWhereInput>>;
  NOT?: InputMaybe<Array<Subcourse_Participants_PupilWhereInput>>;
  OR?: InputMaybe<Array<Subcourse_Participants_PupilWhereInput>>;
  pupil?: InputMaybe<PupilRelationFilter>;
  pupilId?: InputMaybe<IntFilter>;
  subcourse?: InputMaybe<SubcourseRelationFilter>;
  subcourseId?: InputMaybe<IntFilter>;
};

export type Subcourse_PromotionListRelationFilter = {
  every?: InputMaybe<Subcourse_PromotionWhereInput>;
  none?: InputMaybe<Subcourse_PromotionWhereInput>;
  some?: InputMaybe<Subcourse_PromotionWhereInput>;
};

export type Subcourse_PromotionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type Subcourse_PromotionWhereInput = {
  AND?: InputMaybe<Array<Subcourse_PromotionWhereInput>>;
  NOT?: InputMaybe<Array<Subcourse_PromotionWhereInput>>;
  OR?: InputMaybe<Array<Subcourse_PromotionWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  subcourse?: InputMaybe<SubcourseRelationFilter>;
  subcourseId?: InputMaybe<IntFilter>;
  type?: InputMaybe<Enumsubcourse_Promotion_Type_EnumFilter>;
};

export type Subject = {
  __typename?: 'Subject';
  grade?: Maybe<Range>;
  mandatory?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type SubjectDemand = {
  __typename?: 'SubjectDemand';
  demand: Scalars['Float'];
  offered: Scalars['Float'];
  requested: Scalars['Float'];
  requestedMandatory?: Maybe<Scalars['Float']>;
  subject: Scalars['String'];
};

export type SubjectInput = {
  grade?: InputMaybe<RangeInput>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type SupportMessage = {
  message: Scalars['String'];
  subject: Scalars['String'];
};

export type TemporaryMatch = {
  __typename?: 'TemporaryMatch';
  pupil: Pupil;
  student: Student;
};

export type UserType = {
  __typename?: 'UserType';
  _achievementData: Array<Scalars['JSON']>;
  _achievementEvents: Array<Scalars['JSON']>;
  achievement: Achievement;
  achievements: Array<Achievement>;
  active: Scalars['Boolean'];
  appointments?: Maybe<Array<Lecture>>;
  chatSignature: Scalars['String'];
  concreteNotifications: Array<Concrete_Notification>;
  contactOptions: Array<Contact>;
  email: Scalars['String'];
  firstAppointmentId?: Maybe<Scalars['Int']>;
  firstname: Scalars['String'];
  furtherAchievements: Array<Achievement>;
  hasAppointments: Scalars['Boolean'];
  lastAppointmentId?: Maybe<Scalars['Int']>;
  lastLogin: Scalars['DateTime'];
  lastTimeCheckedNotifications?: Maybe<Scalars['DateTime']>;
  lastname: Scalars['String'];
  logs: Array<Log>;
  nextStepAchievements: Array<Achievement>;
  notificationPreferences?: Maybe<Scalars['JSON']>;
  pupil?: Maybe<Pupil>;
  pushSubscriptions: Array<Push_Subscription>;
  receivedScreeningSuggestions: Array<Concrete_Notification>;
  /** Number of referrals made by the user */
  referralCount: Scalars['Int'];
  roles: Array<Scalars['String']>;
  screener?: Maybe<Screener>;
  secrets: Array<Secret>;
  student?: Maybe<Student>;
  /** Total hours supported by referred students/pupils - 0 if less than 3 users were referred for privacy */
  supportedHours: Scalars['Int'];
  userID: Scalars['String'];
  zoomSDKJWT: Scalars['String'];
  zoomZAK: Scalars['String'];
};


export type UserTypeAchievementArgs = {
  id: Scalars['Float'];
};


export type UserTypeAppointmentsArgs = {
  cursor?: InputMaybe<Scalars['Float']>;
  direction?: InputMaybe<Scalars['String']>;
  skip: Scalars['Float'];
  take: Scalars['Float'];
};


export type UserTypeConcreteNotificationsArgs = {
  skip?: InputMaybe<Scalars['Float']>;
  take?: InputMaybe<Scalars['Float']>;
};


export type UserTypeZoomSdkjwtArgs = {
  meetingId: Scalars['String'];
  role: Scalars['Float'];
};

export type User_AchievementListRelationFilter = {
  every?: InputMaybe<User_AchievementWhereInput>;
  none?: InputMaybe<User_AchievementWhereInput>;
  some?: InputMaybe<User_AchievementWhereInput>;
};

export type User_AchievementWhereInput = {
  AND?: InputMaybe<Array<User_AchievementWhereInput>>;
  NOT?: InputMaybe<Array<User_AchievementWhereInput>>;
  OR?: InputMaybe<Array<User_AchievementWhereInput>>;
  achievedAt?: InputMaybe<DateTimeNullableFilter>;
  context?: InputMaybe<JsonFilter>;
  id?: InputMaybe<IntFilter>;
  isSeen?: InputMaybe<BoolFilter>;
  recordValue?: InputMaybe<IntNullableFilter>;
  relation?: InputMaybe<StringNullableFilter>;
  template?: InputMaybe<Achievement_TemplateRelationFilter>;
  templateId?: InputMaybe<IntFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type Waiting_List_EnrollmentListRelationFilter = {
  every?: InputMaybe<Waiting_List_EnrollmentWhereInput>;
  none?: InputMaybe<Waiting_List_EnrollmentWhereInput>;
  some?: InputMaybe<Waiting_List_EnrollmentWhereInput>;
};

export type Waiting_List_EnrollmentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type Waiting_List_EnrollmentWhereInput = {
  AND?: InputMaybe<Array<Waiting_List_EnrollmentWhereInput>>;
  NOT?: InputMaybe<Array<Waiting_List_EnrollmentWhereInput>>;
  OR?: InputMaybe<Array<Waiting_List_EnrollmentWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  pupil?: InputMaybe<PupilRelationFilter>;
  pupilId?: InputMaybe<IntNullableFilter>;
  subcourse?: InputMaybe<SubcourseRelationFilter>;
  subcourseId?: InputMaybe<IntNullableFilter>;
};

export enum Achievement_Action_Type_Enum {
  Action = 'Action',
  Appointment = 'Appointment',
  Info = 'Info',
  Wait = 'Wait'
}

export enum Achievement_State {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Inactive = 'INACTIVE'
}

export enum Achievement_Template_For_Enum {
  Course = 'Course',
  Global = 'Global',
  GlobalCourses = 'Global_Courses',
  GlobalMatches = 'Global_Matches',
  Match = 'Match'
}

export enum Achievement_Type_Enum {
  Sequential = 'SEQUENTIAL',
  Streak = 'STREAK',
  Tiered = 'TIERED'
}

export enum Chat_Type {
  Announcement = 'ANNOUNCEMENT',
  Normal = 'NORMAL'
}

export enum Course_Category_Enum {
  Club = 'club',
  Coaching = 'coaching',
  Focus = 'focus',
  HomeworkHelp = 'homework_help',
  Language = 'language',
  Revision = 'revision'
}

export enum Course_Coursestate_Enum {
  Allowed = 'allowed',
  Cancelled = 'cancelled',
  Created = 'created',
  Denied = 'denied',
  Submitted = 'submitted'
}

export enum Course_Schooltype_Enum {
  Berufsschule = 'berufsschule',
  FRderschule = 'f_rderschule',
  Gesamtschule = 'gesamtschule',
  Grundschule = 'grundschule',
  Gymnasium = 'gymnasium',
  Hauptschule = 'hauptschule',
  Other = 'other',
  Realschule = 'realschule'
}

export enum Course_Subject_Enum {
  Altgriechisch = 'Altgriechisch',
  Arbeitslehre = 'Arbeitslehre',
  Biologie = 'Biologie',
  Chemie = 'Chemie',
  Deutsch = 'Deutsch',
  DeutschAlsZweitsprache = 'Deutsch_als_Zweitsprache',
  Englisch = 'Englisch',
  Erdkunde = 'Erdkunde',
  Ethik = 'Ethik',
  FranzSisch = 'Franz_sisch',
  Geschichte = 'Geschichte',
  Gesundheit = 'Gesundheit',
  Informatik = 'Informatik',
  Italienisch = 'Italienisch',
  Kunst = 'Kunst',
  Latein = 'Latein',
  LernenLernen = 'Lernen_lernen',
  Mathematik = 'Mathematik',
  Musik = 'Musik',
  NiederlNdisch = 'Niederl_ndisch',
  PDagogik = 'P_dagogik',
  Philosophie = 'Philosophie',
  Physik = 'Physik',
  Politik = 'Politik',
  Religion = 'Religion',
  Russisch = 'Russisch',
  Sachkunde = 'Sachkunde',
  Spanisch = 'Spanisch',
  Technik = 'Technik',
  Wirtschaft = 'Wirtschaft'
}

export enum Dissolve_Reason {
  AccountDeactivated = 'accountDeactivated',
  AccountDeactivatedNoCoC = 'accountDeactivatedNoCoC',
  Ghosted = 'ghosted',
  IsOfNoHelp = 'isOfNoHelp',
  LanguageIssues = 'languageIssues',
  NoMoreHelpNeeded = 'noMoreHelpNeeded',
  NoMoreTime = 'noMoreTime',
  Other = 'other',
  PersonalIssues = 'personalIssues',
  ScheduleIssues = 'scheduleIssues',
  TechnicalIssues = 'technicalIssues',
  Unknown = 'unknown'
}

export enum Dissolved_By_Enum {
  Admin = 'admin',
  Pupil = 'pupil',
  Student = 'student',
  Unknown = 'unknown'
}

export enum Gender_Enum {
  Female = 'female',
  Male = 'male',
  Other = 'other'
}

export enum Important_Information_Language_Enum {
  De = 'de',
  En = 'en'
}

export enum Important_Information_Recipients_Enum {
  Pupils = 'pupils',
  Students = 'students'
}

export enum Learning_Assignment_Status {
  Done = 'done',
  InProgress = 'in_progress',
  Pending = 'pending'
}

export enum Learning_Note_Type {
  Answer = 'answer',
  Comment = 'comment',
  CorrectAnswer = 'correct_answer',
  Question = 'question',
  Task = 'task',
  WrongAnswer = 'wrong_answer'
}

export enum Lecture_Appointmenttype_Enum {
  Group = 'group',
  Internal = 'internal',
  Legacy = 'legacy',
  Match = 'match'
}

export enum Log_Logtype_Enum {
  AccessedByScreener = 'accessedByScreener',
  BbbMeeting = 'bbbMeeting',
  CancelledCourse = 'cancelledCourse',
  CancelledSubcourse = 'cancelledSubcourse',
  CertificateRequest = 'certificateRequest',
  CocCancel = 'cocCancel',
  CreatedCourse = 'createdCourse',
  CreatedCourseAttendanceLog = 'createdCourseAttendanceLog',
  DeActivate = 'deActivate',
  FetchedFromWix = 'fetchedFromWix',
  InstructorIssuedCertificate = 'instructorIssuedCertificate',
  MatchDissolve = 'matchDissolve',
  MentorJoinedCourse = 'mentorJoinedCourse',
  MentorLeftCourse = 'mentorLeftCourse',
  Misc = 'misc',
  ParticipantJoinedCourse = 'participantJoinedCourse',
  ParticipantJoinedWaitingList = 'participantJoinedWaitingList',
  ParticipantLeftCourse = 'participantLeftCourse',
  ParticipantLeftWaitingList = 'participantLeftWaitingList',
  PupilInterestConfirmationRequestReminderSent = 'pupilInterestConfirmationRequestReminderSent',
  PupilInterestConfirmationRequestSent = 'pupilInterestConfirmationRequestSent',
  PupilInterestConfirmationRequestStatusChange = 'pupilInterestConfirmationRequestStatusChange',
  SkippedCoC = 'skippedCoC',
  UpdatePersonal = 'updatePersonal',
  UpdateStudentDescription = 'updateStudentDescription',
  UpdateSubjects = 'updateSubjects',
  UpdatedByScreener = 'updatedByScreener',
  UserAccessedCourseWhileAuthenticated = 'userAccessedCourseWhileAuthenticated',
  VerificationRequets = 'verificationRequets',
  Verified = 'verified'
}

export type MatchUq_MatchCompoundUniqueInput = {
  pupilId: Scalars['Int'];
  studentId: Scalars['Int'];
};

export enum Message_Translation_Language_Enum {
  De = 'de',
  En = 'en'
}

export enum Notification_Channel_Enum {
  Email = 'email',
  Inapp = 'inapp',
  Push = 'push'
}

export enum Notification_Sender_Enum {
  CertificateOfConduct = 'CERTIFICATE_OF_CONDUCT',
  Support = 'SUPPORT'
}

export enum Notification_Type_Enum {
  Account = 'account',
  Achievement = 'achievement',
  Advice = 'advice',
  Alternative = 'alternative',
  Announcement = 'announcement',
  Appointment = 'appointment',
  Call = 'call',
  Certificate = 'certificate',
  Chat = 'chat',
  Course = 'course',
  Event = 'event',
  Legacy = 'legacy',
  Match = 'match',
  News = 'news',
  Onboarding = 'onboarding',
  Request = 'request',
  Suggestion = 'suggestion',
  Survey = 'survey'
}

export enum Pupil_Email_Owner_Enum {
  Other = 'other',
  Parent = 'parent',
  Pupil = 'pupil',
  Unknown = 'unknown'
}

export enum Pupil_Languages_Enum {
  Albanisch = 'Albanisch',
  Andere = 'Andere',
  Arabisch = 'Arabisch',
  Armenisch = 'Armenisch',
  Aserbaidschanisch = 'Aserbaidschanisch',
  Bosnisch = 'Bosnisch',
  Bulgarisch = 'Bulgarisch',
  Chinesisch = 'Chinesisch',
  Deutsch = 'Deutsch',
  Englisch = 'Englisch',
  FranzSisch = 'Franz_sisch',
  Italienisch = 'Italienisch',
  Kasachisch = 'Kasachisch',
  Kurdisch = 'Kurdisch',
  Polnisch = 'Polnisch',
  Portugiesisch = 'Portugiesisch',
  Russisch = 'Russisch',
  Spanisch = 'Spanisch',
  TRkisch = 'T_rkisch',
  Ukrainisch = 'Ukrainisch',
  Vietnamesisch = 'Vietnamesisch'
}

export enum Pupil_Learninggermansince_Enum {
  LessThanOne = 'less_than_one',
  MoreThanFour = 'more_than_four',
  OneToTwo = 'one_to_two',
  TwoToFour = 'two_to_four'
}

export enum Pupil_Registrationsource_Enum {
  Codu = 'codu',
  Cooperation = 'cooperation',
  Drehtuer = 'drehtuer',
  Normal = 'normal',
  Other = 'other',
  Plus = 'plus'
}

export enum Pupil_Schooltype_Enum {
  Berufsschule = 'berufsschule',
  FRderschule = 'f_rderschule',
  Gesamtschule = 'gesamtschule',
  Grundschule = 'grundschule',
  Gymnasium = 'gymnasium',
  Hauptschule = 'hauptschule',
  Other = 'other',
  Realschule = 'realschule'
}

export enum Pupil_Screening_Status_Enum {
  Dispute = 'dispute',
  Pending = 'pending',
  Rejection = 'rejection',
  Success = 'success'
}

export enum Pupil_State_Enum {
  At = 'at',
  Bb = 'bb',
  Be = 'be',
  Bw = 'bw',
  By = 'by',
  Ch = 'ch',
  Hb = 'hb',
  He = 'he',
  Hh = 'hh',
  Mv = 'mv',
  Ni = 'ni',
  Nw = 'nw',
  Other = 'other',
  Rp = 'rp',
  Sh = 'sh',
  Sl = 'sl',
  Sn = 'sn',
  St = 'st',
  Th = 'th'
}

export type SchoolNameStateCityCompoundUniqueInput = {
  city: Scalars['String'];
  name: Scalars['String'];
  state: School_State_Enum;
};

export enum School_Schooltype_Enum {
  Berufsschule = 'berufsschule',
  FRderschule = 'f_rderschule',
  Gesamtschule = 'gesamtschule',
  Grundschule = 'grundschule',
  Gymnasium = 'gymnasium',
  Hauptschule = 'hauptschule',
  Other = 'other',
  Realschule = 'realschule'
}

export enum School_State_Enum {
  At = 'at',
  Bb = 'bb',
  Be = 'be',
  Bw = 'bw',
  By = 'by',
  Ch = 'ch',
  Hb = 'hb',
  He = 'he',
  Hh = 'hh',
  Mv = 'mv',
  Ni = 'ni',
  Nw = 'nw',
  Other = 'other',
  Rp = 'rp',
  Sh = 'sh',
  Sl = 'sl',
  Sn = 'sn',
  St = 'st',
  Th = 'th'
}

export enum Screening_Jobstatus_Enum {
  Employee = 'Employee',
  Misc = 'Misc',
  Pupil = 'Pupil',
  Retiree = 'Retiree',
  Student = 'Student'
}

export enum Secret_Type_Enum {
  EmailToken = 'EMAIL_TOKEN',
  Idp = 'IDP',
  Password = 'PASSWORD',
  Token = 'TOKEN'
}

export enum Student_Languages_Enum {
  Albanisch = 'Albanisch',
  Andere = 'Andere',
  Arabisch = 'Arabisch',
  Armenisch = 'Armenisch',
  Aserbaidschanisch = 'Aserbaidschanisch',
  Bosnisch = 'Bosnisch',
  Bulgarisch = 'Bulgarisch',
  Chinesisch = 'Chinesisch',
  Deutsch = 'Deutsch',
  Englisch = 'Englisch',
  FranzSisch = 'Franz_sisch',
  Italienisch = 'Italienisch',
  Kasachisch = 'Kasachisch',
  Kurdisch = 'Kurdisch',
  Polnisch = 'Polnisch',
  Portugiesisch = 'Portugiesisch',
  Russisch = 'Russisch',
  Spanisch = 'Spanisch',
  TRkisch = 'T_rkisch',
  Ukrainisch = 'Ukrainisch',
  Vietnamesisch = 'Vietnamesisch'
}

export enum Student_Registrationsource_Enum {
  Codu = 'codu',
  Cooperation = 'cooperation',
  Drehtuer = 'drehtuer',
  Normal = 'normal',
  Other = 'other',
  Plus = 'plus'
}

export enum Student_Screening_Status_Enum {
  Missed = 'missed',
  Pending = 'pending',
  Rejection = 'rejection',
  Success = 'success'
}

export enum Student_State_Enum {
  At = 'at',
  Bb = 'bb',
  Be = 'be',
  Bw = 'bw',
  By = 'by',
  Ch = 'ch',
  Hb = 'hb',
  He = 'he',
  Hh = 'hh',
  Mv = 'mv',
  Ni = 'ni',
  Nw = 'nw',
  Other = 'other',
  Rp = 'rp',
  Sh = 'sh',
  Sl = 'sl',
  Sn = 'sn',
  St = 'st',
  Th = 'th'
}

export enum Subcourse_Promotion_Type_Enum {
  Admin = 'admin',
  Instructor = 'instructor',
  System = 'system'
}

export type ContactSupportMutationVariables = Exact<{
  subject: Scalars['String'];
  message: Scalars['String'];
}>;


export type ContactSupportMutation = { __typename?: 'Mutation', userContactSupport: boolean };

export type OverrrideLinkQueryVariables = Exact<{
  appointmentId: Scalars['Float'];
}>;


export type OverrrideLinkQuery = { __typename?: 'Query', appointment: { __typename?: 'Lecture', override_meeting_link?: string | null } };

export type JoinMeetingMutationVariables = Exact<{
  appointmentId: Scalars['Float'];
}>;


export type JoinMeetingMutation = { __typename?: 'Mutation', appointmentTrackJoin: boolean };

export type GetZoomMeetingLinkMutationVariables = Exact<{
  appointmentId: Scalars['Float'];
}>;


export type GetZoomMeetingLinkMutation = { __typename?: 'Mutation', appointmentZoomLinkGet: string };

export type AppointmentMeetingDataQueryVariables = Exact<{
  appointmentId: Scalars['Float'];
}>;


export type AppointmentMeetingDataQuery = { __typename?: 'Query', appointment: { __typename?: 'Lecture', zoomMeetingId?: string | null, isOrganizer: boolean, isParticipant: boolean, zoomMeetingPassword?: string | null } };

export type ZoomCredentialsOrganizerQueryVariables = Exact<{
  meetingId: Scalars['String'];
  role: Scalars['Float'];
}>;


export type ZoomCredentialsOrganizerQuery = { __typename?: 'Query', me: { __typename?: 'UserType', firstname: string, lastname: string, email: string, zoomZAK: string, zoomSDKJWT: string } };

export type ZoomCredentialsParticipantQueryVariables = Exact<{
  meetingId: Scalars['String'];
  role: Scalars['Float'];
}>;


export type ZoomCredentialsParticipantQuery = { __typename?: 'Query', me: { __typename?: 'UserType', firstname: string, lastname: string, email: string, zoomSDKJWT: string } };

export type CancelAppointmentMutationVariables = Exact<{
  appointmentId: Scalars['Float'];
}>;


export type CancelAppointmentMutation = { __typename?: 'Mutation', appointmentCancel: boolean };

export type DeclineAppointmentMutationVariables = Exact<{
  appointmentId: Scalars['Float'];
}>;


export type DeclineAppointmentMutation = { __typename?: 'Mutation', appointmentDecline: boolean };

export type LoginTokenForSecondDeviceMutationVariables = Exact<{
  expiresAt: Scalars['DateTime'];
  description: Scalars['String'];
}>;


export type LoginTokenForSecondDeviceMutation = { __typename?: 'Mutation', tokenCreate: string };

export type MyChatSignatureQueryVariables = Exact<{ [key: string]: never; }>;


export type MyChatSignatureQuery = { __typename?: 'Query', me: { __typename?: 'UserType', userID: string, chatSignature: string } };

export type LoginWithDeviceTokenMutationVariables = Exact<{
  deviceToken: Scalars['String'];
  deviceId: Scalars['String'];
}>;


export type LoginWithDeviceTokenMutation = { __typename?: 'Mutation', loginToken: boolean };

export type CreateDeviceTokenMutationVariables = Exact<{
  description: Scalars['String'];
  deviceId: Scalars['String'];
}>;


export type CreateDeviceTokenMutation = { __typename?: 'Mutation', tokenCreate: string };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', myRoles: Array<string>, me: { __typename?: 'UserType', userID: string, firstname: string, lastname: string, email: string, pupil?: { __typename?: 'Pupil', id: number, verifiedAt?: any | null } | null, student?: { __typename?: 'Student', id: number, verifiedAt?: any | null, hasDoneEthicsOnboarding?: boolean | null } | null, screener?: { __typename?: 'Screener', id: number } | null } };

export type RevokeTokenMutationVariables = Exact<{
  deviceToken: Scalars['String'];
}>;


export type RevokeTokenMutation = { __typename?: 'Mutation', tokenRevoke: boolean };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type LoginMutationVariables = Exact<{
  password: Scalars['String'];
  email: Scalars['String'];
  deviceId: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'Mutation', loginPassword: boolean };

export type MutationLoginWithSsoMutationVariables = Exact<{
  code: Scalars['String'];
  referrer: Scalars['String'];
}>;


export type MutationLoginWithSsoMutation = { __typename?: 'Mutation', loginWithSSO: SsoAuthStatus };

export type ConcreteNotificationQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ConcreteNotificationQuery = { __typename?: 'Query', concrete_notification?: { __typename?: 'Concrete_notification', id: number, sentAt: any, message?: { __typename?: 'NotificationMessage', headline: string, body: string, modalText?: string | null, type: string, navigateTo?: string | null } | null } | null };

export type ConcreteNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConcreteNotificationsQuery = { __typename?: 'Query', me: { __typename?: 'UserType', concreteNotifications: Array<{ __typename?: 'Concrete_notification', id: number, sentAt: any, message?: { __typename?: 'NotificationMessage', headline: string, body: string, modalText?: string | null, type: string, navigateTo?: string | null } | null }> } };

export type SearchSchoolsQueryVariables = Exact<{
  name: Scalars['String'];
}>;


export type SearchSchoolsQuery = { __typename?: 'Query', externalSchoolSearch: Array<{ __typename?: 'ExternalSchoolSearch', id: string, name: string, state: State, schooltype?: SchoolType | null, zip?: string | null, city?: string | null, email?: string | null }> };

export type GetLastTimeCheckedNotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLastTimeCheckedNotificationsQuery = { __typename?: 'Query', me: { __typename?: 'UserType', lastTimeCheckedNotifications?: any | null } };

export type UpdateMeLastTimeMutationVariables = Exact<{
  lastTimeCheckedNotifications?: InputMaybe<Scalars['DateTime']>;
}>;


export type UpdateMeLastTimeMutation = { __typename?: 'Mutation', meUpdate: boolean };

export type GetNotificationPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationPreferencesQuery = { __typename?: 'Query', me: { __typename?: 'UserType', notificationPreferences?: any | null } };

export type ChangeMeNotificationPrefMutationVariables = Exact<{
  preferences: PreferencesInput;
}>;


export type ChangeMeNotificationPrefMutation = { __typename?: 'Mutation', meUpdate: boolean };

export type GetPushPublicKeyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPushPublicKeyQuery = { __typename?: 'Query', pushPublicKey?: string | null };

export type AddSubscriptionMutationVariables = Exact<{
  subscription: CreatePushSubscriptionInput;
}>;


export type AddSubscriptionMutation = { __typename?: 'Mutation', userPushSubcriptionAdd: boolean };

export type RemoveSubscriptionMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type RemoveSubscriptionMutation = { __typename?: 'Mutation', userPushSubcriptionRemove: boolean };

export type GetPushSubsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPushSubsQuery = { __typename?: 'Query', me: { __typename?: 'UserType', pushSubscriptions: Array<{ __typename?: 'Push_subscription', id: number, endpoint: string }> } };

export type AchievementByIdQueryVariables = Exact<{
  achievementId: Scalars['Float'];
}>;


export type AchievementByIdQuery = { __typename?: 'Query', me: { __typename?: 'UserType', achievement: { __typename?: 'Achievement', title?: string | null, tagline?: string | null, subtitle?: string | null, description: string, footer?: string | null, achievementState: Achievement_State, achievementType: Achievement_Type_Enum, isNewAchievement?: boolean | null, maxSteps: number, currentStep: number, image: string, alternativeText: string, actionType?: Achievement_Action_Type_Enum | null, actionName?: string | null, actionRedirectLink?: string | null, steps?: Array<{ __typename?: 'Step', name: string, isActive?: boolean | null }> | null } } };

export type CreateAdHocMeetingMutationVariables = Exact<{
  matchId: Scalars['Int'];
}>;


export type CreateAdHocMeetingMutation = { __typename?: 'Mutation', matchCreateAdHocMeeting?: { __typename?: 'AdHocMeeting', id: number, appointmentType: string, zoomUrl?: string | null } | null };

export type SearchInstructorsQueryVariables = Exact<{
  search: Scalars['String'];
  take: Scalars['Int'];
}>;


export type SearchInstructorsQuery = { __typename?: 'Query', otherInstructors: Array<{ __typename?: 'Instructor', id: number, firstname: string, lastname: string }> };

export type JoinFromWaitinglistMutationVariables = Exact<{
  subcourseId: Scalars['Float'];
  pupilId: Scalars['Float'];
}>;


export type JoinFromWaitinglistMutation = { __typename?: 'Mutation', subcourseJoinFromWaitinglist: boolean };

export type JoinFromProspectListMutationVariables = Exact<{
  subcourseId: Scalars['Float'];
  pupilId: Scalars['Float'];
}>;


export type JoinFromProspectListMutation = { __typename?: 'Mutation', subcourseJoinFromProspects: boolean };

export type SendAppFeedbackMutationVariables = Exact<{
  allowContact: Scalars['Boolean'];
  notes: Scalars['String'];
  attachment?: InputMaybe<AppFeedbackAttachment>;
}>;


export type SendAppFeedbackMutation = { __typename?: 'Mutation', userSendAppFeedback: boolean };

export type CancelSubcourseMutationVariables = Exact<{
  subcourseId: Scalars['Float'];
}>;


export type CancelSubcourseMutation = { __typename?: 'Mutation', subcourseCancel: boolean };

export type ChangeEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ChangeEmailMutation = { __typename?: 'Mutation', meChangeEmail: boolean };

export type IsEmailAvailableMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type IsEmailAvailableMutation = { __typename?: 'Mutation', isEmailAvailable: boolean };

export type SendReportOnSupportMutationVariables = Exact<{
  subject: Scalars['String'];
  message: Scalars['String'];
}>;


export type SendReportOnSupportMutation = { __typename?: 'Mutation', userContactSupport: boolean };

export type DeactiveAccountMutationVariables = Exact<{
  reason?: InputMaybe<Scalars['String']>;
}>;


export type DeactiveAccountMutation = { __typename?: 'Mutation', meDeactivate: boolean };

export type IncreaseMaxParticipantsMutationVariables = Exact<{
  maxParticipants: Scalars['Int'];
  subcourseId: Scalars['Float'];
}>;


export type IncreaseMaxParticipantsMutation = { __typename?: 'Mutation', subcourseEdit: { __typename?: 'Subcourse', maxParticipants: number } };

export type RemoveParticipantFromCourseMutationVariables = Exact<{
  subcourseId: Scalars['Float'];
  pupilId: Scalars['Float'];
}>;


export type RemoveParticipantFromCourseMutation = { __typename?: 'Mutation', subcourseLeave: boolean };

export type ReportMatchMutationVariables = Exact<{
  matchId: Scalars['Int'];
  description: Scalars['String'];
}>;


export type ReportMatchMutation = { __typename?: 'Mutation', matchReport: boolean };

export type ExistingScreeningsQueryVariables = Exact<{ [key: string]: never; }>;


export type ExistingScreeningsQuery = { __typename?: 'Query', me: { __typename?: 'UserType', pupil?: { __typename?: 'Pupil', grade?: string | null, subjectsFormatted: Array<{ __typename?: 'Subject', name: string }>, screenings: Array<{ __typename?: 'Pupil_screening', status: Pupil_Screening_Status_Enum }> } | null, student?: { __typename?: 'Student', tutorScreenings: Array<{ __typename?: 'Screening', success: boolean }>, instructorScreenings: Array<{ __typename?: 'Instructor_screening', success: boolean }> } | null } };

export type GetCourseTagsQueryVariables = Exact<{
  category: Scalars['String'];
}>;


export type GetCourseTagsQuery = { __typename?: 'Query', courseTags: Array<{ __typename?: 'Course_tag', id: number, name: string }> };

export type SearchCourseImagesQueryVariables = Exact<{
  search: Scalars['String'];
  page: Scalars['Float'];
}>;


export type SearchCourseImagesQuery = { __typename?: 'Query', courseImages: { __typename?: 'CourseImageSearchResponse', total: number, totalPages: number, results: Array<{ __typename?: 'CourseImage', id: string, description: string, regularImageUrl: string, smallImageUrl: string }> } };

export type RequestVerifyEmailMutationVariables = Exact<{
  email: Scalars['String'];
  redirectTo: Scalars['String'];
}>;


export type RequestVerifyEmailMutation = { __typename?: 'Mutation', tokenRequest: boolean };

export type AppointmentStudentQueryVariables = Exact<{
  appointmentId: Scalars['Float'];
}>;


export type AppointmentStudentQuery = { __typename?: 'Query', appointment: { __typename?: 'Lecture', id: number, start: any, duration: number, title?: string | null, description?: string | null, isCanceled?: boolean | null, position: number, appointmentType: Lecture_Appointmenttype_Enum, total: number, displayName: string, isOrganizer: boolean, override_meeting_link?: string | null, zoomMeetingUrl?: string | null, subcourseId?: number | null, matchId?: number | null, declinedBy: Array<string>, zoomMeetingId?: string | null, participants?: Array<{ __typename?: 'AppointmentParticipant', id?: number | null, userID?: string | null, firstname?: string | null, lastname?: string | null }> | null, organizers: Array<{ __typename?: 'Organizer', id: number, userID?: string | null, firstname: string, lastname: string }>, subcourse?: { __typename?: 'Subcourse', published: boolean, course: { __typename?: 'Course', category: Course_Category_Enum } } | null } };

export type AppointmentPupilQueryVariables = Exact<{
  appointmentId: Scalars['Float'];
}>;


export type AppointmentPupilQuery = { __typename?: 'Query', appointment: { __typename?: 'Lecture', id: number, start: any, duration: number, title?: string | null, description?: string | null, isCanceled?: boolean | null, position: number, appointmentType: Lecture_Appointmenttype_Enum, total: number, displayName: string, isOrganizer: boolean, override_meeting_link?: string | null, zoomMeetingUrl?: string | null, subcourseId?: number | null, matchId?: number | null, declinedBy: Array<string>, zoomMeetingId?: string | null, participants?: Array<{ __typename?: 'AppointmentParticipant', id?: number | null, userID?: string | null, firstname?: string | null }> | null, organizers: Array<{ __typename?: 'Organizer', id: number, userID?: string | null, firstname: string, lastname: string }>, subcourse?: { __typename?: 'Subcourse', published: boolean } | null } };

export type MyAppointments_No_CacheQueryVariables = Exact<{
  take: Scalars['Float'];
  skip: Scalars['Float'];
  cursor?: InputMaybe<Scalars['Float']>;
  direction?: InputMaybe<Scalars['String']>;
}>;


export type MyAppointments_No_CacheQuery = { __typename?: 'Query', me: { __typename?: 'UserType', appointments?: Array<{ __typename?: 'Lecture', id: number, title?: string | null, description?: string | null, start: any, duration: number, appointmentType: Lecture_Appointmenttype_Enum, total: number, position: number, displayName: string, isOrganizer: boolean, isParticipant: boolean, declinedBy: Array<string>, zoomMeetingId?: string | null, organizers: Array<{ __typename?: 'Organizer', id: number, userID?: string | null, firstname: string, lastname: string }>, participants?: Array<{ __typename?: 'AppointmentParticipant', id?: number | null, userID?: string | null, firstname?: string | null, lastname?: string | null }> | null, subcourse?: { __typename?: 'Subcourse', published: boolean } | null }> | null } };

export type AppoimtmentsMetaDataQueryVariables = Exact<{ [key: string]: never; }>;


export type AppoimtmentsMetaDataQuery = { __typename?: 'Query', me: { __typename?: 'UserType', hasAppointments: boolean, lastAppointmentId?: number | null, firstAppointmentId?: number | null } };

export type GetCocDateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCocDateQuery = { __typename?: 'Query', me: { __typename?: 'UserType', student?: { __typename?: 'Student', certificateOfConductDeactivationDate?: any | null } | null } };

export type DownloadRemissionRequestMutationVariables = Exact<{ [key: string]: never; }>;


export type DownloadRemissionRequestMutation = { __typename?: 'Mutation', studentGetRemissionRequestAsPDF: string };

export type MyEmailQueryVariables = Exact<{ [key: string]: never; }>;


export type MyEmailQuery = { __typename?: 'Query', me: { __typename?: 'UserType', firstname: string, email: string } };

export type GetPupilCertificateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPupilCertificateQuery = { __typename?: 'Query', me: { __typename?: 'UserType', pupil?: { __typename?: 'Pupil', participationCertificatesToSign: Array<{ __typename?: 'Participation_certificate', id: number, uuid: string, ongoingLessons: boolean, state: string, categories: string, startDate: any, endDate: any, hoursPerWeek: any, hoursTotal: any, medium: string, student: { __typename?: 'Student', firstname?: string | null, lastname?: string | null } }> } | null } };

export type StudentCanCreateCourseQueryVariables = Exact<{ [key: string]: never; }>;


export type StudentCanCreateCourseQuery = { __typename?: 'Query', me: { __typename?: 'UserType', student?: { __typename?: 'Student', id: number, firstname?: string | null, lastname?: string | null, canCreateCourse: { __typename?: 'Decision', allowed: boolean, reason?: string | null } } | null } };

export type GetSubcourseQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetSubcourseQuery = { __typename?: 'Query', subcourse?: { __typename?: 'Subcourse', id: number, participantsCount: number, maxParticipants: number, minGrade: number, maxGrade: number, published: boolean, joinAfterStart: boolean, allowChatContactParticipants: boolean, allowChatContactProspects: boolean, groupChatType: Chat_Type, instructors: Array<{ __typename?: 'Instructor', id: number, firstname: string, lastname: string }>, course: { __typename?: 'Course', id: number, name: string, image?: string | null, category: Course_Category_Enum, description: string, subject?: Course_Subject_Enum | null, allowContact: boolean, tags: Array<{ __typename?: 'Course_tag', id: number, name: string }> }, appointments: Array<{ __typename?: 'Lecture', id: number, start: any, duration: number, title?: string | null, description?: string | null, displayName: string, position: number, total: number, appointmentType: Lecture_Appointmenttype_Enum, participants?: Array<{ __typename?: 'AppointmentParticipant', firstname?: string | null, lastname?: string | null }> | null, organizers: Array<{ __typename?: 'Organizer', firstname: string, lastname: string }> }> } | null };

export type CreateCourseMutationVariables = Exact<{
  course: PublicCourseCreateInput;
}>;


export type CreateCourseMutation = { __typename?: 'Mutation', courseCreate: { __typename?: 'Course', id: number } };

export type UpdateCourseMutationVariables = Exact<{
  course: PublicCourseEditInput;
  id: Scalars['Float'];
}>;


export type UpdateCourseMutation = { __typename?: 'Mutation', courseEdit: { __typename?: 'Course', id: number } };

export type CreateSubcourseMutationVariables = Exact<{
  courseId: Scalars['Float'];
  subcourse: PublicSubcourseCreateInput;
}>;


export type CreateSubcourseMutation = { __typename?: 'Mutation', subcourseCreate: { __typename?: 'Subcourse', id: number, canPublish: { __typename?: 'Decision', allowed: boolean, reason?: string | null } } };

export type AppointmentsCourseCreateMutationVariables = Exact<{
  appointments: Array<AppointmentCreateGroupInput> | AppointmentCreateGroupInput;
  subcourseId: Scalars['Float'];
}>;


export type AppointmentsCourseCreateMutation = { __typename?: 'Mutation', appointmentsGroupCreate: boolean };

export type UpdateSubcourseMutationVariables = Exact<{
  course: PublicSubcourseEditInput;
  id: Scalars['Float'];
}>;


export type UpdateSubcourseMutation = { __typename?: 'Mutation', subcourseEdit: { __typename?: 'Subcourse', id: number } };

export type SetCourseImageMutationVariables = Exact<{
  courseId: Scalars['Float'];
  fileId: Scalars['String'];
}>;


export type SetCourseImageMutation = { __typename?: 'Mutation', courseSetImage: boolean };

export type AddCourseInstructorMutationVariables = Exact<{
  studentId: Scalars['Float'];
  courseId: Scalars['Float'];
}>;


export type AddCourseInstructorMutation = { __typename?: 'Mutation', subcourseAddInstructor: boolean };

export type RemoveCourseInstructorMutationVariables = Exact<{
  studentId: Scalars['Float'];
  courseId: Scalars['Float'];
}>;


export type RemoveCourseInstructorMutation = { __typename?: 'Mutation', subcourseDeleteInstructor: boolean };

export type SetCourseTagsMutationVariables = Exact<{
  courseId: Scalars['Float'];
  courseTagIds: Array<Scalars['Float']> | Scalars['Float'];
}>;


export type SetCourseTagsMutation = { __typename?: 'Mutation', courseSetTags: boolean };

export type SubmitCourseMutationVariables = Exact<{
  courseId: Scalars['Float'];
}>;


export type SubmitCourseMutation = { __typename?: 'Mutation', courseSubmit: boolean };

export type GenerateLessonPlanMutationVariables = Exact<{
  data: GenerateLessonPlanInput;
}>;


export type GenerateLessonPlanMutation = { __typename?: 'Mutation', generateLessonPlan: { __typename?: 'LessonPlanOutput', title?: string | null, subject: CourseSubjectEnum, grade: string, duration: number, learningGoal?: string | null, agendaExercises?: string | null, assessment?: string | null, homework?: string | null, resources?: string | null } };

export type DetermineLoginOptionsMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type DetermineLoginOptionsMutation = { __typename?: 'Mutation', userDetermineLoginOptions: string };

export type PasswordResetMutationVariables = Exact<{
  email: Scalars['String'];
  redirectTo: Scalars['String'];
}>;


export type PasswordResetMutation = { __typename?: 'Mutation', tokenRequest: boolean };

export type AuthenticateMutationVariables = Exact<{
  email: Scalars['String'];
  redirectTo: Scalars['String'];
}>;


export type AuthenticateMutation = { __typename?: 'Mutation', tokenRequest: boolean };

export type AchievementsQueryVariables = Exact<{ [key: string]: never; }>;


export type AchievementsQuery = { __typename?: 'Query', me: { __typename?: 'UserType', achievements: Array<{ __typename?: 'Achievement', id: number, name: string, title?: string | null, tagline?: string | null, subtitle?: string | null, description: string, footer?: string | null, image: string, alternativeText: string, achievementType: Achievement_Type_Enum, achievementState: Achievement_State, maxSteps: number, currentStep: number, isNewAchievement?: boolean | null, actionType?: Achievement_Action_Type_Enum | null, actionName?: string | null, actionRedirectLink?: string | null, steps?: Array<{ __typename?: 'Step', name: string, isActive?: boolean | null }> | null }> } };

export type FurtherAchievementsQueryVariables = Exact<{ [key: string]: never; }>;


export type FurtherAchievementsQuery = { __typename?: 'Query', me: { __typename?: 'UserType', furtherAchievements: Array<{ __typename?: 'Achievement', id: number, name: string, title?: string | null, tagline?: string | null, subtitle?: string | null, description: string, footer?: string | null, image: string, alternativeText: string, achievementType: Achievement_Type_Enum, achievementState: Achievement_State, maxSteps: number, currentStep: number, isNewAchievement?: boolean | null, actionType?: Achievement_Action_Type_Enum | null, actionName?: string | null, actionRedirectLink?: string | null, steps?: Array<{ __typename?: 'Step', name: string, isActive?: boolean | null }> | null }> } };

export type ReferralCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ReferralCountQuery = { __typename?: 'Query', me: { __typename?: 'UserType', referralCount: number } };

export type SupportedHoursQueryVariables = Exact<{ [key: string]: never; }>;


export type SupportedHoursQuery = { __typename?: 'Query', me: { __typename?: 'UserType', supportedHours: number } };

export type RegisterPupilMutationVariables = Exact<{
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  email: Scalars['String'];
  newsletter: Scalars['Boolean'];
  grade: Scalars['Int'];
  school: RegistrationSchool;
  referredById?: InputMaybe<Scalars['String']>;
  emailOwner: PupilEmailOwner;
}>;


export type RegisterPupilMutation = { __typename?: 'Mutation', meUpdate: boolean, meRegisterPupil: { __typename?: 'Pupil', id: number } };

export type RegisterStudentMutationVariables = Exact<{
  firstname: Scalars['String'];
  lastname: Scalars['String'];
  email: Scalars['String'];
  newsletter: Scalars['Boolean'];
  cooperationTag?: InputMaybe<Scalars['String']>;
  referredById?: InputMaybe<Scalars['String']>;
}>;


export type RegisterStudentMutation = { __typename?: 'Mutation', meRegisterStudent: { __typename?: 'Student', id: number } };

export type CreateCredentialsMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  retainPath: Scalars['String'];
}>;


export type CreateCredentialsMutation = { __typename?: 'Mutation', passwordCreate: boolean, tokenRequest: boolean };

export type CooperationsQueryVariables = Exact<{ [key: string]: never; }>;


export type CooperationsQuery = { __typename?: 'Query', cooperations: Array<{ __typename?: 'Cooperation', id: number, tag: string, name: string, welcomeTitle: string, welcomeMessage: string }> };

export type RequestCertificateMutationVariables = Exact<{
  matchId: Scalars['String'];
  certificateData: CertificateCreationInput;
}>;


export type RequestCertificateMutation = { __typename?: 'Mutation', participationCertificateCreate: boolean };

export type ChangePasswordMutationVariables = Exact<{
  password: Scalars['String'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', passwordCreate: boolean };

export type SessionQueryVariables = Exact<{ [key: string]: never; }>;


export type SessionQuery = { __typename?: 'Query', me: { __typename?: 'UserType', secrets: Array<{ __typename?: 'Secret', id: number, type: Secret_Type_Enum, description?: string | null, lastUsed?: any | null, lastUsedDeviceId?: string | null }> } };

export type RevokeMutationVariables = Exact<{
  id: Scalars['Float'];
}>;


export type RevokeMutation = { __typename?: 'Mutation', tokenRevoke: boolean };

export type SingleMatchQueryVariables = Exact<{
  matchId: Scalars['Int'];
}>;


export type SingleMatchQuery = { __typename?: 'Query', match: { __typename?: 'Match', id: number, uuid: string, createdAt: any, dissolved: boolean, dissolvedAt?: any | null, appointmentsCount: number, lastAppointmentId?: number | null, firstAppointmentId?: number | null, pupil: { __typename?: 'Pupil', id: number, firstname?: string | null, lastname?: string | null, schooltype: Pupil_Schooltype_Enum, grade?: string | null, gradeAsInt: number, state: Pupil_State_Enum, aboutMe: string, subjectsFormatted: Array<{ __typename?: 'Subject', name: string }> }, student: { __typename?: 'Student', id: number, firstname?: string | null, lastname?: string | null, state?: Student_State_Enum | null, aboutMe: string, subjectsFormatted: Array<{ __typename?: 'Subject', name: string }> } } };

export type SingleMatchAppointments_No_CacheQueryVariables = Exact<{
  matchId: Scalars['Int'];
  take: Scalars['Float'];
  skip: Scalars['Float'];
  cursor?: InputMaybe<Scalars['Float']>;
  direction?: InputMaybe<Scalars['String']>;
}>;


export type SingleMatchAppointments_No_CacheQuery = { __typename?: 'Query', match: { __typename?: 'Match', appointments: Array<{ __typename?: 'Lecture', id: number, title?: string | null, description?: string | null, start: any, duration: number, appointmentType: Lecture_Appointmenttype_Enum, total: number, position: number, displayName: string, isOrganizer: boolean, isParticipant: boolean, override_meeting_link?: string | null, declinedBy: Array<string>, organizers: Array<{ __typename?: 'Organizer', id: number, firstname: string, lastname: string }>, participants?: Array<{ __typename?: 'AppointmentParticipant', userID?: string | null, id?: number | null, firstname?: string | null, lastname?: string | null }> | null }> } };

export type CreateMatcheeChatMutationVariables = Exact<{
  matcheeId: Scalars['String'];
}>;


export type CreateMatcheeChatMutation = { __typename?: 'Mutation', matchChatCreate: string };

export type DissolveMatchStudent2MutationVariables = Exact<{
  matchId: Scalars['Int'];
  dissolveReasons: Array<Dissolve_Reason> | Dissolve_Reason;
  otherFreeText?: InputMaybe<Scalars['String']>;
}>;


export type DissolveMatchStudent2Mutation = { __typename?: 'Mutation', matchDissolve: boolean };

export type GetStudentLanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStudentLanguagesQuery = { __typename?: 'Query', me: { __typename?: 'UserType', student?: { __typename?: 'Student', languages: Array<Student_Languages_Enum> } | null } };

export type GetPupilLanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPupilLanguagesQuery = { __typename?: 'Query', me: { __typename?: 'UserType', pupil?: { __typename?: 'Pupil', languages: Array<Pupil_Languages_Enum> } | null } };

export type UpdateLanguageStudentMutationVariables = Exact<{
  languages?: InputMaybe<Array<StudentLanguage> | StudentLanguage>;
}>;


export type UpdateLanguageStudentMutation = { __typename?: 'Mutation', meUpdate: boolean };

export type UpdateLanguagePupilMutationVariables = Exact<{
  languages?: InputMaybe<Array<Language> | Language>;
}>;


export type UpdateLanguagePupilMutation = { __typename?: 'Mutation', meUpdate: boolean };

export type GetPupilSchoolQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPupilSchoolQuery = { __typename?: 'Query', me: { __typename?: 'UserType', pupil?: { __typename?: 'Pupil', schooltype: Pupil_Schooltype_Enum, gradeAsInt: number } | null } };

export type UpdateSchoolGradePupilMutationVariables = Exact<{
  grade: Scalars['Int'];
}>;


export type UpdateSchoolGradePupilMutation = { __typename?: 'Mutation', meUpdate: boolean };

export type GetPupilSchooltypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPupilSchooltypeQuery = { __typename?: 'Query', me: { __typename?: 'UserType', pupil?: { __typename?: 'Pupil', schooltype: Pupil_Schooltype_Enum } | null } };

export type UpdateSchooltypePupilMutationVariables = Exact<{
  schooltype: SchoolType;
}>;


export type UpdateSchooltypePupilMutation = { __typename?: 'Mutation', meUpdate: boolean };

export type GetPupilStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPupilStateQuery = { __typename?: 'Query', me: { __typename?: 'UserType', pupil?: { __typename?: 'Pupil', state: Pupil_State_Enum } | null } };

export type GetStudentStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetStudentStateQuery = { __typename?: 'Query', me: { __typename?: 'UserType', student?: { __typename?: 'Student', state?: Student_State_Enum | null } | null } };

export type UpdateStateStudentMutationVariables = Exact<{
  state: StudentState;
}>;


export type UpdateStateStudentMutation = { __typename?: 'Mutation', meUpdate: boolean };

export type UpdateStatePupilMutationVariables = Exact<{
  state: State;
}>;


export type UpdateStatePupilMutation = { __typename?: 'Mutation', meUpdate: boolean };

export type StudentCourseMatchesQueryVariables = Exact<{ [key: string]: never; }>;


export type StudentCourseMatchesQuery = { __typename?: 'Query', me: { __typename?: 'UserType', firstname: string, student?: { __typename?: 'Student', matches: Array<{ __typename?: 'Match', id: number, uuid: string, dissolved: boolean, pupil: { __typename?: 'Pupil', firstname?: string | null, lastname?: string | null, schooltype: Pupil_Schooltype_Enum, grade?: string | null, gradeAsInt: number, subjectsFormatted: Array<{ __typename?: 'Subject', name: string }> }, appointments: Array<{ __typename?: 'Lecture', id: number }> }>, subcoursesInstructing: Array<{ __typename?: 'Subcourse', id: number, published: boolean, lectures: Array<{ __typename?: 'Lecture', start: any, duration: number }>, firstLecture?: { __typename?: 'Lecture', id: number, start: any, duration: number } | null, course: { __typename?: 'Course', name: string, description: string, tags: Array<{ __typename?: 'Course_tag', name: string }> } }> } | null } };

export type TotalAppointmentsCreatedQueryVariables = Exact<{ [key: string]: never; }>;


export type TotalAppointmentsCreatedQuery = { __typename?: 'Query', me: { __typename?: 'UserType', student?: { __typename?: 'Student', totalLecturesOrganized: number } | null } };

export type AppointmentsGroupCreateMutationVariables = Exact<{
  appointments: Array<AppointmentCreateGroupInput> | AppointmentCreateGroupInput;
  id: Scalars['Float'];
}>;


export type AppointmentsGroupCreateMutation = { __typename?: 'Mutation', appointmentsGroupCreate: boolean };

export type AppointmentsMatchCreateMutationVariables = Exact<{
  appointments: Array<AppointmentCreateMatchInput> | AppointmentCreateMatchInput;
  id: Scalars['Float'];
}>;


export type AppointmentsMatchCreateMutation = { __typename?: 'Mutation', appointmentsMatchCreate: boolean };

export type SubcourseAppointmentsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type SubcourseAppointmentsQuery = { __typename?: 'Query', subcourse?: { __typename?: 'Subcourse', course: { __typename?: 'Course', name: string }, appointments: Array<{ __typename?: 'Lecture', id: number, start: any, duration: number, title?: string | null, description?: string | null, displayName: string, position: number, total: number, appointmentType: Lecture_Appointmenttype_Enum, override_meeting_link?: string | null, participants?: Array<{ __typename?: 'AppointmentParticipant', id?: number | null, firstname?: string | null, lastname?: string | null, isPupil?: boolean | null, isStudent?: boolean | null }> | null, organizers: Array<{ __typename?: 'Organizer', id: number, firstname: string, lastname: string }> }> } | null };

export type MatchAppointmentsQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type MatchAppointmentsQuery = { __typename?: 'Query', match: { __typename?: 'Match', pupil: { __typename?: 'Pupil', id: number, firstname?: string | null, lastname?: string | null }, appointments: Array<{ __typename?: 'Lecture', id: number, matchId?: number | null, start: any, duration: number, title?: string | null, description?: string | null, displayName: string, position: number, total: number, appointmentType: Lecture_Appointmenttype_Enum, override_meeting_link?: string | null, participants?: Array<{ __typename?: 'AppointmentParticipant', id?: number | null, firstname?: string | null, lastname?: string | null, isPupil?: boolean | null, isStudent?: boolean | null }> | null, organizers: Array<{ __typename?: 'Organizer', id: number, firstname: string, lastname: string }> }> } };

export type GetAppointmentByIdQueryVariables = Exact<{
  appointmentId: Scalars['Float'];
}>;


export type GetAppointmentByIdQuery = { __typename?: 'Query', appointment: { __typename?: 'Lecture', id: number, start: any, duration: number, title?: string | null, description?: string | null, position: number, displayName: string, appointmentType: Lecture_Appointmenttype_Enum, matchId?: number | null, subcourseId?: number | null } };

export type UpdateAppointmentMutationVariables = Exact<{
  appointmentToBeUpdated: AppointmentUpdateInput;
}>;


export type UpdateAppointmentMutation = { __typename?: 'Mutation', appointmentUpdate: boolean };

export type MeEmailQueryVariables = Exact<{ [key: string]: never; }>;


export type MeEmailQuery = { __typename?: 'Query', me: { __typename?: 'UserType', firstname: string, email: string } };

export type UpdateHasDoneEthicsOnboardingMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateHasDoneEthicsOnboardingMutation = { __typename?: 'Mutation', studentUpdate: boolean };

export type PupilDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type PupilDashboardQuery = { __typename?: 'Query', myRoles: Array<string>, me: { __typename?: 'UserType', firstname: string, pupil?: { __typename?: 'Pupil', firstMatchRequest?: any | null, openMatchRequestCount: number, matches: Array<{ __typename?: 'Match', id: number, uuid: string, dissolved: boolean, subjectsFormatted: Array<{ __typename?: 'Subject', name: string }>, student: { __typename?: 'Student', id: number, firstname?: string | null, lastname?: string | null } }>, canRequestMatch: { __typename?: 'Decision', allowed: boolean, reason?: string | null, limit?: number | null }, canJoinSubcourses: { __typename?: 'Decision', allowed: boolean, reason?: string | null, limit?: number | null }, subcoursesJoined: Array<{ __typename?: 'Subcourse', id: number, isParticipant: boolean, minGrade: number, maxGrade: number, participantsCount: number, maxParticipants: number, published: boolean, cancelled: boolean, lectures: Array<{ __typename?: 'Lecture', start: any, duration: number }>, course: { __typename?: 'Course', courseState: Course_Coursestate_Enum, name: string, image?: string | null, subject?: Course_Subject_Enum | null, description: string, tags: Array<{ __typename?: 'Course_tag', name: string }> } }> } | null, appointments?: Array<{ __typename?: 'Lecture', id: number, title?: string | null, description?: string | null, start: any, duration: number, appointmentType: Lecture_Appointmenttype_Enum, total: number, position: number, displayName: string, isOrganizer: boolean, isParticipant: boolean, declinedBy: Array<string>, zoomMeetingId?: string | null, organizers: Array<{ __typename?: 'Organizer', id: number, userID?: string | null, firstname: string, lastname: string }>, participants?: Array<{ __typename?: 'AppointmentParticipant', id?: number | null, userID?: string | null, firstname?: string | null, lastname?: string | null }> | null, subcourse?: { __typename?: 'Subcourse', published: boolean, course: { __typename?: 'Course', image?: string | null } } | null }> | null }, subcoursesPublic: Array<{ __typename?: 'Subcourse', id: number, minGrade: number, maxGrade: number, joinAfterStart: boolean, maxParticipants: number, participantsCount: number, course: { __typename?: 'Course', name: string, description: string, image?: string | null, tags: Array<{ __typename?: 'Course_tag', name: string }> }, lectures: Array<{ __typename?: 'Lecture', start: any, duration: number }>, firstLecture?: { __typename?: 'Lecture', start: any, duration: number } | null, nextLecture?: { __typename?: 'Lecture', start: any, duration: number } | null }> };

export type CancelMatchRequestMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelMatchRequestMutation = { __typename?: 'Mutation', pupilDeleteMatchRequest: boolean };

export type PupilSubcourseOverviewQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type PupilSubcourseOverviewQuery = { __typename?: 'Query', me: { __typename?: 'UserType', pupil?: { __typename?: 'Pupil', canJoinSubcourses: { __typename?: 'Decision', allowed: boolean, reason?: string | null, limit?: number | null }, subcoursesJoined: Array<{ __typename?: 'Subcourse', id: number, minGrade: number, maxGrade: number, cancelled: boolean, published: boolean, isParticipant: boolean, isOnWaitingList: boolean, maxParticipants: number, participantsCount: number, firstLecture?: { __typename?: 'Lecture', start: any, duration: number } | null, nextLecture?: { __typename?: 'Lecture', start: any, duration: number } | null, lectures: Array<{ __typename?: 'Lecture', start: any, duration: number }>, course: { __typename?: 'Course', name: string, image?: string | null, category: Course_Category_Enum, description: string, courseState: Course_Coursestate_Enum, tags: Array<{ __typename?: 'Course_tag', name: string }> } }>, subcoursesWaitingList: Array<{ __typename?: 'Subcourse', id: number, minGrade: number, maxGrade: number, isParticipant: boolean, cancelled: boolean, published: boolean, isOnWaitingList: boolean, maxParticipants: number, participantsCount: number, firstLecture?: { __typename?: 'Lecture', start: any, duration: number } | null, nextLecture?: { __typename?: 'Lecture', start: any, duration: number } | null, lectures: Array<{ __typename?: 'Lecture', start: any, duration: number }>, course: { __typename?: 'Course', name: string, image?: string | null, category: Course_Category_Enum, description: string, courseState: Course_Coursestate_Enum, tags: Array<{ __typename?: 'Course_tag', name: string }> } }> } | null } };

export type PupilPastSubcoursesOverviewQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type PupilPastSubcoursesOverviewQuery = { __typename?: 'Query', me: { __typename?: 'UserType', pupil?: { __typename?: 'Pupil', canJoinSubcourses: { __typename?: 'Decision', allowed: boolean, reason?: string | null, limit?: number | null }, subcoursesJoined: Array<{ __typename?: 'Subcourse', cancelled: boolean, published: boolean, isOnWaitingList: boolean, id: number, isParticipant: boolean, maxParticipants: number, participantsCount: number, minGrade: number, maxGrade: number, firstLecture?: { __typename?: 'Lecture', start: any, duration: number } | null, nextLecture?: { __typename?: 'Lecture', start: any, duration: number } | null, lectures: Array<{ __typename?: 'Lecture', start: any, duration: number }>, course: { __typename?: 'Course', name: string, image?: string | null, category: Course_Category_Enum, description: string, courseState: Course_Coursestate_Enum, tags: Array<{ __typename?: 'Course_tag', name: string }> } }> } | null } };

export type GetAllSubcoursesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetAllSubcoursesQuery = { __typename?: 'Query', subcoursesPublic: Array<{ __typename?: 'Subcourse', cancelled: boolean, published: boolean, isParticipant: boolean, minGrade: number, maxGrade: number, maxParticipants: number, participantsCount: number, id: number, isOnWaitingList: boolean, firstLecture?: { __typename?: 'Lecture', start: any, duration: number } | null, nextLecture?: { __typename?: 'Lecture', start: any, duration: number } | null, lectures: Array<{ __typename?: 'Lecture', start: any, duration: number }>, course: { __typename?: 'Course', name: string, image?: string | null, category: Course_Category_Enum, description: string, courseState: Course_Coursestate_Enum, tags: Array<{ __typename?: 'Course_tag', name: string }> } }> };

export type PupilMatchingQueryVariables = Exact<{ [key: string]: never; }>;


export type PupilMatchingQuery = { __typename?: 'Query', me: { __typename?: 'UserType', pupil?: { __typename?: 'Pupil', id: number, openMatchRequestCount: number, subjectsFormatted: Array<{ __typename?: 'Subject', name: string, mandatory?: boolean | null }>, matches: Array<{ __typename?: 'Match', id: number, uuid: string, dissolved: boolean, subjectsFormatted: Array<{ __typename?: 'Subject', name: string }>, pupil: { __typename?: 'Pupil', schooltype: Pupil_Schooltype_Enum, grade?: string | null }, student: { __typename?: 'Student', firstname?: string | null, lastname?: string | null } }>, canRequestMatch: { __typename?: 'Decision', allowed: boolean, reason?: string | null, limit?: number | null } } | null } };

export type PupilDeleteMatchRequestMutationVariables = Exact<{ [key: string]: never; }>;


export type PupilDeleteMatchRequestMutation = { __typename?: 'Mutation', pupilDeleteMatchRequest: boolean };

export type PupilProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type PupilProfileQuery = { __typename?: 'Query', me: { __typename?: 'UserType', firstname: string, lastname: string, email: string, pupil?: { __typename?: 'Pupil', aboutMe: string, state: Pupil_State_Enum, schooltype: Pupil_Schooltype_Enum, languages: Array<Pupil_Languages_Enum>, gradeAsInt: number, subjectsFormatted: Array<{ __typename?: 'Subject', name: string }> } | null } };

export type ChangePupilNameMutationVariables = Exact<{
  firstname?: InputMaybe<Scalars['String']>;
  lastname?: InputMaybe<Scalars['String']>;
}>;


export type ChangePupilNameMutation = { __typename?: 'Mutation', meUpdate: boolean };

export type ChangeAboutMePupilMutationVariables = Exact<{
  aboutMe: Scalars['String'];
}>;


export type ChangeAboutMePupilMutation = { __typename?: 'Mutation', meUpdate: boolean };

export type GetOtherParticipantsQueryVariables = Exact<{
  subcourseId: Scalars['Int'];
}>;


export type GetOtherParticipantsQuery = { __typename?: 'Query', subcourse?: { __typename?: 'Subcourse', otherParticipants: Array<{ __typename?: 'OtherParticipant', id: number, firstname: string, grade: string, gradeAsInt: number }> } | null, me: { __typename?: 'UserType', pupil?: { __typename?: 'Pupil', firstname?: string | null, lastname?: string | null, schooltype: Pupil_Schooltype_Enum, grade?: string | null, gradeAsInt: number } | null } };

export type GetSingleSubcoursePupilQueryVariables = Exact<{
  subcourseId: Scalars['Int'];
}>;


export type GetSingleSubcoursePupilQuery = { __typename?: 'Query', subcourse?: { __typename?: 'Subcourse', id: number, participantsCount: number, maxParticipants: number, minGrade: number, maxGrade: number, capacity: number, groupChatType: Chat_Type, allowChatContactProspects: boolean, allowChatContactParticipants: boolean, isParticipant: boolean, isOnWaitingList: boolean, cancelled: boolean, published: boolean, publishedAt?: any | null, nextLecture?: { __typename?: 'Lecture', start: any, duration: number } | null, instructors: Array<{ __typename?: 'Instructor', id: number, firstname: string, lastname: string }>, course: { __typename?: 'Course', id: number, courseState: Course_Coursestate_Enum, name: string, image?: string | null, category: Course_Category_Enum, description: string, subject?: Course_Subject_Enum | null, allowContact: boolean, tags: Array<{ __typename?: 'Course_tag', name: string }> }, lectures: Array<{ __typename?: 'Lecture', start: any, duration: number }>, canJoin: { __typename?: 'Decision', allowed: boolean, reason?: string | null }, canContactInstructor: { __typename?: 'Decision', allowed: boolean, reason?: string | null }, canJoinWaitinglist: { __typename?: 'Decision', allowed: boolean, reason?: string | null }, appointments: Array<{ __typename?: 'Lecture', id: number, appointmentType: Lecture_Appointmenttype_Enum, title?: string | null, description?: string | null, start: any, duration: number, displayName: string, position: number, total: number, isOrganizer: boolean, isParticipant: boolean, subcourse?: { __typename?: 'Subcourse', published: boolean } | null }> } | null };

export type PupilMatchRequestInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type PupilMatchRequestInfoQuery = { __typename?: 'Query', me: { __typename?: 'UserType', pupil?: { __typename?: 'Pupil', schooltype: Pupil_Schooltype_Enum, gradeAsInt: number, state: Pupil_State_Enum, openMatchRequestCount: number, subjectsFormatted: Array<{ __typename?: 'Subject', name: string, mandatory?: boolean | null }> } | null } };

export type UpdatePupilMutationVariables = Exact<{
  subjects?: InputMaybe<Array<SubjectInput> | SubjectInput>;
}>;


export type UpdatePupilMutation = { __typename?: 'Mutation', meUpdate: boolean };

export type PupilCreateMatchRequestMutationVariables = Exact<{ [key: string]: never; }>;


export type PupilCreateMatchRequestMutation = { __typename?: 'Mutation', pupilCreateMatchRequest: boolean };

export type ChangeSchooltypeDataMutationVariables = Exact<{
  data: SchoolType;
}>;


export type ChangeSchooltypeDataMutation = { __typename?: 'Mutation', meUpdate: boolean };

export type ChangeSchoolClassDataMutationVariables = Exact<{
  data: Scalars['Int'];
}>;


export type ChangeSchoolClassDataMutation = { __typename?: 'Mutation', meUpdate: boolean };

export type ChangePupilStateDataMutationVariables = Exact<{
  data: State;
}>;


export type ChangePupilStateDataMutation = { __typename?: 'Mutation', meUpdate: boolean };

export type GetCourseConversationIdQueryVariables = Exact<{
  subcourseId: Scalars['Int'];
  isParticipant: Scalars['Boolean'];
}>;


export type GetCourseConversationIdQuery = { __typename?: 'Query', subcourse?: { __typename?: 'Subcourse', conversationId?: string | null } | null };

export type TotalSubcoursesJoinedQueryVariables = Exact<{ [key: string]: never; }>;


export type TotalSubcoursesJoinedQuery = { __typename?: 'Query', me: { __typename?: 'UserType', pupil?: { __typename?: 'Pupil', totalSubcoursesJoined: number } | null } };

export type SubcourseJoinMutationVariables = Exact<{
  subcourseId: Scalars['Float'];
}>;


export type SubcourseJoinMutation = { __typename?: 'Mutation', subcourseJoin: boolean };

export type LeaveSubcourseMutationVariables = Exact<{
  subcourseId: Scalars['Float'];
}>;


export type LeaveSubcourseMutation = { __typename?: 'Mutation', subcourseLeave: boolean };

export type JoinWaitingListMutationVariables = Exact<{
  subcourseId: Scalars['Float'];
}>;


export type JoinWaitingListMutation = { __typename?: 'Mutation', subcourseJoinWaitinglist: boolean };

export type LeaveWaitingListMutationVariables = Exact<{
  subcourseId: Scalars['Float'];
}>;


export type LeaveWaitingListMutation = { __typename?: 'Mutation', subcourseLeaveWaitinglist: boolean };

export type CreateInstructorChatMutationVariables = Exact<{
  subcourseId: Scalars['Float'];
  memberUserId: Scalars['String'];
}>;


export type CreateInstructorChatMutation = { __typename?: 'Mutation', participantChatCreate: string };

export type CreateProspectChatMutationVariables = Exact<{
  subcourseId: Scalars['Float'];
  instructorUserId: Scalars['String'];
}>;


export type CreateProspectChatMutation = { __typename?: 'Mutation', prospectChatCreate: string };

export type ScreenerSearchUsersQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type ScreenerSearchUsersQuery = { __typename?: 'Query', usersSearch: Array<{ __typename?: 'UserType', pupil?: { __typename?: 'Pupil', active: boolean, id: number, createdAt: any, firstname?: string | null, lastname?: string | null, email: string, languages: Array<Pupil_Languages_Enum>, grade?: string | null, gradeAsInt: number, openMatchRequestCount: number, verifiedAt?: any | null, state: Pupil_State_Enum, schooltype: Pupil_Schooltype_Enum, onlyMatchWith?: Gender_Enum | null, hasSpecialNeeds: boolean, descriptionForScreening: string, descriptionForMatch: string, subjectsFormatted: Array<{ __typename?: 'Subject', name: string, mandatory?: boolean | null }>, school?: { __typename?: 'School', id: number, name: string, zip?: string | null, city?: string | null, email?: string | null } | null, matches: Array<{ __typename?: 'Match', createdAt: any, dissolved: boolean, dissolvedAt?: any | null, dissolveReasons: Array<Dissolve_Reason>, dissolvedBy?: Dissolved_By_Enum | null, pupilFirstMatchRequest?: any | null, student: { __typename?: 'Student', firstname?: string | null, lastname?: string | null }, subjectsFormatted: Array<{ __typename?: 'Subject', name: string }> }>, screenings: Array<{ __typename?: 'Pupil_screening', id: number, invalidated: boolean, status: Pupil_Screening_Status_Enum, comment?: string | null, knowsCoronaSchoolFrom?: string | null, createdAt: any, updatedAt: any, screeners: Array<{ __typename?: 'Screener', firstname?: string | null, lastname?: string | null }> }>, user: { __typename?: 'UserType', receivedScreeningSuggestions: Array<{ __typename?: 'Concrete_notification', sentAt: any, notification: { __typename?: 'Notification', description: string } }> } } | null, student?: { __typename?: 'Student', active: boolean, id: number, createdAt: any, email: string, firstname?: string | null, lastname?: string | null, languages: Array<Student_Languages_Enum>, certificateOfConductDeactivationDate?: any | null, hasSpecialExperience: boolean, gender?: Gender_Enum | null, descriptionForMatch: string, descriptionForScreening: string, subjectsFormatted: Array<{ __typename?: 'Subject', name: string, grade?: { __typename?: 'Range', min: number, max: number } | null }>, certificateOfConduct?: { __typename?: 'Certificate_of_conduct', id: number } | null, matches: Array<{ __typename?: 'Match', createdAt: any, dissolved: boolean, dissolvedAt?: any | null, dissolveReasons: Array<Dissolve_Reason>, dissolvedBy?: Dissolved_By_Enum | null, studentFirstMatchRequest?: any | null, pupil: { __typename?: 'Pupil', firstname?: string | null, lastname?: string | null }, subjectsFormatted: Array<{ __typename?: 'Subject', name: string }> }>, subcoursesInstructing: Array<{ __typename?: 'Subcourse', id: number, published: boolean, course: { __typename?: 'Course', name: string, image?: string | null, courseState: Course_Coursestate_Enum, tags: Array<{ __typename?: 'Course_tag', name: string }> }, nextLecture?: { __typename?: 'Lecture', start: any, duration: number } | null }>, tutorScreenings: Array<{ __typename?: 'Screening', id: number, createdAt: any, success: boolean, comment?: string | null, screener: { __typename?: 'Screener', firstname?: string | null, lastname?: string | null } }>, instructorScreenings: Array<{ __typename?: 'Instructor_screening', id: number, createdAt: any, success: boolean, comment?: string | null, screener: { __typename?: 'Screener', firstname?: string | null, lastname?: string | null } }>, user: { __typename?: 'UserType', receivedScreeningSuggestions: Array<{ __typename?: 'Concrete_notification', sentAt: any, notification: { __typename?: 'Notification', description: string } }> } } | null }> };

export type GetDisputedScreeningsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDisputedScreeningsQuery = { __typename?: 'Query', pupilsToBeScreened: Array<{ __typename?: 'Pupil', active: boolean, id: number, createdAt: any, firstname?: string | null, lastname?: string | null, email: string, languages: Array<Pupil_Languages_Enum>, grade?: string | null, gradeAsInt: number, openMatchRequestCount: number, state: Pupil_State_Enum, schooltype: Pupil_Schooltype_Enum, onlyMatchWith?: Gender_Enum | null, hasSpecialNeeds: boolean, descriptionForScreening: string, descriptionForMatch: string, subjectsFormatted: Array<{ __typename?: 'Subject', name: string }>, school?: { __typename?: 'School', name: string } | null, matches: Array<{ __typename?: 'Match', createdAt: any, dissolved: boolean, dissolvedAt?: any | null, dissolveReasons: Array<Dissolve_Reason>, dissolvedBy?: Dissolved_By_Enum | null, pupilFirstMatchRequest?: any | null, student: { __typename?: 'Student', firstname?: string | null, lastname?: string | null }, subjectsFormatted: Array<{ __typename?: 'Subject', name: string }> }>, screenings: Array<{ __typename?: 'Pupil_screening', id: number, invalidated: boolean, status: Pupil_Screening_Status_Enum, comment?: string | null, knowsCoronaSchoolFrom?: string | null, createdAt: any, updatedAt: any, screeners: Array<{ __typename?: 'Screener', firstname?: string | null, lastname?: string | null }> }>, user: { __typename?: 'UserType', receivedScreeningSuggestions: Array<{ __typename?: 'Concrete_notification', sentAt: any, notification: { __typename?: 'Notification', description: string } }> } }> };

export type SubcoursesQueryVariables = Exact<{
  search: Scalars['String'];
  courseState: Scalars['String'];
}>;


export type SubcoursesQuery = { __typename?: 'Query', subcourseSearch: Array<{ __typename?: 'Subcourse', id: number, published: boolean, minGrade: number, maxGrade: number, maxParticipants: number, participantsCount: number, course: { __typename?: 'Course', name: string, courseState: Course_Coursestate_Enum, image?: string | null, category: Course_Category_Enum, tags: Array<{ __typename?: 'Course_tag', name: string }> }, firstLecture?: { __typename?: 'Lecture', start: any } | null, instructors: Array<{ __typename?: 'Instructor', firstname: string, lastname: string }> }> };

export type SubcourseQueryVariables = Exact<{
  subcourseId: Scalars['Int'];
}>;


export type SubcourseQuery = { __typename?: 'Query', subcourse?: { __typename?: 'Subcourse', id: number, participantsCount: number, maxParticipants: number, minGrade: number, maxGrade: number, cancelled: boolean, published: boolean, publishedAt?: any | null, nextLecture?: { __typename?: 'Lecture', start: any, duration: number } | null, instructors: Array<{ __typename?: 'Instructor', id: number, firstname: string, lastname: string }>, course: { __typename?: 'Course', id: number, courseState: Course_Coursestate_Enum, name: string, image?: string | null, category: Course_Category_Enum, description: string, subject?: Course_Subject_Enum | null, shared: boolean, tags: Array<{ __typename?: 'Course_tag', name: string }> }, lectures: Array<{ __typename?: 'Lecture', start: any, duration: number }>, appointments: Array<{ __typename?: 'Lecture', id: number, appointmentType: Lecture_Appointmenttype_Enum, title?: string | null, description?: string | null, start: any, duration: number, displayName: string, position: number, total: number, organizers: Array<{ __typename?: 'Organizer', id: number, firstname: string, lastname: string }>, subcourse?: { __typename?: 'Subcourse', published: boolean } | null }> } | null };

export type AllowCourseMutationVariables = Exact<{
  courseId: Scalars['Float'];
}>;


export type AllowCourseMutation = { __typename?: 'Mutation', courseAllow: boolean };

export type DenyCourseMutationVariables = Exact<{
  courseId: Scalars['Float'];
}>;


export type DenyCourseMutation = { __typename?: 'Mutation', courseDeny: boolean };

export type ShareCourseMutationVariables = Exact<{
  courseId: Scalars['Float'];
  share: Scalars['Boolean'];
}>;


export type ShareCourseMutation = { __typename?: 'Mutation', courseMarkShared: { __typename?: 'Course', shared: boolean } };

export type AdminAccessMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type AdminAccessMutation = { __typename?: 'Mutation', tokenCreateAdmin: string };

export type PupilRequestMatchMutationVariables = Exact<{
  pupilId: Scalars['Float'];
}>;


export type PupilRequestMatchMutation = { __typename?: 'Mutation', pupilCreateMatchRequest: boolean };

export type PupilRevokeMatchRequestMutationVariables = Exact<{
  pupilId: Scalars['Float'];
}>;


export type PupilRevokeMatchRequestMutation = { __typename?: 'Mutation', pupilDeleteMatchRequest: boolean };

export type ScreenerDeactivatePupilMutationVariables = Exact<{
  pupilId: Scalars['Float'];
}>;


export type ScreenerDeactivatePupilMutation = { __typename?: 'Mutation', pupilDeactivate: boolean };

export type CreateScreeningMutationVariables = Exact<{
  pupilId: Scalars['Float'];
}>;


export type CreateScreeningMutation = { __typename?: 'Mutation', pupilCreateScreening: boolean };

export type UpdatePupilScreeningMutationVariables = Exact<{
  id: Scalars['Float'];
  screeningComment: Scalars['String'];
  status?: InputMaybe<PupilScreeningStatus>;
  knowsFrom: Scalars['String'];
}>;


export type UpdatePupilScreeningMutation = { __typename?: 'Mutation', pupilUpdateScreening: boolean };

export type MissedScreeningMutationVariables = Exact<{
  pupilScreeningId: Scalars['Float'];
  comment: Scalars['String'];
}>;


export type MissedScreeningMutation = { __typename?: 'Mutation', pupilMissedScreening: boolean };

export type ScreenerUpdatePupilMutationVariables = Exact<{
  pupilId: Scalars['Float'];
  data: PupilUpdateInput;
}>;


export type ScreenerUpdatePupilMutation = { __typename?: 'Mutation', pupilUpdate: boolean };

export type ScreenerUpdateStudentMutationVariables = Exact<{
  studentId: Scalars['Float'];
  data: StudentUpdateInput;
}>;


export type ScreenerUpdateStudentMutation = { __typename?: 'Mutation', studentUpdate: boolean };

export type ScreenAsInstructorMutationVariables = Exact<{
  studentId: Scalars['Float'];
  success: Scalars['Boolean'];
  status?: InputMaybe<StudentScreeningStatus>;
  comment: Scalars['String'];
  knowsFrom: Scalars['String'];
  jobStatus: Screening_Jobstatus_Enum;
}>;


export type ScreenAsInstructorMutation = { __typename?: 'Mutation', studentInstructorScreeningCreate: boolean };

export type ScreenAsTutorMutationVariables = Exact<{
  studentId: Scalars['Float'];
  success: Scalars['Boolean'];
  status?: InputMaybe<StudentScreeningStatus>;
  comment: Scalars['String'];
  knowsFrom: Scalars['String'];
  jobStatus: Screening_Jobstatus_Enum;
}>;


export type ScreenAsTutorMutation = { __typename?: 'Mutation', studentTutorScreeningCreate: boolean };

export type RequireStudentOnboardingMutationVariables = Exact<{
  studentId: Scalars['Float'];
}>;


export type RequireStudentOnboardingMutation = { __typename?: 'Mutation', studentRequireOnboarding: boolean };

export type UpdateTutorScreeningMutationVariables = Exact<{
  screeningId: Scalars['Float'];
  comment?: InputMaybe<Scalars['String']>;
}>;


export type UpdateTutorScreeningMutation = { __typename?: 'Mutation', studentTutorScreeningUpdate: boolean };

export type UpdateInstructorScreeningMutationVariables = Exact<{
  screeningId: Scalars['Float'];
  comment?: InputMaybe<Scalars['String']>;
}>;


export type UpdateInstructorScreeningMutation = { __typename?: 'Mutation', studentInstructorScreeningUpdate: boolean };

export type CertificatesQueryVariables = Exact<{ [key: string]: never; }>;


export type CertificatesQuery = { __typename?: 'Query', me: { __typename?: 'UserType', student?: { __typename?: 'Student', participationCertificates: Array<{ __typename?: 'Participation_certificate', uuid: string, categories: string, endDate: any, hoursPerWeek: any, hoursTotal: any, medium: string, ongoingLessons: boolean, startDate: any, state: string, pupil: { __typename?: 'Pupil', firstname?: string | null, lastname?: string | null } }> } | null } };

export type RequestInstantCertificateMutationVariables = Exact<{
  lang: Scalars['String'];
}>;


export type RequestInstantCertificateMutation = { __typename?: 'Mutation', instantCertificateCreate: string };

export type StudentDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type StudentDashboardQuery = { __typename?: 'Query', me: { __typename?: 'UserType', firstname: string, student?: { __typename?: 'Student', firstMatchRequest?: any | null, openMatchRequestCount: number, canRequestMatch: { __typename?: 'Decision', allowed: boolean, reason?: string | null }, canCreateCourse: { __typename?: 'Decision', allowed: boolean, reason?: string | null }, subcoursesInstructing: Array<{ __typename?: 'Subcourse', id: number, minGrade: number, maxGrade: number, participantsCount: number, maxParticipants: number, published: boolean, cancelled: boolean, lectures: Array<{ __typename?: 'Lecture', start: any, duration: number }>, nextLecture?: { __typename?: 'Lecture', start: any } | null, course: { __typename?: 'Course', name: string, description: string, courseState: Course_Coursestate_Enum, image?: string | null, tags: Array<{ __typename?: 'Course_tag', name: string }> } }> } | null, appointments?: Array<{ __typename?: 'Lecture', id: number, title?: string | null, description?: string | null, start: any, duration: number, appointmentType: Lecture_Appointmenttype_Enum, total: number, position: number, displayName: string, isOrganizer: boolean, isParticipant: boolean, declinedBy: Array<string>, zoomMeetingId?: string | null, organizers: Array<{ __typename?: 'Organizer', id: number, userID?: string | null, firstname: string, lastname: string }>, participants?: Array<{ __typename?: 'AppointmentParticipant', id?: number | null, userID?: string | null, firstname?: string | null, lastname?: string | null }> | null, subcourse?: { __typename?: 'Subcourse', published: boolean, course: { __typename?: 'Course', image?: string | null, subject?: Course_Subject_Enum | null } } | null }> | null }, subcoursesPublic: Array<{ __typename?: 'Subcourse', participantsCount: number, maxParticipants: number, course: { __typename?: 'Course', name: string, description: string, image?: string | null, tags: Array<{ __typename?: 'Course_tag', name: string }> } }> };

export type MatchingStudentOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type MatchingStudentOverviewQuery = { __typename?: 'Query', me: { __typename?: 'UserType', student?: { __typename?: 'Student', id: number, openMatchRequestCount: number, subjectsFormatted: Array<{ __typename?: 'Subject', name: string }>, matches: Array<{ __typename?: 'Match', id: number, uuid: string, dissolved: boolean, subjectsFormatted: Array<{ __typename?: 'Subject', name: string }>, pupil: { __typename?: 'Pupil', firstname?: string | null, lastname?: string | null, schooltype: Pupil_Schooltype_Enum, grade?: string | null, gradeAsInt: number } }>, canRequestMatch: { __typename?: 'Decision', allowed: boolean, reason?: string | null, limit?: number | null } } | null } };

export type StudentDeleteMatchRequestMutationVariables = Exact<{ [key: string]: never; }>;


export type StudentDeleteMatchRequestMutation = { __typename?: 'Mutation', studentDeleteMatchRequest: boolean };

export type StudentProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type StudentProfileQuery = { __typename?: 'Query', me: { __typename?: 'UserType', firstname: string, lastname: string, email: string, student?: { __typename?: 'Student', state?: Student_State_Enum | null, aboutMe: string, languages: Array<Student_Languages_Enum>, subjectsFormatted: Array<{ __typename?: 'Subject', name: string }>, participationCertificates: Array<{ __typename?: 'Participation_certificate', state: string, subjectsFormatted: Array<string>, startDate: any, endDate: any, hoursTotal: any, medium: string, categories: string, uuid: string, hoursPerWeek: any, ongoingLessons: boolean, pupil: { __typename?: 'Pupil', firstname?: string | null, lastname?: string | null } }> } | null } };

export type ChangeAboutMeMutationVariables = Exact<{
  aboutMe: Scalars['String'];
}>;


export type ChangeAboutMeMutation = { __typename?: 'Mutation', meUpdate: boolean };

export type GetBasicSubcourseStudentQueryVariables = Exact<{
  subcourseId: Scalars['Int'];
}>;


export type GetBasicSubcourseStudentQuery = { __typename?: 'Query', subcourse?: { __typename?: 'Subcourse', id: number, allowChatContactProspects: boolean, allowChatContactParticipants: boolean, groupChatType: Chat_Type, participantsCount: number, maxParticipants: number, minGrade: number, maxGrade: number, capacity: number, cancelled: boolean, published: boolean, publishedAt?: any | null, isInstructor: boolean, isMentor: boolean, nextLecture?: { __typename?: 'Lecture', start: any, duration: number } | null, instructors: Array<{ __typename?: 'Instructor', id: number, firstname: string, lastname: string }>, course: { __typename?: 'Course', id: number, courseState: Course_Coursestate_Enum, name: string, image?: string | null, category: Course_Category_Enum, description: string, subject?: Course_Subject_Enum | null, allowContact: boolean, tags: Array<{ __typename?: 'Course_tag', name: string }> }, lectures: Array<{ __typename?: 'Lecture', start: any, duration: number }>, appointments: Array<{ __typename?: 'Lecture', id: number, appointmentType: Lecture_Appointmenttype_Enum, title?: string | null, description?: string | null, start: any, duration: number, displayName: string, position: number, total: number, isOrganizer: boolean, isParticipant: boolean, organizers: Array<{ __typename?: 'Organizer', id: number, firstname: string, lastname: string }>, subcourse?: { __typename?: 'Subcourse', published: boolean } | null }> } | null };

export type GetInstructorSubcourseQueryVariables = Exact<{
  subcourseId: Scalars['Int'];
}>;


export type GetInstructorSubcourseQuery = { __typename?: 'Query', subcourse?: { __typename?: 'Subcourse', conversationId?: string | null, wasPromotedByInstructor: boolean, pupilsWaitingCount: number, canPromote: { __typename?: 'Decision', allowed: boolean }, pupilsOnWaitinglist: Array<{ __typename?: 'Participant', id: number, firstname: string, lastname: string, schooltype: Pupil_Schooltype_Enum, grade: string, gradeAsInt: number }>, canEdit: { __typename?: 'Decision', allowed: boolean, reason?: string | null }, canContactParticipants: { __typename?: 'Decision', allowed: boolean, reason?: string | null }, canCancel: { __typename?: 'Decision', allowed: boolean, reason?: string | null }, appointments: Array<{ __typename?: 'Lecture', id: number, appointmentType: Lecture_Appointmenttype_Enum, title?: string | null, description?: string | null, start: any, duration: number, displayName: string, position: number, total: number, isOrganizer: boolean, isParticipant: boolean, participantIds: Array<string>, declinedBy: Array<string>, organizers: Array<{ __typename?: 'Organizer', id: number, firstname: string, lastname: string }>, subcourse?: { __typename?: 'Subcourse', published: boolean } | null, participants?: Array<{ __typename?: 'AppointmentParticipant', id?: number | null, firstname?: string | null, lastname?: string | null, isPupil?: boolean | null, isStudent?: boolean | null }> | null }>, prospectParticipants: Array<{ __typename?: 'ProspectParticipant', id: number, firstname: string, lastname: string, schooltype: Pupil_Schooltype_Enum, grade: string, gradeAsInt: number, conversationId: string }> } | null };

export type JoinAsMentorMutationVariables = Exact<{
  subcourseId: Scalars['Float'];
}>;


export type JoinAsMentorMutation = { __typename?: 'Mutation', subcourseJoinAsMentor: boolean };

export type MentorLeaveSubcourseMutationVariables = Exact<{
  subcourseId: Scalars['Float'];
}>;


export type MentorLeaveSubcourseMutation = { __typename?: 'Mutation', subcourseMentorLeave: boolean };

export type SubcoursePublishMutationVariables = Exact<{
  subcourseId: Scalars['Float'];
}>;


export type SubcoursePublishMutation = { __typename?: 'Mutation', subcoursePublish: boolean };

export type CourseSubmitMutationVariables = Exact<{
  courseId: Scalars['Float'];
}>;


export type CourseSubmitMutation = { __typename?: 'Mutation', courseSubmit: boolean };

export type ContactCourseParticipantMutationVariables = Exact<{
  memberUserId: Scalars['String'];
  subcourseId: Scalars['Float'];
}>;


export type ContactCourseParticipantMutation = { __typename?: 'Mutation', participantChatCreate: string };

export type StudentCourseOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type StudentCourseOverviewQuery = { __typename?: 'Query', me: { __typename?: 'UserType', student?: { __typename?: 'Student', canCreateCourse: { __typename?: 'Decision', allowed: boolean, reason?: string | null }, subcoursesMentoring: Array<{ __typename?: 'Subcourse', id: number, published: boolean, cancelled: boolean, participantsCount: number, maxParticipants: number, minGrade: number, maxGrade: number, firstLecture?: { __typename?: 'Lecture', start: any, duration: number } | null, nextLecture?: { __typename?: 'Lecture', start: any, duration: number } | null, lectures: Array<{ __typename?: 'Lecture', start: any, duration: number }>, course: { __typename?: 'Course', courseState: Course_Coursestate_Enum, name: string, description: string, image?: string | null, category: Course_Category_Enum, tags: Array<{ __typename?: 'Course_tag', id: number, name: string }> } }>, subcoursesInstructing: Array<{ __typename?: 'Subcourse', id: number, published: boolean, cancelled: boolean, participantsCount: number, maxParticipants: number, minGrade: number, maxGrade: number, firstLecture?: { __typename?: 'Lecture', start: any, duration: number } | null, nextLecture?: { __typename?: 'Lecture', start: any, duration: number } | null, lectures: Array<{ __typename?: 'Lecture', start: any, duration: number }>, course: { __typename?: 'Course', courseState: Course_Coursestate_Enum, name: string, description: string, image?: string | null, category: Course_Category_Enum, tags: Array<{ __typename?: 'Course_tag', id: number, name: string }> } }> } | null }, subcoursesPublic: Array<{ __typename?: 'Subcourse', id: number, published: boolean, cancelled: boolean, minGrade: number, maxGrade: number, participantsCount: number, maxParticipants: number, isInstructor: boolean, firstLecture?: { __typename?: 'Lecture', start: any, duration: number } | null, nextLecture?: { __typename?: 'Lecture', start: any, duration: number } | null, lectures: Array<{ __typename?: 'Lecture', start: any, duration: number }>, course: { __typename?: 'Course', name: string, courseState: Course_Coursestate_Enum, description: string, image?: string | null, category: Course_Category_Enum, tags: Array<{ __typename?: 'Course_tag', id: number, name: string }> } }> };

export type StudentMatchRequestCountQueryVariables = Exact<{ [key: string]: never; }>;


export type StudentMatchRequestCountQuery = { __typename?: 'Query', me: { __typename?: 'UserType', student?: { __typename?: 'Student', state?: Student_State_Enum | null, openMatchRequestCount: number, subjectsFormatted: Array<{ __typename?: 'Subject', name: string, grade?: { __typename?: 'Range', min: number, max: number } | null }> } | null } };

export type UpdateStudentSubjectsMutationVariables = Exact<{
  subjects?: InputMaybe<Array<SubjectInput> | SubjectInput>;
}>;


export type UpdateStudentSubjectsMutation = { __typename?: 'Mutation', meUpdate: boolean };

export type StudentCreateMatchRequestMutationVariables = Exact<{ [key: string]: never; }>;


export type StudentCreateMatchRequestMutation = { __typename?: 'Mutation', studentCreateMatchRequest: boolean };

export type ChangeStudentStateDataMutationVariables = Exact<{
  data: StudentState;
}>;


export type ChangeStudentStateDataMutation = { __typename?: 'Mutation', meUpdate: boolean };

export type StudentGroupContactSupportMutationVariables = Exact<{
  subject: Scalars['String'];
  message: Scalars['String'];
}>;


export type StudentGroupContactSupportMutation = { __typename?: 'Mutation', userContactSupport: boolean };

export type BecomeInstructorMutationVariables = Exact<{ [key: string]: never; }>;


export type BecomeInstructorMutation = { __typename?: 'Mutation', meBecomeInstructor: boolean };

export type StudentMatchContactSupportMutationVariables = Exact<{
  subject: Scalars['String'];
  message: Scalars['String'];
}>;


export type StudentMatchContactSupportMutation = { __typename?: 'Mutation', userContactSupport: boolean };

export type BecomeTutorMutationVariables = Exact<{ [key: string]: never; }>;


export type BecomeTutorMutation = { __typename?: 'Mutation', meBecomeTutor: boolean };

export type SubcourseParticipantsForContactQueryVariables = Exact<{
  subcourseId: Scalars['Int'];
}>;


export type SubcourseParticipantsForContactQuery = { __typename?: 'Query', subcourse?: { __typename?: 'Subcourse', participants: Array<{ __typename?: 'Participant', id: number, firstname: string, lastname: string }> } | null };

export type SendMessageMutationVariables = Exact<{
  subject: Scalars['String'];
  message: Scalars['String'];
  subcourseId: Scalars['Int'];
  participants: Array<Scalars['Int']> | Scalars['Int'];
  fileIDs: Array<Scalars['String']> | Scalars['String'];
}>;


export type SendMessageMutation = { __typename?: 'Mutation', subcourseNotifyParticipants: boolean };

export type CreateNewGroupChatMutationVariables = Exact<{
  subcourseId: Scalars['Float'];
  groupChatType: Scalars['String'];
}>;


export type CreateNewGroupChatMutation = { __typename?: 'Mutation', subcourseGroupChatCreate: string };

export type GetParticipantsQueryVariables = Exact<{
  subcourseId: Scalars['Int'];
}>;


export type GetParticipantsQuery = { __typename?: 'Query', subcourse?: { __typename?: 'Subcourse', participants: Array<{ __typename?: 'Participant', id: number, firstname: string, lastname: string, schooltype: Pupil_Schooltype_Enum, grade: string, gradeAsInt: number }> } | null };

export type MarkAchievementAsSeenMutationVariables = Exact<{
  id: Scalars['Float'];
}>;


export type MarkAchievementAsSeenMutation = { __typename?: 'Mutation', markAchievementAsSeen: boolean };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', myContactOptions: Array<{ __typename?: 'Contact', contactReasons: Array<string>, chatId?: string | null, user: { __typename?: 'UserType', userID: string, firstname: string, lastname: string } }> };

export type CreateContactChatMutationVariables = Exact<{
  contactUserId: Scalars['String'];
}>;


export type CreateContactChatMutation = { __typename?: 'Mutation', contactChatCreate: string };

export type GetOnboardingInfosQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOnboardingInfosQuery = { __typename?: 'Query', myRoles: Array<string>, important_informations: Array<{ __typename?: 'Important_information', title: string, description: string, navigateTo?: string | null, language: Important_Information_Language_Enum, recipients: Important_Information_Recipients_Enum }>, me: { __typename?: 'UserType', email: string, firstname: string, lastname: string, secrets: Array<{ __typename?: 'Secret', type: Secret_Type_Enum }>, student?: { __typename?: 'Student', createdAt: any, verifiedAt?: any | null, firstMatchRequest?: any | null, openMatchRequestCount: number, certificateOfConductDeactivationDate?: any | null, matches: Array<{ __typename?: 'Match', dissolved: boolean, createdAt: any, pupil: { __typename?: 'Pupil', firstname?: string | null, lastname?: string | null } }>, canRequestMatch: { __typename?: 'Decision', allowed: boolean, reason?: string | null }, canCreateCourse: { __typename?: 'Decision', allowed: boolean, reason?: string | null }, subcoursesInstructing: Array<{ __typename?: 'Subcourse', id: number }> } | null, pupil?: { __typename?: 'Pupil', createdAt: any, verifiedAt?: any | null, grade?: string | null, firstMatchRequest?: any | null, openMatchRequestCount: number, subjectsFormatted: Array<{ __typename?: 'Subject', name: string }>, subcoursesJoined: Array<{ __typename?: 'Subcourse', id: number }>, matches: Array<{ __typename?: 'Match', dissolved: boolean, createdAt: any, subjectsFormatted: Array<{ __typename?: 'Subject', name: string }>, student: { __typename?: 'Student', firstname?: string | null, lastname?: string | null } }>, tutoringInterestConfirmation?: { __typename?: 'Pupil_tutoring_interest_confirmation_request', id: number, token: string, status: string } | null, participationCertificatesToSign: Array<{ __typename?: 'Participation_certificate', id: number, uuid: string, ongoingLessons: boolean, state: string, categories: string, startDate: any, endDate: any, hoursPerWeek: any, hoursTotal: any, medium: string, student: { __typename?: 'Student', firstname?: string | null, lastname?: string | null } }>, screenings: Array<{ __typename?: 'Pupil_screening', invalidated: boolean, status: Pupil_Screening_Status_Enum }> } | null } };

export type SendVerificationMailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type SendVerificationMailMutation = { __typename?: 'Mutation', tokenRequest: boolean };

export type ConfirmMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type ConfirmMutation = { __typename?: 'Mutation', tutoringInterestConfirm: boolean };

export type RefuseMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type RefuseMutation = { __typename?: 'Mutation', tutoringInterestRefuse: boolean };

export type DeleteMatchRequestMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteMatchRequestMutation = { __typename?: 'Mutation', pupilDeleteMatchRequest: boolean };

export type AppointmentOrganizerQueryVariables = Exact<{
  appointmentId: Scalars['Float'];
}>;


export type AppointmentOrganizerQuery = { __typename?: 'Query', appointment: { __typename?: 'Lecture', isOrganizer: boolean, zoomMeetingId?: string | null } };

export type AppointmentSaveMeetingReportMutationVariables = Exact<{
  appointmentId: Scalars['Float'];
}>;


export type AppointmentSaveMeetingReportMutation = { __typename?: 'Mutation', appointmentSaveMeetingReport: boolean };

export type SubcoursePromoteMutationVariables = Exact<{
  subcourseId: Scalars['Float'];
}>;


export type SubcoursePromoteMutation = { __typename?: 'Mutation', subcoursePromote: boolean };

export type SignCertificateMutationVariables = Exact<{
  certificateId: Scalars['String'];
  location: Scalars['String'];
  signatureParent?: InputMaybe<Scalars['String']>;
  signaturePupil?: InputMaybe<Scalars['String']>;
}>;


export type SignCertificateMutation = { __typename?: 'Mutation', participationCertificateSign: boolean };

export type GetCertificateMutationVariables = Exact<{
  lang: Scalars['String'];
  uuid: Scalars['String'];
}>;


export type GetCertificateMutation = { __typename?: 'Mutation', participationCertificateAsPDF: string };

export type GetPupilsForCertificateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPupilsForCertificateQuery = { __typename?: 'Query', me: { __typename?: 'UserType', student?: { __typename?: 'Student', subjectsFormatted: Array<{ __typename?: 'Subject', name: string }>, matches: Array<{ __typename?: 'Match', uuid: string, createdAt: any, subjectsFormatted: Array<{ __typename?: 'Subject', name: string }>, pupil: { __typename?: 'Pupil', firstname?: string | null, lastname?: string | null } }> } | null } };

export type SendSuggestionMutationVariables = Exact<{
  userID: Scalars['String'];
  suggestion: Scalars['Int'];
}>;


export type SendSuggestionMutation = { __typename?: 'Mutation', screenerSuggest: boolean };

export type GetPossibleSuggestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPossibleSuggestionsQuery = { __typename?: 'Query', notifications: Array<{ __typename?: 'Notification', id: number, description: string }> };


export const ContactSupportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ContactSupport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subject"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userContactSupport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"subject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subject"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}}]}}]}]}}]} as unknown as DocumentNode<ContactSupportMutation, ContactSupportMutationVariables>;
export const OverrrideLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"overrrideLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appointmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"override_meeting_link"}}]}}]}}]} as unknown as DocumentNode<OverrrideLinkQuery, OverrrideLinkQueryVariables>;
export const JoinMeetingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JoinMeeting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentTrackJoin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appointmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}}}]}]}}]} as unknown as DocumentNode<JoinMeetingMutation, JoinMeetingMutationVariables>;
export const GetZoomMeetingLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GetZoomMeetingLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentZoomLinkGet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appointmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}}}]}]}}]} as unknown as DocumentNode<GetZoomMeetingLinkMutation, GetZoomMeetingLinkMutationVariables>;
export const AppointmentMeetingDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"appointmentMeetingData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appointmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zoomMeetingId"}},{"kind":"Field","name":{"kind":"Name","value":"isOrganizer"}},{"kind":"Field","name":{"kind":"Name","value":"isParticipant"}},{"kind":"Field","name":{"kind":"Name","value":"zoomMeetingPassword"}}]}}]}}]} as unknown as DocumentNode<AppointmentMeetingDataQuery, AppointmentMeetingDataQueryVariables>;
export const ZoomCredentialsOrganizerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"zoomCredentialsOrganizer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"meetingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"zoomZAK"}},{"kind":"Field","name":{"kind":"Name","value":"zoomSDKJWT"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"meetingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"meetingId"}}},{"kind":"Argument","name":{"kind":"Name","value":"role"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}}]}]}}]}}]} as unknown as DocumentNode<ZoomCredentialsOrganizerQuery, ZoomCredentialsOrganizerQueryVariables>;
export const ZoomCredentialsParticipantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"zoomCredentialsParticipant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"meetingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"zoomSDKJWT"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"meetingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"meetingId"}}},{"kind":"Argument","name":{"kind":"Name","value":"role"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}}]}]}}]}}]} as unknown as DocumentNode<ZoomCredentialsParticipantQuery, ZoomCredentialsParticipantQueryVariables>;
export const CancelAppointmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"cancelAppointment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentCancel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appointmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}}}]}]}}]} as unknown as DocumentNode<CancelAppointmentMutation, CancelAppointmentMutationVariables>;
export const DeclineAppointmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"declineAppointment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentDecline"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appointmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}}}]}]}}]} as unknown as DocumentNode<DeclineAppointmentMutation, DeclineAppointmentMutationVariables>;
export const LoginTokenForSecondDeviceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LoginTokenForSecondDevice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expiresAt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokenCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"expiresAt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expiresAt"}}},{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}}]}]}}]} as unknown as DocumentNode<LoginTokenForSecondDeviceMutation, LoginTokenForSecondDeviceMutationVariables>;
export const MyChatSignatureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"myChatSignature"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"chatSignature"}}]}}]}}]} as unknown as DocumentNode<MyChatSignatureQuery, MyChatSignatureQueryVariables>;
export const LoginWithDeviceTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LoginWithDeviceToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deviceToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loginToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deviceToken"}}},{"kind":"Argument","name":{"kind":"Name","value":"deviceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}}}]}]}}]} as unknown as DocumentNode<LoginWithDeviceTokenMutation, LoginWithDeviceTokenMutationVariables>;
export const CreateDeviceTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDeviceToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokenCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}},{"kind":"Argument","name":{"kind":"Name","value":"deviceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}}}]}]}}]} as unknown as DocumentNode<CreateDeviceTokenMutation, CreateDeviceTokenMutationVariables>;
export const GetUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"pupil"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"hasDoneEthicsOnboarding"}}]}},{"kind":"Field","name":{"kind":"Name","value":"screener"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"myRoles"}}]}}]} as unknown as DocumentNode<GetUserQuery, GetUserQueryVariables>;
export const RevokeTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RevokeToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deviceToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokenRevoke"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deviceToken"}}},{"kind":"Argument","name":{"kind":"Name","value":"invalidateSessions"},"value":{"kind":"BooleanValue","value":false}}]}]}}]} as unknown as DocumentNode<RevokeTokenMutation, RevokeTokenMutationVariables>;
export const LogoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Logout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logout"}}]}}]} as unknown as DocumentNode<LogoutMutation, LogoutMutationVariables>;
export const LoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loginPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"deviceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}}}]}]}}]} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const MutationLoginWithSsoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MutationLoginWithSSO"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referrer"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loginWithSSO"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}},{"kind":"Argument","name":{"kind":"Name","value":"referrer"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referrer"}}}]}]}}]} as unknown as DocumentNode<MutationLoginWithSsoMutation, MutationLoginWithSsoMutationVariables>;
export const ConcreteNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConcreteNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"concrete_notification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"concreteNotificationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"modalText"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"navigateTo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}}]}}]}}]} as unknown as DocumentNode<ConcreteNotificationQuery, ConcreteNotificationQueryVariables>;
export const ConcreteNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConcreteNotifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"concreteNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"message"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"modalText"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"navigateTo"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}}]}}]}}]}}]} as unknown as DocumentNode<ConcreteNotificationsQuery, ConcreteNotificationsQueryVariables>;
export const SearchSchoolsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchSchools"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"externalSchoolSearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"options"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"schooltype"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<SearchSchoolsQuery, SearchSchoolsQueryVariables>;
export const GetLastTimeCheckedNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLastTimeCheckedNotifications"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastTimeCheckedNotifications"}}]}}]}}]} as unknown as DocumentNode<GetLastTimeCheckedNotificationsQuery, GetLastTimeCheckedNotificationsQueryVariables>;
export const UpdateMeLastTimeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateMeLastTime"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastTimeCheckedNotifications"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lastTimeCheckedNotifications"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastTimeCheckedNotifications"}}}]}}]}]}}]} as unknown as DocumentNode<UpdateMeLastTimeMutation, UpdateMeLastTimeMutationVariables>;
export const GetNotificationPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNotificationPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationPreferences"}}]}}]}}]} as unknown as DocumentNode<GetNotificationPreferencesQuery, GetNotificationPreferencesQueryVariables>;
export const ChangeMeNotificationPrefDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"changeMeNotificationPref"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preferences"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PreferencesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notificationPreferences"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preferences"}}}]}}]}]}}]} as unknown as DocumentNode<ChangeMeNotificationPrefMutation, ChangeMeNotificationPrefMutationVariables>;
export const GetPushPublicKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPushPublicKey"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pushPublicKey"}}]}}]} as unknown as DocumentNode<GetPushPublicKeyQuery, GetPushPublicKeyQueryVariables>;
export const AddSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subscription"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePushSubscriptionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userPushSubcriptionAdd"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subscription"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subscription"}}}]}]}}]} as unknown as DocumentNode<AddSubscriptionMutation, AddSubscriptionMutationVariables>;
export const RemoveSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userPushSubcriptionRemove"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subscriptionID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RemoveSubscriptionMutation, RemoveSubscriptionMutationVariables>;
export const GetPushSubsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPushSubs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pushSubscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endpoint"}}]}}]}}]}}]} as unknown as DocumentNode<GetPushSubsQuery, GetPushSubsQueryVariables>;
export const AchievementByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"achievementById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"achievementId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"achievement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"achievementId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"tagline"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"footer"}},{"kind":"Field","name":{"kind":"Name","value":"achievementState"}},{"kind":"Field","name":{"kind":"Name","value":"achievementType"}},{"kind":"Field","name":{"kind":"Name","value":"isNewAchievement"}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maxSteps"}},{"kind":"Field","name":{"kind":"Name","value":"currentStep"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}},{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"actionName"}},{"kind":"Field","name":{"kind":"Name","value":"actionRedirectLink"}}]}}]}}]}}]} as unknown as DocumentNode<AchievementByIdQuery, AchievementByIdQueryVariables>;
export const CreateAdHocMeetingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAdHocMeeting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matchId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matchCreateAdHocMeeting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matchId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matchId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"zoomUrl"}}]}}]}}]} as unknown as DocumentNode<CreateAdHocMeetingMutation, CreateAdHocMeetingMutationVariables>;
export const SearchInstructorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchInstructors"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"otherInstructors"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}}]}}]} as unknown as DocumentNode<SearchInstructorsQuery, SearchInstructorsQueryVariables>;
export const JoinFromWaitinglistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JoinFromWaitinglist"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pupilId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcourseJoinFromWaitinglist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pupilId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pupilId"}}}]}]}}]} as unknown as DocumentNode<JoinFromWaitinglistMutation, JoinFromWaitinglistMutationVariables>;
export const JoinFromProspectListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JoinFromProspectList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pupilId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcourseJoinFromProspects"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pupilId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pupilId"}}}]}]}}]} as unknown as DocumentNode<JoinFromProspectListMutation, JoinFromProspectListMutationVariables>;
export const SendAppFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendAppFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allowContact"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"attachment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AppFeedbackAttachment"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userSendAppFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"allowContact"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allowContact"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"notes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notes"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"attachment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"attachment"}}}]}}]}]}}]} as unknown as DocumentNode<SendAppFeedbackMutation, SendAppFeedbackMutationVariables>;
export const CancelSubcourseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelSubcourse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcourseCancel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}}}]}]}}]} as unknown as DocumentNode<CancelSubcourseMutation, CancelSubcourseMutationVariables>;
export const ChangeEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meChangeEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}]}}]} as unknown as DocumentNode<ChangeEmailMutation, ChangeEmailMutationVariables>;
export const IsEmailAvailableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"isEmailAvailable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isEmailAvailable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}]}}]} as unknown as DocumentNode<IsEmailAvailableMutation, IsEmailAvailableMutationVariables>;
export const SendReportOnSupportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendReportOnSupport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subject"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userContactSupport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"subject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subject"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}}]}}]}]}}]} as unknown as DocumentNode<SendReportOnSupportMutation, SendReportOnSupportMutationVariables>;
export const DeactiveAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deactiveAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reason"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meDeactivate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reason"}}}]}]}}]} as unknown as DocumentNode<DeactiveAccountMutation, DeactiveAccountMutationVariables>;
export const IncreaseMaxParticipantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IncreaseMaxParticipants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxParticipants"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcourseEdit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcourse"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"maxParticipants"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxParticipants"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maxParticipants"}}]}}]}}]} as unknown as DocumentNode<IncreaseMaxParticipantsMutation, IncreaseMaxParticipantsMutationVariables>;
export const RemoveParticipantFromCourseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeParticipantFromCourse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pupilId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcourseLeave"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}}},{"kind":"Argument","name":{"kind":"Name","value":"pupilId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pupilId"}}}]}]}}]} as unknown as DocumentNode<RemoveParticipantFromCourseMutation, RemoveParticipantFromCourseMutationVariables>;
export const ReportMatchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReportMatch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matchId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"description"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matchReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"report"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"matchId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matchId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"description"},"value":{"kind":"Variable","name":{"kind":"Name","value":"description"}}}]}}]}]}}]} as unknown as DocumentNode<ReportMatchMutation, ReportMatchMutationVariables>;
export const ExistingScreeningsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ExistingScreenings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pupil"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"subjectsFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"screenings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tutorScreenings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"Field","name":{"kind":"Name","value":"instructorScreenings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ExistingScreeningsQuery, ExistingScreeningsQueryVariables>;
export const GetCourseTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCourseTags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"courseTags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"category"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetCourseTagsQuery, GetCourseTagsQueryVariables>;
export const SearchCourseImagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"searchCourseImages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"courseImages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"8"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"regularImageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"smallImageUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"totalPages"}}]}}]}}]} as unknown as DocumentNode<SearchCourseImagesQuery, SearchCourseImagesQueryVariables>;
export const RequestVerifyEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestVerifyEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"redirectTo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokenRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"action"},"value":{"kind":"StringValue","value":"user-verify-email","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"redirectTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"redirectTo"}}}]}]}}]} as unknown as DocumentNode<RequestVerifyEmailMutation, RequestVerifyEmailMutationVariables>;
export const AppointmentStudentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"appointmentStudent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appointmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isCanceled"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"isOrganizer"}},{"kind":"Field","name":{"kind":"Name","value":"override_meeting_link"}},{"kind":"Field","name":{"kind":"Name","value":"zoomMeetingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"subcourseId"}},{"kind":"Field","name":{"kind":"Name","value":"matchId"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"declinedBy"}},{"kind":"Field","name":{"kind":"Name","value":"zoomMeetingId"}},{"kind":"Field","name":{"kind":"Name","value":"subcourse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AppointmentStudentQuery, AppointmentStudentQueryVariables>;
export const AppointmentPupilDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"appointmentPupil"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appointmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isCanceled"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"isOrganizer"}},{"kind":"Field","name":{"kind":"Name","value":"override_meeting_link"}},{"kind":"Field","name":{"kind":"Name","value":"zoomMeetingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"subcourseId"}},{"kind":"Field","name":{"kind":"Name","value":"matchId"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"declinedBy"}},{"kind":"Field","name":{"kind":"Name","value":"zoomMeetingId"}},{"kind":"Field","name":{"kind":"Name","value":"subcourse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"published"}}]}}]}}]}}]} as unknown as DocumentNode<AppointmentPupilQuery, AppointmentPupilQueryVariables>;
export const MyAppointments_No_CacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"myAppointments_NO_CACHE"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"direction"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"direction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"direction"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"isOrganizer"}},{"kind":"Field","name":{"kind":"Name","value":"isParticipant"}},{"kind":"Field","name":{"kind":"Name","value":"organizers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"30"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"declinedBy"}},{"kind":"Field","name":{"kind":"Name","value":"zoomMeetingId"}},{"kind":"Field","name":{"kind":"Name","value":"subcourse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"published"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MyAppointments_No_CacheQuery, MyAppointments_No_CacheQueryVariables>;
export const AppoimtmentsMetaDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"appoimtmentsMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasAppointments"}},{"kind":"Field","name":{"kind":"Name","value":"lastAppointmentId"}},{"kind":"Field","name":{"kind":"Name","value":"firstAppointmentId"}}]}}]}}]} as unknown as DocumentNode<AppoimtmentsMetaDataQuery, AppoimtmentsMetaDataQueryVariables>;
export const GetCocDateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCocDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"certificateOfConductDeactivationDate"}}]}}]}}]}}]} as unknown as DocumentNode<GetCocDateQuery, GetCocDateQueryVariables>;
export const DownloadRemissionRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DownloadRemissionRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"studentGetRemissionRequestAsPDF"}}]}}]} as unknown as DocumentNode<DownloadRemissionRequestMutation, DownloadRemissionRequestMutationVariables>;
export const MyEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyEmail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<MyEmailQuery, MyEmailQueryVariables>;
export const GetPupilCertificateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPupilCertificate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pupil"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participationCertificatesToSign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"ongoingLessons"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"categories"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"hoursPerWeek"}},{"kind":"Field","name":{"kind":"Name","value":"hoursTotal"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPupilCertificateQuery, GetPupilCertificateQueryVariables>;
export const StudentCanCreateCourseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StudentCanCreateCourse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canCreateCourse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowed"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}}]}}]}}]} as unknown as DocumentNode<StudentCanCreateCourseQuery, StudentCanCreateCourseQueryVariables>;
export const GetSubcourseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSubcourse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcourse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participantsCount"}},{"kind":"Field","name":{"kind":"Name","value":"maxParticipants"}},{"kind":"Field","name":{"kind":"Name","value":"minGrade"}},{"kind":"Field","name":{"kind":"Name","value":"maxGrade"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"instructors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"joinAfterStart"}},{"kind":"Field","name":{"kind":"Name","value":"allowChatContactParticipants"}},{"kind":"Field","name":{"kind":"Name","value":"allowChatContactProspects"}},{"kind":"Field","name":{"kind":"Name","value":"groupChatType"}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"allowContact"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSubcourseQuery, GetSubcourseQueryVariables>;
export const CreateCourseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCourse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"course"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PublicCourseCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"courseCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"course"},"value":{"kind":"Variable","name":{"kind":"Name","value":"course"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateCourseMutation, CreateCourseMutationVariables>;
export const UpdateCourseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCourse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"course"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PublicCourseEditInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"courseEdit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"course"},"value":{"kind":"Variable","name":{"kind":"Name","value":"course"}}},{"kind":"Argument","name":{"kind":"Name","value":"courseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateCourseMutation, UpdateCourseMutationVariables>;
export const CreateSubcourseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createSubcourse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"courseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcourse"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PublicSubcourseCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcourseCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"courseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"courseId"}}},{"kind":"Argument","name":{"kind":"Name","value":"subcourse"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcourse"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"canPublish"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowed"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}}]}}]} as unknown as DocumentNode<CreateSubcourseMutation, CreateSubcourseMutationVariables>;
export const AppointmentsCourseCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"appointmentsCourseCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointments"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AppointmentCreateGroupInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentsGroupCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appointments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointments"}}},{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}}}]}]}}]} as unknown as DocumentNode<AppointmentsCourseCreateMutation, AppointmentsCourseCreateMutationVariables>;
export const UpdateSubcourseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateSubcourse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"course"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PublicSubcourseEditInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcourseEdit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcourse"},"value":{"kind":"Variable","name":{"kind":"Name","value":"course"}}},{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateSubcourseMutation, UpdateSubcourseMutationVariables>;
export const SetCourseImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setCourseImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"courseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"courseSetImage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"courseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"courseId"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileId"}}}]}]}}]} as unknown as DocumentNode<SetCourseImageMutation, SetCourseImageMutationVariables>;
export const AddCourseInstructorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addCourseInstructor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"courseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcourseAddInstructor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"studentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"courseId"}}}]}]}}]} as unknown as DocumentNode<AddCourseInstructorMutation, AddCourseInstructorMutationVariables>;
export const RemoveCourseInstructorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"removeCourseInstructor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"courseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcourseDeleteInstructor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"studentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"courseId"}}}]}]}}]} as unknown as DocumentNode<RemoveCourseInstructorMutation, RemoveCourseInstructorMutationVariables>;
export const SetCourseTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetCourseTags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"courseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"courseTagIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"courseSetTags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"courseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"courseId"}}},{"kind":"Argument","name":{"kind":"Name","value":"courseTagIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"courseTagIds"}}}]}]}}]} as unknown as DocumentNode<SetCourseTagsMutation, SetCourseTagsMutationVariables>;
export const SubmitCourseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitCourse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"courseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"courseSubmit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"courseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"courseId"}}}]}]}}]} as unknown as DocumentNode<SubmitCourseMutation, SubmitCourseMutationVariables>;
export const GenerateLessonPlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateLessonPlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GenerateLessonPlanInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateLessonPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"learningGoal"}},{"kind":"Field","name":{"kind":"Name","value":"agendaExercises"}},{"kind":"Field","name":{"kind":"Name","value":"assessment"}},{"kind":"Field","name":{"kind":"Name","value":"homework"}},{"kind":"Field","name":{"kind":"Name","value":"resources"}}]}}]}}]} as unknown as DocumentNode<GenerateLessonPlanMutation, GenerateLessonPlanMutationVariables>;
export const DetermineLoginOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"determineLoginOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userDetermineLoginOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}]}}]} as unknown as DocumentNode<DetermineLoginOptionsMutation, DetermineLoginOptionsMutationVariables>;
export const PasswordResetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PasswordReset"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"redirectTo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokenRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"action"},"value":{"kind":"StringValue","value":"user-password-reset","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"redirectTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"redirectTo"}}}]}]}}]} as unknown as DocumentNode<PasswordResetMutation, PasswordResetMutationVariables>;
export const AuthenticateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Authenticate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"redirectTo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokenRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"action"},"value":{"kind":"StringValue","value":"user-authenticate","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"redirectTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"redirectTo"}}}]}]}}]} as unknown as DocumentNode<AuthenticateMutation, AuthenticateMutationVariables>;
export const AchievementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"achievements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"achievements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"tagline"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"footer"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}},{"kind":"Field","name":{"kind":"Name","value":"achievementType"}},{"kind":"Field","name":{"kind":"Name","value":"achievementState"}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maxSteps"}},{"kind":"Field","name":{"kind":"Name","value":"currentStep"}},{"kind":"Field","name":{"kind":"Name","value":"isNewAchievement"}},{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"actionName"}},{"kind":"Field","name":{"kind":"Name","value":"actionRedirectLink"}}]}}]}}]}}]} as unknown as DocumentNode<AchievementsQuery, AchievementsQueryVariables>;
export const FurtherAchievementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"furtherAchievements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"furtherAchievements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"tagline"}},{"kind":"Field","name":{"kind":"Name","value":"subtitle"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"footer"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"alternativeText"}},{"kind":"Field","name":{"kind":"Name","value":"achievementType"}},{"kind":"Field","name":{"kind":"Name","value":"achievementState"}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maxSteps"}},{"kind":"Field","name":{"kind":"Name","value":"currentStep"}},{"kind":"Field","name":{"kind":"Name","value":"isNewAchievement"}},{"kind":"Field","name":{"kind":"Name","value":"actionType"}},{"kind":"Field","name":{"kind":"Name","value":"actionName"}},{"kind":"Field","name":{"kind":"Name","value":"actionRedirectLink"}}]}}]}}]}}]} as unknown as DocumentNode<FurtherAchievementsQuery, FurtherAchievementsQueryVariables>;
export const ReferralCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ReferralCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"referralCount"}}]}}]}}]} as unknown as DocumentNode<ReferralCountQuery, ReferralCountQueryVariables>;
export const SupportedHoursDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SupportedHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supportedHours"}}]}}]}}]} as unknown as DocumentNode<SupportedHoursQuery, SupportedHoursQueryVariables>;
export const RegisterPupilDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"registerPupil"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstname"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastname"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsletter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"grade"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"school"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RegistrationSchool"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referredById"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"emailOwner"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PupilEmailOwner"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meRegisterPupil"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"noEmail"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"firstname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstname"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lastname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastname"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"newsletter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsletter"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"registrationSource"},"value":{"kind":"EnumValue","value":"normal"}},{"kind":"ObjectField","name":{"kind":"Name","value":"school"},"value":{"kind":"Variable","name":{"kind":"Name","value":"school"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"referredById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referredById"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"emailOwner"},"value":{"kind":"Variable","name":{"kind":"Name","value":"emailOwner"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"meUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pupil"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gradeAsInt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"grade"}}}]}}]}}]}]}}]} as unknown as DocumentNode<RegisterPupilMutation, RegisterPupilMutationVariables>;
export const RegisterStudentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"registerStudent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstname"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastname"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newsletter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cooperationTag"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referredById"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meRegisterStudent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"noEmail"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"firstname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstname"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lastname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastname"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"newsletter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newsletter"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"registrationSource"},"value":{"kind":"EnumValue","value":"normal"}},{"kind":"ObjectField","name":{"kind":"Name","value":"cooperationTag"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cooperationTag"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"referredById"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referredById"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RegisterStudentMutation, RegisterStudentMutationVariables>;
export const CreateCredentialsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createCredentials"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retainPath"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"passwordCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}]},{"kind":"Field","name":{"kind":"Name","value":"tokenRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"action"},"value":{"kind":"StringValue","value":"user-verify-email","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"redirectTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retainPath"}}}]}]}}]} as unknown as DocumentNode<CreateCredentialsMutation, CreateCredentialsMutationVariables>;
export const CooperationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Cooperations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cooperations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"tag"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"welcomeTitle"}},{"kind":"Field","name":{"kind":"Name","value":"welcomeMessage"}}]}}]}}]} as unknown as DocumentNode<CooperationsQuery, CooperationsQueryVariables>;
export const RequestCertificateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestCertificate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matchId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"certificateData"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CertificateCreationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participationCertificateCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matchId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matchId"}}},{"kind":"Argument","name":{"kind":"Name","value":"certificateData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"certificateData"}}}]}]}}]} as unknown as DocumentNode<RequestCertificateMutation, RequestCertificateMutationVariables>;
export const ChangePasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"changePassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"passwordCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}]}]}}]} as unknown as DocumentNode<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const SessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"session"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"secrets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"lastUsed"}},{"kind":"Field","name":{"kind":"Name","value":"lastUsedDeviceId"}}]}}]}}]}}]} as unknown as DocumentNode<SessionQuery, SessionQueryVariables>;
export const RevokeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"revoke"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokenRevoke"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"invalidateSessions"},"value":{"kind":"BooleanValue","value":true}}]}]}}]} as unknown as DocumentNode<RevokeMutation, RevokeMutationVariables>;
export const SingleMatchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SingleMatch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matchId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"match"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matchId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matchId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"dissolved"}},{"kind":"Field","name":{"kind":"Name","value":"dissolvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentsCount"}},{"kind":"Field","name":{"kind":"Name","value":"lastAppointmentId"}},{"kind":"Field","name":{"kind":"Name","value":"firstAppointmentId"}},{"kind":"Field","name":{"kind":"Name","value":"pupil"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"schooltype"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"gradeAsInt"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"subjectsFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aboutMe"}}]}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"subjectsFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aboutMe"}}]}}]}}]}}]} as unknown as DocumentNode<SingleMatchQuery, SingleMatchQueryVariables>;
export const SingleMatchAppointments_No_CacheDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SingleMatchAppointments_NO_CACHE"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matchId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"direction"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"match"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matchId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matchId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"direction"},"value":{"kind":"Variable","name":{"kind":"Name","value":"direction"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"isOrganizer"}},{"kind":"Field","name":{"kind":"Name","value":"isParticipant"}},{"kind":"Field","name":{"kind":"Name","value":"override_meeting_link"}},{"kind":"Field","name":{"kind":"Name","value":"declinedBy"}},{"kind":"Field","name":{"kind":"Name","value":"organizers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SingleMatchAppointments_No_CacheQuery, SingleMatchAppointments_No_CacheQueryVariables>;
export const CreateMatcheeChatDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createMatcheeChat"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matcheeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matchChatCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matcheeUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matcheeId"}}}]}]}}]} as unknown as DocumentNode<CreateMatcheeChatMutation, CreateMatcheeChatMutationVariables>;
export const DissolveMatchStudent2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"dissolveMatchStudent2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"matchId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dissolveReasons"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"dissolve_reason"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"otherFreeText"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matchDissolve"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"info"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"matchId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"matchId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dissolveReasons"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dissolveReasons"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"otherDissolveReason"},"value":{"kind":"Variable","name":{"kind":"Name","value":"otherFreeText"}}}]}}]}]}}]} as unknown as DocumentNode<DissolveMatchStudent2Mutation, DissolveMatchStudent2MutationVariables>;
export const GetStudentLanguagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStudentLanguages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"languages"}}]}}]}}]}}]} as unknown as DocumentNode<GetStudentLanguagesQuery, GetStudentLanguagesQueryVariables>;
export const GetPupilLanguagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPupilLanguages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pupil"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"languages"}}]}}]}}]}}]} as unknown as DocumentNode<GetPupilLanguagesQuery, GetPupilLanguagesQueryVariables>;
export const UpdateLanguageStudentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateLanguageStudent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languages"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StudentLanguage"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"student"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languages"}}}]}}]}}]}]}}]} as unknown as DocumentNode<UpdateLanguageStudentMutation, UpdateLanguageStudentMutationVariables>;
export const UpdateLanguagePupilDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateLanguagePupil"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languages"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Language"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pupil"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"languages"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languages"}}}]}}]}}]}]}}]} as unknown as DocumentNode<UpdateLanguagePupilMutation, UpdateLanguagePupilMutationVariables>;
export const GetPupilSchoolDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPupilSchool"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pupil"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schooltype"}},{"kind":"Field","name":{"kind":"Name","value":"gradeAsInt"}}]}}]}}]}}]} as unknown as DocumentNode<GetPupilSchoolQuery, GetPupilSchoolQueryVariables>;
export const UpdateSchoolGradePupilDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateSchoolGradePupil"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"grade"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pupil"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gradeAsInt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"grade"}}}]}}]}}]}]}}]} as unknown as DocumentNode<UpdateSchoolGradePupilMutation, UpdateSchoolGradePupilMutationVariables>;
export const GetPupilSchooltypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPupilSchooltype"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pupil"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schooltype"}}]}}]}}]}}]} as unknown as DocumentNode<GetPupilSchooltypeQuery, GetPupilSchooltypeQueryVariables>;
export const UpdateSchooltypePupilDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateSchooltypePupil"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"schooltype"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SchoolType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pupil"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"schooltype"},"value":{"kind":"Variable","name":{"kind":"Name","value":"schooltype"}}}]}}]}}]}]}}]} as unknown as DocumentNode<UpdateSchooltypePupilMutation, UpdateSchooltypePupilMutationVariables>;
export const GetPupilStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPupilState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pupil"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]}}]} as unknown as DocumentNode<GetPupilStateQuery, GetPupilStateQueryVariables>;
export const GetStudentStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStudentState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]}}]} as unknown as DocumentNode<GetStudentStateQuery, GetStudentStateQueryVariables>;
export const UpdateStateStudentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateStateStudent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StudentState"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"student"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}}]}}]}}]}]}}]} as unknown as DocumentNode<UpdateStateStudentMutation, UpdateStateStudentMutationVariables>;
export const UpdateStatePupilDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateStatePupil"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"State"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pupil"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}}]}}]}}]}]}}]} as unknown as DocumentNode<UpdateStatePupilMutation, UpdateStatePupilMutationVariables>;
export const StudentCourseMatchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StudentCourseMatches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"dissolved"}},{"kind":"Field","name":{"kind":"Name","value":"pupil"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"schooltype"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"gradeAsInt"}},{"kind":"Field","name":{"kind":"Name","value":"subjectsFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subcoursesInstructing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"excludeCancelled"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"lectures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstLecture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<StudentCourseMatchesQuery, StudentCourseMatchesQueryVariables>;
export const TotalAppointmentsCreatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"totalAppointmentsCreated"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalLecturesOrganized"}}]}}]}}]}}]} as unknown as DocumentNode<TotalAppointmentsCreatedQuery, TotalAppointmentsCreatedQueryVariables>;
export const AppointmentsGroupCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"appointmentsGroupCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointments"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AppointmentCreateGroupInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentsGroupCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appointments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointments"}}},{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<AppointmentsGroupCreateMutation, AppointmentsGroupCreateMutationVariables>;
export const AppointmentsMatchCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"appointmentsMatchCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointments"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AppointmentCreateMatchInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentsMatchCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appointments"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointments"}}},{"kind":"Argument","name":{"kind":"Name","value":"matchId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<AppointmentsMatchCreateMutation, AppointmentsMatchCreateMutationVariables>;
export const SubcourseAppointmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"subcourseAppointments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcourse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"override_meeting_link"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"isPupil"}},{"kind":"Field","name":{"kind":"Name","value":"isStudent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SubcourseAppointmentsQuery, SubcourseAppointmentsQueryVariables>;
export const MatchAppointmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"matchAppointments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"match"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"matchId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pupil"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"matchId"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"override_meeting_link"}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"isPupil"}},{"kind":"Field","name":{"kind":"Name","value":"isStudent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MatchAppointmentsQuery, MatchAppointmentsQueryVariables>;
export const GetAppointmentByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAppointmentById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appointmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"matchId"}},{"kind":"Field","name":{"kind":"Name","value":"subcourseId"}}]}}]}}]} as unknown as DocumentNode<GetAppointmentByIdQuery, GetAppointmentByIdQueryVariables>;
export const UpdateAppointmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateAppointment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointmentToBeUpdated"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AppointmentUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appointmentToBeUpdated"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointmentToBeUpdated"}}}]}]}}]} as unknown as DocumentNode<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>;
export const MeEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MeEmail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<MeEmailQuery, MeEmailQueryVariables>;
export const UpdateHasDoneEthicsOnboardingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateHasDoneEthicsOnboarding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"studentUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hasDoneEthicsOnboarding"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]} as unknown as DocumentNode<UpdateHasDoneEthicsOnboardingMutation, UpdateHasDoneEthicsOnboardingMutationVariables>;
export const PupilDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PupilDashboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"pupil"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"matches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"dissolved"}},{"kind":"Field","name":{"kind":"Name","value":"subjectsFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstMatchRequest"}},{"kind":"Field","name":{"kind":"Name","value":"openMatchRequestCount"}},{"kind":"Field","name":{"kind":"Name","value":"canRequestMatch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowed"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"canJoinSubcourses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowed"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subcoursesJoined"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isParticipant"}},{"kind":"Field","name":{"kind":"Name","value":"minGrade"}},{"kind":"Field","name":{"kind":"Name","value":"maxGrade"}},{"kind":"Field","name":{"kind":"Name","value":"participantsCount"}},{"kind":"Field","name":{"kind":"Name","value":"maxParticipants"}},{"kind":"Field","name":{"kind":"Name","value":"lectures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"courseState"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"isOrganizer"}},{"kind":"Field","name":{"kind":"Name","value":"isParticipant"}},{"kind":"Field","name":{"kind":"Name","value":"organizers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"30"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"declinedBy"}},{"kind":"Field","name":{"kind":"Name","value":"zoomMeetingId"}},{"kind":"Field","name":{"kind":"Name","value":"subcourse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subcoursesPublic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"excludeKnown"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"onlyJoinable"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"minGrade"}},{"kind":"Field","name":{"kind":"Name","value":"maxGrade"}},{"kind":"Field","name":{"kind":"Name","value":"joinAfterStart"}},{"kind":"Field","name":{"kind":"Name","value":"maxParticipants"}},{"kind":"Field","name":{"kind":"Name","value":"participantsCount"}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lectures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstLecture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextLecture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"myRoles"}}]}}]} as unknown as DocumentNode<PupilDashboardQuery, PupilDashboardQueryVariables>;
export const CancelMatchRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"cancelMatchRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pupilDeleteMatchRequest"}}]}}]} as unknown as DocumentNode<CancelMatchRequestMutation, CancelMatchRequestMutationVariables>;
export const PupilSubcourseOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PupilSubcourseOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pupil"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canJoinSubcourses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowed"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subcoursesJoined"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"excludePast"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"minGrade"}},{"kind":"Field","name":{"kind":"Name","value":"maxGrade"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"isParticipant"}},{"kind":"Field","name":{"kind":"Name","value":"isOnWaitingList"}},{"kind":"Field","name":{"kind":"Name","value":"maxParticipants"}},{"kind":"Field","name":{"kind":"Name","value":"participantsCount"}},{"kind":"Field","name":{"kind":"Name","value":"firstLecture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextLecture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lectures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"courseState"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subcoursesWaitingList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"minGrade"}},{"kind":"Field","name":{"kind":"Name","value":"maxGrade"}},{"kind":"Field","name":{"kind":"Name","value":"isParticipant"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"isOnWaitingList"}},{"kind":"Field","name":{"kind":"Name","value":"maxParticipants"}},{"kind":"Field","name":{"kind":"Name","value":"participantsCount"}},{"kind":"Field","name":{"kind":"Name","value":"firstLecture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextLecture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lectures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"courseState"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PupilSubcourseOverviewQuery, PupilSubcourseOverviewQueryVariables>;
export const PupilPastSubcoursesOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PupilPastSubcoursesOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pupil"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canJoinSubcourses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowed"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subcoursesJoined"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"onlyPast"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"isOnWaitingList"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isParticipant"}},{"kind":"Field","name":{"kind":"Name","value":"maxParticipants"}},{"kind":"Field","name":{"kind":"Name","value":"participantsCount"}},{"kind":"Field","name":{"kind":"Name","value":"minGrade"}},{"kind":"Field","name":{"kind":"Name","value":"maxGrade"}},{"kind":"Field","name":{"kind":"Name","value":"firstLecture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextLecture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lectures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"courseState"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PupilPastSubcoursesOverviewQuery, PupilPastSubcoursesOverviewQueryVariables>;
export const GetAllSubcoursesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllSubcourses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcoursesPublic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"50"}},{"kind":"Argument","name":{"kind":"Name","value":"excludeKnown"},"value":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"isParticipant"}},{"kind":"Field","name":{"kind":"Name","value":"minGrade"}},{"kind":"Field","name":{"kind":"Name","value":"maxGrade"}},{"kind":"Field","name":{"kind":"Name","value":"maxParticipants"}},{"kind":"Field","name":{"kind":"Name","value":"participantsCount"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isOnWaitingList"}},{"kind":"Field","name":{"kind":"Name","value":"firstLecture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextLecture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lectures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"courseState"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllSubcoursesQuery, GetAllSubcoursesQueryVariables>;
export const PupilMatchingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PupilMatching"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pupil"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subjectsFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mandatory"}}]}},{"kind":"Field","name":{"kind":"Name","value":"openMatchRequestCount"}},{"kind":"Field","name":{"kind":"Name","value":"matches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"dissolved"}},{"kind":"Field","name":{"kind":"Name","value":"subjectsFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pupil"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schooltype"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}}]}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"canRequestMatch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowed"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PupilMatchingQuery, PupilMatchingQueryVariables>;
export const PupilDeleteMatchRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PupilDeleteMatchRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pupilDeleteMatchRequest"}}]}}]} as unknown as DocumentNode<PupilDeleteMatchRequestMutation, PupilDeleteMatchRequestMutationVariables>;
export const PupilProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PupilProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"pupil"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aboutMe"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"schooltype"}},{"kind":"Field","name":{"kind":"Name","value":"languages"}},{"kind":"Field","name":{"kind":"Name","value":"subjectsFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"gradeAsInt"}}]}}]}}]}}]} as unknown as DocumentNode<PupilProfileQuery, PupilProfileQueryVariables>;
export const ChangePupilNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"changePupilName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firstname"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lastname"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"firstname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firstname"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lastname"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lastname"}}}]}}]}]}}]} as unknown as DocumentNode<ChangePupilNameMutation, ChangePupilNameMutationVariables>;
export const ChangeAboutMePupilDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"changeAboutMePupil"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aboutMe"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pupil"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"aboutMe"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aboutMe"}}}]}}]}}]}]}}]} as unknown as DocumentNode<ChangeAboutMePupilMutation, ChangeAboutMePupilMutationVariables>;
export const GetOtherParticipantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOtherParticipants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcourse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"otherParticipants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"gradeAsInt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pupil"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"schooltype"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"gradeAsInt"}}]}}]}}]}}]} as unknown as DocumentNode<GetOtherParticipantsQuery, GetOtherParticipantsQueryVariables>;
export const GetSingleSubcoursePupilDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSingleSubcoursePupil"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcourse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participantsCount"}},{"kind":"Field","name":{"kind":"Name","value":"maxParticipants"}},{"kind":"Field","name":{"kind":"Name","value":"minGrade"}},{"kind":"Field","name":{"kind":"Name","value":"maxGrade"}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}},{"kind":"Field","name":{"kind":"Name","value":"groupChatType"}},{"kind":"Field","name":{"kind":"Name","value":"allowChatContactProspects"}},{"kind":"Field","name":{"kind":"Name","value":"allowChatContactParticipants"}},{"kind":"Field","name":{"kind":"Name","value":"nextLecture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"instructors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"courseState"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowContact"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lectures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"canJoin"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowed"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"canContactInstructor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowed"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"canJoinWaitinglist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowed"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isParticipant"}},{"kind":"Field","name":{"kind":"Name","value":"isOnWaitingList"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"isOrganizer"}},{"kind":"Field","name":{"kind":"Name","value":"isParticipant"}},{"kind":"Field","name":{"kind":"Name","value":"subcourse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"published"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSingleSubcoursePupilQuery, GetSingleSubcoursePupilQueryVariables>;
export const PupilMatchRequestInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PupilMatchRequestInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pupil"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schooltype"}},{"kind":"Field","name":{"kind":"Name","value":"gradeAsInt"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"openMatchRequestCount"}},{"kind":"Field","name":{"kind":"Name","value":"subjectsFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mandatory"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PupilMatchRequestInfoQuery, PupilMatchRequestInfoQueryVariables>;
export const UpdatePupilDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updatePupil"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subjects"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubjectInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pupil"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"subjects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subjects"}}}]}}]}}]}]}}]} as unknown as DocumentNode<UpdatePupilMutation, UpdatePupilMutationVariables>;
export const PupilCreateMatchRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PupilCreateMatchRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pupilCreateMatchRequest"}}]}}]} as unknown as DocumentNode<PupilCreateMatchRequestMutation, PupilCreateMatchRequestMutationVariables>;
export const ChangeSchooltypeDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"changeSchooltypeData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SchoolType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pupil"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"schooltype"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}}]}}]}]}}]} as unknown as DocumentNode<ChangeSchooltypeDataMutation, ChangeSchooltypeDataMutationVariables>;
export const ChangeSchoolClassDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"changeSchoolClassData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pupil"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gradeAsInt"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}}]}}]}]}}]} as unknown as DocumentNode<ChangeSchoolClassDataMutation, ChangeSchoolClassDataMutationVariables>;
export const ChangePupilStateDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"changePupilStateData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"State"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"pupil"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}}]}}]}]}}]} as unknown as DocumentNode<ChangePupilStateDataMutation, ChangePupilStateDataMutationVariables>;
export const GetCourseConversationIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCourseConversationId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isParticipant"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcourse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationId"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isParticipant"}}}]}]}]}}]}}]} as unknown as DocumentNode<GetCourseConversationIdQuery, GetCourseConversationIdQueryVariables>;
export const TotalSubcoursesJoinedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"totalSubcoursesJoined"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pupil"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalSubcoursesJoined"}}]}}]}}]}}]} as unknown as DocumentNode<TotalSubcoursesJoinedQuery, TotalSubcoursesJoinedQueryVariables>;
export const SubcourseJoinDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubcourseJoin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcourseJoin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}}}]}]}}]} as unknown as DocumentNode<SubcourseJoinMutation, SubcourseJoinMutationVariables>;
export const LeaveSubcourseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LeaveSubcourse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcourseLeave"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}}}]}]}}]} as unknown as DocumentNode<LeaveSubcourseMutation, LeaveSubcourseMutationVariables>;
export const JoinWaitingListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JoinWaitingList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcourseJoinWaitinglist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}}}]}]}}]} as unknown as DocumentNode<JoinWaitingListMutation, JoinWaitingListMutationVariables>;
export const LeaveWaitingListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LeaveWaitingList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcourseLeaveWaitinglist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}}}]}]}}]} as unknown as DocumentNode<LeaveWaitingListMutation, LeaveWaitingListMutationVariables>;
export const CreateInstructorChatDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createInstructorChat"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participantChatCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}}},{"kind":"Argument","name":{"kind":"Name","value":"memberUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberUserId"}}}]}]}}]} as unknown as DocumentNode<CreateInstructorChatMutation, CreateInstructorChatMutationVariables>;
export const CreateProspectChatDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createProspectChat"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"instructorUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prospectChatCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}}},{"kind":"Argument","name":{"kind":"Name","value":"instructorUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"instructorUserId"}}}]}]}}]} as unknown as DocumentNode<CreateProspectChatMutation, CreateProspectChatMutationVariables>;
export const ScreenerSearchUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ScreenerSearchUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"usersSearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pupil"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"languages"}},{"kind":"Field","name":{"kind":"Name","value":"subjectsFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mandatory"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"gradeAsInt"}},{"kind":"Field","name":{"kind":"Name","value":"openMatchRequestCount"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"schooltype"}},{"kind":"Field","name":{"kind":"Name","value":"onlyMatchWith"}},{"kind":"Field","name":{"kind":"Name","value":"hasSpecialNeeds"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionForScreening"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionForMatch"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dissolved"}},{"kind":"Field","name":{"kind":"Name","value":"dissolvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"dissolveReasons"}},{"kind":"Field","name":{"kind":"Name","value":"dissolvedBy"}},{"kind":"Field","name":{"kind":"Name","value":"pupilFirstMatchRequest"}},{"kind":"Field","name":{"kind":"Name","value":"subjectsFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"screenings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invalidated"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"knowsCoronaSchoolFrom"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"screeners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"receivedScreeningSuggestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"languages"}},{"kind":"Field","name":{"kind":"Name","value":"subjectsFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"grade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"certificateOfConductDeactivationDate"}},{"kind":"Field","name":{"kind":"Name","value":"certificateOfConduct"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"hasSpecialExperience"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionForMatch"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionForScreening"}},{"kind":"Field","name":{"kind":"Name","value":"matches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"pupil"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dissolved"}},{"kind":"Field","name":{"kind":"Name","value":"dissolvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"dissolveReasons"}},{"kind":"Field","name":{"kind":"Name","value":"dissolvedBy"}},{"kind":"Field","name":{"kind":"Name","value":"studentFirstMatchRequest"}},{"kind":"Field","name":{"kind":"Name","value":"subjectsFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subcoursesInstructing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"courseState"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextLecture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tutorScreenings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"screener"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"instructorScreenings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"screener"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"receivedScreeningSuggestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ScreenerSearchUsersQuery, ScreenerSearchUsersQueryVariables>;
export const GetDisputedScreeningsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDisputedScreenings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pupilsToBeScreened"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"onlyDisputed"},"value":{"kind":"BooleanValue","value":true}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"languages"}},{"kind":"Field","name":{"kind":"Name","value":"subjectsFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"gradeAsInt"}},{"kind":"Field","name":{"kind":"Name","value":"openMatchRequestCount"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"schooltype"}},{"kind":"Field","name":{"kind":"Name","value":"onlyMatchWith"}},{"kind":"Field","name":{"kind":"Name","value":"hasSpecialNeeds"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionForScreening"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionForMatch"}},{"kind":"Field","name":{"kind":"Name","value":"school"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dissolved"}},{"kind":"Field","name":{"kind":"Name","value":"dissolvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"dissolveReasons"}},{"kind":"Field","name":{"kind":"Name","value":"dissolvedBy"}},{"kind":"Field","name":{"kind":"Name","value":"pupilFirstMatchRequest"}},{"kind":"Field","name":{"kind":"Name","value":"subjectsFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"screenings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invalidated"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"knowsCoronaSchoolFrom"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"screeners"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"receivedScreeningSuggestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"notification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDisputedScreeningsQuery, GetDisputedScreeningsQueryVariables>;
export const SubcoursesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Subcourses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"courseState"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcourseSearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"100"}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"courseStates"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"courseState"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"StringValue","value":"last-update","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"courseState"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"minGrade"}},{"kind":"Field","name":{"kind":"Name","value":"maxGrade"}},{"kind":"Field","name":{"kind":"Name","value":"maxParticipants"}},{"kind":"Field","name":{"kind":"Name","value":"participantsCount"}},{"kind":"Field","name":{"kind":"Name","value":"firstLecture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}}]}},{"kind":"Field","name":{"kind":"Name","value":"instructors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}}]}}]}}]} as unknown as DocumentNode<SubcoursesQuery, SubcoursesQueryVariables>;
export const SubcourseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"subcourse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcourse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participantsCount"}},{"kind":"Field","name":{"kind":"Name","value":"maxParticipants"}},{"kind":"Field","name":{"kind":"Name","value":"minGrade"}},{"kind":"Field","name":{"kind":"Name","value":"maxGrade"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"nextLecture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"instructors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"courseState"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"shared"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lectures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"organizers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subcourse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"published"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SubcourseQuery, SubcourseQueryVariables>;
export const AllowCourseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"allowCourse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"courseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"courseAllow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"courseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"courseId"}}}]}]}}]} as unknown as DocumentNode<AllowCourseMutation, AllowCourseMutationVariables>;
export const DenyCourseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"denyCourse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"courseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"courseDeny"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"courseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"courseId"}}}]}]}}]} as unknown as DocumentNode<DenyCourseMutation, DenyCourseMutationVariables>;
export const ShareCourseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"shareCourse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"courseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"share"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"courseMarkShared"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"shared"},"value":{"kind":"Variable","name":{"kind":"Name","value":"share"}}},{"kind":"Argument","name":{"kind":"Name","value":"courseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"courseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shared"}}]}}]}}]} as unknown as DocumentNode<ShareCourseMutation, ShareCourseMutationVariables>;
export const AdminAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AdminAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokenCreateAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}]}}]} as unknown as DocumentNode<AdminAccessMutation, AdminAccessMutationVariables>;
export const PupilRequestMatchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PupilRequestMatch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pupilId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pupilCreateMatchRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pupilId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pupilId"}}}]}]}}]} as unknown as DocumentNode<PupilRequestMatchMutation, PupilRequestMatchMutationVariables>;
export const PupilRevokeMatchRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PupilRevokeMatchRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pupilId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pupilDeleteMatchRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pupilId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pupilId"}}}]}]}}]} as unknown as DocumentNode<PupilRevokeMatchRequestMutation, PupilRevokeMatchRequestMutationVariables>;
export const ScreenerDeactivatePupilDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ScreenerDeactivatePupil"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pupilId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pupilDeactivate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pupilId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pupilId"}}}]}]}}]} as unknown as DocumentNode<ScreenerDeactivatePupilMutation, ScreenerDeactivatePupilMutationVariables>;
export const CreateScreeningDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateScreening"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pupilId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pupilCreateScreening"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pupilId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pupilId"}}},{"kind":"Argument","name":{"kind":"Name","value":"silent"},"value":{"kind":"BooleanValue","value":true}}]}]}}]} as unknown as DocumentNode<CreateScreeningMutation, CreateScreeningMutationVariables>;
export const UpdatePupilScreeningDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePupilScreening"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"screeningComment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PupilScreeningStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"knowsFrom"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pupilUpdateScreening"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pupilScreeningId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"screeningComment"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"knowsCoronaSchoolFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"knowsFrom"}}}]}}]}]}}]} as unknown as DocumentNode<UpdatePupilScreeningMutation, UpdatePupilScreeningMutationVariables>;
export const MissedScreeningDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MissedScreening"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pupilScreeningId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pupilMissedScreening"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pupilScreeningId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pupilScreeningId"}}},{"kind":"Argument","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}}]}]}}]} as unknown as DocumentNode<MissedScreeningMutation, MissedScreeningMutationVariables>;
export const ScreenerUpdatePupilDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ScreenerUpdatePupil"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pupilId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PupilUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pupilUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pupilId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pupilId"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<ScreenerUpdatePupilMutation, ScreenerUpdatePupilMutationVariables>;
export const ScreenerUpdateStudentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ScreenerUpdateStudent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StudentUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"studentUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"studentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}]}}]} as unknown as DocumentNode<ScreenerUpdateStudentMutation, ScreenerUpdateStudentMutationVariables>;
export const ScreenAsInstructorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ScreenAsInstructor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"success"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StudentScreeningStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"knowsFrom"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobStatus"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"screening_jobstatus_enum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"studentInstructorScreeningCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"studentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"screening"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"success"},"value":{"kind":"Variable","name":{"kind":"Name","value":"success"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobStatus"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"knowsCoronaSchoolFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"knowsFrom"}}}]}}]}]}}]} as unknown as DocumentNode<ScreenAsInstructorMutation, ScreenAsInstructorMutationVariables>;
export const ScreenAsTutorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ScreenAsTutor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"success"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StudentScreeningStatus"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"knowsFrom"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"jobStatus"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"screening_jobstatus_enum"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"studentTutorScreeningCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"studentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"screening"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"success"},"value":{"kind":"Variable","name":{"kind":"Name","value":"success"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"jobStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"jobStatus"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"knowsCoronaSchoolFrom"},"value":{"kind":"Variable","name":{"kind":"Name","value":"knowsFrom"}}}]}}]}]}}]} as unknown as DocumentNode<ScreenAsTutorMutation, ScreenAsTutorMutationVariables>;
export const RequireStudentOnboardingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"requireStudentOnboarding"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"studentRequireOnboarding"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"studentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"studentId"}}}]}]}}]} as unknown as DocumentNode<RequireStudentOnboardingMutation, RequireStudentOnboardingMutationVariables>;
export const UpdateTutorScreeningDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTutorScreening"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"screeningId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"studentTutorScreeningUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"screeningId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"screeningId"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}}]}}]}]}}]} as unknown as DocumentNode<UpdateTutorScreeningMutation, UpdateTutorScreeningMutationVariables>;
export const UpdateInstructorScreeningDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateInstructorScreening"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"screeningId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"studentInstructorScreeningUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"screeningId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"screeningId"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}}]}}]}]}}]} as unknown as DocumentNode<UpdateInstructorScreeningMutation, UpdateInstructorScreeningMutationVariables>;
export const CertificatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Certificates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participationCertificates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"categories"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"hoursPerWeek"}},{"kind":"Field","name":{"kind":"Name","value":"hoursTotal"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}},{"kind":"Field","name":{"kind":"Name","value":"ongoingLessons"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"pupil"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CertificatesQuery, CertificatesQueryVariables>;
export const RequestInstantCertificateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestInstantCertificate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"instantCertificateCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lang"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}}]}]}}]} as unknown as DocumentNode<RequestInstantCertificateMutation, RequestInstantCertificateMutationVariables>;
export const StudentDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StudentDashboard"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstMatchRequest"}},{"kind":"Field","name":{"kind":"Name","value":"openMatchRequestCount"}},{"kind":"Field","name":{"kind":"Name","value":"canRequestMatch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowed"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"canCreateCourse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowed"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subcoursesInstructing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"minGrade"}},{"kind":"Field","name":{"kind":"Name","value":"maxGrade"}},{"kind":"Field","name":{"kind":"Name","value":"participantsCount"}},{"kind":"Field","name":{"kind":"Name","value":"maxParticipants"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"lectures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextLecture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}}]}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"courseState"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"isOrganizer"}},{"kind":"Field","name":{"kind":"Name","value":"isParticipant"}},{"kind":"Field","name":{"kind":"Name","value":"organizers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"30"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"declinedBy"}},{"kind":"Field","name":{"kind":"Name","value":"zoomMeetingId"}},{"kind":"Field","name":{"kind":"Name","value":"subcourse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subcoursesPublic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"10"}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"2"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participantsCount"}},{"kind":"Field","name":{"kind":"Name","value":"maxParticipants"}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"}}]}}]}}]}}]} as unknown as DocumentNode<StudentDashboardQuery, StudentDashboardQueryVariables>;
export const MatchingStudentOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MatchingStudentOverview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"subjectsFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"dissolved"}},{"kind":"Field","name":{"kind":"Name","value":"subjectsFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pupil"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"schooltype"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"gradeAsInt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"canRequestMatch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowed"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"limit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"openMatchRequestCount"}}]}}]}}]}}]} as unknown as DocumentNode<MatchingStudentOverviewQuery, MatchingStudentOverviewQueryVariables>;
export const StudentDeleteMatchRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StudentDeleteMatchRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"studentDeleteMatchRequest"}}]}}]} as unknown as DocumentNode<StudentDeleteMatchRequestMutation, StudentDeleteMatchRequestMutationVariables>;
export const StudentProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StudentProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"aboutMe"}},{"kind":"Field","name":{"kind":"Name","value":"languages"}},{"kind":"Field","name":{"kind":"Name","value":"subjectsFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participationCertificates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"subjectsFormatted"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"hoursTotal"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}},{"kind":"Field","name":{"kind":"Name","value":"categories"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"hoursPerWeek"}},{"kind":"Field","name":{"kind":"Name","value":"ongoingLessons"}},{"kind":"Field","name":{"kind":"Name","value":"pupil"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<StudentProfileQuery, StudentProfileQueryVariables>;
export const ChangeAboutMeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"changeAboutMe"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aboutMe"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"student"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"aboutMe"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aboutMe"}}}]}}]}}]}]}}]} as unknown as DocumentNode<ChangeAboutMeMutation, ChangeAboutMeMutationVariables>;
export const GetBasicSubcourseStudentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBasicSubcourseStudent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcourse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"allowChatContactProspects"}},{"kind":"Field","name":{"kind":"Name","value":"allowChatContactParticipants"}},{"kind":"Field","name":{"kind":"Name","value":"groupChatType"}},{"kind":"Field","name":{"kind":"Name","value":"participantsCount"}},{"kind":"Field","name":{"kind":"Name","value":"maxParticipants"}},{"kind":"Field","name":{"kind":"Name","value":"minGrade"}},{"kind":"Field","name":{"kind":"Name","value":"maxGrade"}},{"kind":"Field","name":{"kind":"Name","value":"capacity"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"publishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"isInstructor"}},{"kind":"Field","name":{"kind":"Name","value":"isMentor"}},{"kind":"Field","name":{"kind":"Name","value":"nextLecture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"instructors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"courseState"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"subject"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"allowContact"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lectures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"isOrganizer"}},{"kind":"Field","name":{"kind":"Name","value":"isParticipant"}},{"kind":"Field","name":{"kind":"Name","value":"organizers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subcourse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"published"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBasicSubcourseStudentQuery, GetBasicSubcourseStudentQueryVariables>;
export const GetInstructorSubcourseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInstructorSubcourse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcourse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"wasPromotedByInstructor"}},{"kind":"Field","name":{"kind":"Name","value":"canPromote"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pupilsWaitingCount"}},{"kind":"Field","name":{"kind":"Name","value":"pupilsOnWaitinglist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"schooltype"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"gradeAsInt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowed"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"canContactParticipants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowed"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"canCancel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowed"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"appointments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"appointmentType"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"isOrganizer"}},{"kind":"Field","name":{"kind":"Name","value":"isParticipant"}},{"kind":"Field","name":{"kind":"Name","value":"organizers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participantIds"}},{"kind":"Field","name":{"kind":"Name","value":"declinedBy"}},{"kind":"Field","name":{"kind":"Name","value":"subcourse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"published"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"IntValue","value":"0"}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"isPupil"}},{"kind":"Field","name":{"kind":"Name","value":"isStudent"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"prospectParticipants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"schooltype"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"gradeAsInt"}},{"kind":"Field","name":{"kind":"Name","value":"conversationId"}}]}}]}}]}}]} as unknown as DocumentNode<GetInstructorSubcourseQuery, GetInstructorSubcourseQueryVariables>;
export const JoinAsMentorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JoinAsMentor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcourseJoinAsMentor"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}}}]}]}}]} as unknown as DocumentNode<JoinAsMentorMutation, JoinAsMentorMutationVariables>;
export const MentorLeaveSubcourseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MentorLeaveSubcourse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcourseMentorLeave"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}}}]}]}}]} as unknown as DocumentNode<MentorLeaveSubcourseMutation, MentorLeaveSubcourseMutationVariables>;
export const SubcoursePublishDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubcoursePublish"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcoursePublish"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}}}]}]}}]} as unknown as DocumentNode<SubcoursePublishMutation, SubcoursePublishMutationVariables>;
export const CourseSubmitDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CourseSubmit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"courseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"courseSubmit"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"courseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"courseId"}}}]}]}}]} as unknown as DocumentNode<CourseSubmitMutation, CourseSubmitMutationVariables>;
export const ContactCourseParticipantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"contactCourseParticipant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participantChatCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberUserId"}}},{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}}}]}]}}]} as unknown as DocumentNode<ContactCourseParticipantMutation, ContactCourseParticipantMutationVariables>;
export const StudentCourseOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StudentCourseOverview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canCreateCourse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowed"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subcoursesMentoring"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"participantsCount"}},{"kind":"Field","name":{"kind":"Name","value":"maxParticipants"}},{"kind":"Field","name":{"kind":"Name","value":"minGrade"}},{"kind":"Field","name":{"kind":"Name","value":"maxGrade"}},{"kind":"Field","name":{"kind":"Name","value":"firstLecture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextLecture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lectures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"courseState"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subcoursesInstructing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"participantsCount"}},{"kind":"Field","name":{"kind":"Name","value":"maxParticipants"}},{"kind":"Field","name":{"kind":"Name","value":"minGrade"}},{"kind":"Field","name":{"kind":"Name","value":"maxGrade"}},{"kind":"Field","name":{"kind":"Name","value":"firstLecture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextLecture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lectures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"courseState"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"subcoursesPublic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"published"}},{"kind":"Field","name":{"kind":"Name","value":"cancelled"}},{"kind":"Field","name":{"kind":"Name","value":"minGrade"}},{"kind":"Field","name":{"kind":"Name","value":"maxGrade"}},{"kind":"Field","name":{"kind":"Name","value":"participantsCount"}},{"kind":"Field","name":{"kind":"Name","value":"maxParticipants"}},{"kind":"Field","name":{"kind":"Name","value":"isInstructor"}},{"kind":"Field","name":{"kind":"Name","value":"firstLecture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextLecture"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lectures"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}}]}},{"kind":"Field","name":{"kind":"Name","value":"course"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"courseState"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"image"}},{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<StudentCourseOverviewQuery, StudentCourseOverviewQueryVariables>;
export const StudentMatchRequestCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StudentMatchRequestCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"openMatchRequestCount"}},{"kind":"Field","name":{"kind":"Name","value":"subjectsFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"grade"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<StudentMatchRequestCountQuery, StudentMatchRequestCountQueryVariables>;
export const UpdateStudentSubjectsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateStudentSubjects"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subjects"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubjectInput"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"student"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"subjects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subjects"}}}]}}]}}]}]}}]} as unknown as DocumentNode<UpdateStudentSubjectsMutation, UpdateStudentSubjectsMutationVariables>;
export const StudentCreateMatchRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StudentCreateMatchRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"studentCreateMatchRequest"}}]}}]} as unknown as DocumentNode<StudentCreateMatchRequestMutation, StudentCreateMatchRequestMutationVariables>;
export const ChangeStudentStateDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"changeStudentStateData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StudentState"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"update"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"student"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}]}}]}}]}]}}]} as unknown as DocumentNode<ChangeStudentStateDataMutation, ChangeStudentStateDataMutationVariables>;
export const StudentGroupContactSupportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StudentGroupContactSupport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subject"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userContactSupport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"subject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subject"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}}]}}]}]}}]} as unknown as DocumentNode<StudentGroupContactSupportMutation, StudentGroupContactSupportMutationVariables>;
export const BecomeInstructorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"becomeInstructor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meBecomeInstructor"}}]}}]} as unknown as DocumentNode<BecomeInstructorMutation, BecomeInstructorMutationVariables>;
export const StudentMatchContactSupportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StudentMatchContactSupport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subject"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userContactSupport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"subject"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subject"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}}]}}]}]}}]} as unknown as DocumentNode<StudentMatchContactSupportMutation, StudentMatchContactSupportMutationVariables>;
export const BecomeTutorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"becomeTutor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meBecomeTutor"}}]}}]} as unknown as DocumentNode<BecomeTutorMutation, BecomeTutorMutationVariables>;
export const SubcourseParticipantsForContactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SubcourseParticipantsForContact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcourse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}}]}}]}}]} as unknown as DocumentNode<SubcourseParticipantsForContactQuery, SubcourseParticipantsForContactQueryVariables>;
export const SendMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subject"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"participants"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileIDs"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcourseNotifyParticipants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}}},{"kind":"Argument","name":{"kind":"Name","value":"title"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subject"}}},{"kind":"Argument","name":{"kind":"Name","value":"body"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}},{"kind":"Argument","name":{"kind":"Name","value":"participantIDs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"participants"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileIDs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileIDs"}}}]}]}}]} as unknown as DocumentNode<SendMessageMutation, SendMessageMutationVariables>;
export const CreateNewGroupChatDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createNewGroupChat"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupChatType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcourseGroupChatCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupChatType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupChatType"}}}]}]}}]} as unknown as DocumentNode<CreateNewGroupChatMutation, CreateNewGroupChatMutationVariables>;
export const GetParticipantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetParticipants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcourse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"schooltype"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"gradeAsInt"}}]}}]}}]}}]} as unknown as DocumentNode<GetParticipantsQuery, GetParticipantsQueryVariables>;
export const MarkAchievementAsSeenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"markAchievementAsSeen"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markAchievementAsSeen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"achievementId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<MarkAchievementAsSeenMutation, MarkAchievementAsSeenMutationVariables>;
export const MeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myContactOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userID"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactReasons"}},{"kind":"Field","name":{"kind":"Name","value":"chatId"}}]}}]}}]} as unknown as DocumentNode<MeQuery, MeQueryVariables>;
export const CreateContactChatDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createContactChat"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactUserId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactChatCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"contactUserId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactUserId"}}}]}]}}]} as unknown as DocumentNode<CreateContactChatMutation, CreateContactChatMutationVariables>;
export const GetOnboardingInfosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOnboardingInfos"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"important_informations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"navigateTo"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"recipients"}}]}},{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}},{"kind":"Field","name":{"kind":"Name","value":"secrets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"matches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dissolved"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"pupil"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstMatchRequest"}},{"kind":"Field","name":{"kind":"Name","value":"openMatchRequestCount"}},{"kind":"Field","name":{"kind":"Name","value":"certificateOfConductDeactivationDate"}},{"kind":"Field","name":{"kind":"Name","value":"canRequestMatch"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowed"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"canCreateCourse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowed"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subcoursesInstructing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pupil"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAt"}},{"kind":"Field","name":{"kind":"Name","value":"grade"}},{"kind":"Field","name":{"kind":"Name","value":"subjectsFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"subcoursesJoined"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dissolved"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"subjectsFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstMatchRequest"}},{"kind":"Field","name":{"kind":"Name","value":"openMatchRequestCount"}},{"kind":"Field","name":{"kind":"Name","value":"tutoringInterestConfirmation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"participationCertificatesToSign"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"ongoingLessons"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"categories"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"hoursPerWeek"}},{"kind":"Field","name":{"kind":"Name","value":"hoursTotal"}},{"kind":"Field","name":{"kind":"Name","value":"medium"}},{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"screenings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invalidated"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"myRoles"}}]}}]} as unknown as DocumentNode<GetOnboardingInfosQuery, GetOnboardingInfosQueryVariables>;
export const SendVerificationMailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendVerificationMail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tokenRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"action"},"value":{"kind":"StringValue","value":"user-verify-email","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"redirectTo"},"value":{"kind":"StringValue","value":"/dashboard","block":false}}]}]}}]} as unknown as DocumentNode<SendVerificationMailMutation, SendVerificationMailMutationVariables>;
export const ConfirmDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Confirm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tutoringInterestConfirm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}]}]}}]} as unknown as DocumentNode<ConfirmMutation, ConfirmMutationVariables>;
export const RefuseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Refuse"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tutoringInterestRefuse"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}]}]}}]} as unknown as DocumentNode<RefuseMutation, RefuseMutationVariables>;
export const DeleteMatchRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteMatchRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pupilDeleteMatchRequest"}}]}}]} as unknown as DocumentNode<DeleteMatchRequestMutation, DeleteMatchRequestMutationVariables>;
export const AppointmentOrganizerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"appointmentOrganizer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appointmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isOrganizer"}},{"kind":"Field","name":{"kind":"Name","value":"zoomMeetingId"}}]}}]}}]} as unknown as DocumentNode<AppointmentOrganizerQuery, AppointmentOrganizerQueryVariables>;
export const AppointmentSaveMeetingReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"appointmentSaveMeetingReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentSaveMeetingReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"appointmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointmentId"}}}]}]}}]} as unknown as DocumentNode<AppointmentSaveMeetingReportMutation, AppointmentSaveMeetingReportMutationVariables>;
export const SubcoursePromoteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"subcoursePromote"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subcoursePromote"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"subcourseId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"subcourseId"}}}]}]}}]} as unknown as DocumentNode<SubcoursePromoteMutation, SubcoursePromoteMutationVariables>;
export const SignCertificateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SignCertificate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"certificateId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"location"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signatureParent"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"signaturePupil"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participationCertificateSign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"certificateId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"certificateId"}}},{"kind":"Argument","name":{"kind":"Name","value":"signatureLocation"},"value":{"kind":"Variable","name":{"kind":"Name","value":"location"}}},{"kind":"Argument","name":{"kind":"Name","value":"signatureParent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signatureParent"}}},{"kind":"Argument","name":{"kind":"Name","value":"signaturePupil"},"value":{"kind":"Variable","name":{"kind":"Name","value":"signaturePupil"}}}]}]}}]} as unknown as DocumentNode<SignCertificateMutation, SignCertificateMutationVariables>;
export const GetCertificateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GetCertificate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lang"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participationCertificateAsPDF"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"language"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lang"}}},{"kind":"Argument","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}}]}]}}]} as unknown as DocumentNode<GetCertificateMutation, GetCertificateMutationVariables>;
export const GetPupilsForCertificateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPupilsForCertificate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"student"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"subjectsFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"matches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"subjectsFormatted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pupil"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"lastname"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPupilsForCertificateQuery, GetPupilsForCertificateQueryVariables>;
export const SendSuggestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendSuggestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"suggestion"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"screenerSuggest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userID"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userID"}}},{"kind":"Argument","name":{"kind":"Name","value":"suggestionNotificationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"suggestion"}}}]}]}}]} as unknown as DocumentNode<SendSuggestionMutation, SendSuggestionMutationVariables>;
export const GetPossibleSuggestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPossibleSuggestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"onActions"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"has"},"value":{"kind":"StringValue","value":"screening_suggestion","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"active"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<GetPossibleSuggestionsQuery, GetPossibleSuggestionsQueryVariables>;